import acedolfr from "../../../Statics/assets/by-trade-name/Acedol-Tabletfr.jpg";
import acedolbk from "../../../Statics/assets/by-trade-name/ban-Acedol-Tabletbk.jpg";

import acedolsrfr from "../../../Statics/assets/by-trade-name/Acedol-SR-eng.jpg";
import acedolsrbk from "../../../Statics/assets/by-trade-name/Acedol-SR-ban.jpg";

import acubis25fr from "../../../Statics/assets/by-trade-name/Acubis-2.5-eng.jpg";
import acubis25bk from "../../../Statics/assets/by-trade-name/Acubis-2.5-ban.jpg";

import acubis5fr from "../../../Statics/assets/by-trade-name/Acubis-5-eng.jpg";
import acubis5bk from "../../../Statics/assets/by-trade-name/Acubis-5-ban.jpg";

import acudipinplusfr from "../../../Statics/assets/by-trade-name/Acudipin-Plus-eng.jpg";
import acudipinplusbk from "../../../Statics/assets/by-trade-name/Acudipin-Plus-ban.jpg";

import acusan50fr from "../../../Statics/assets/by-trade-name/Acusan-50-eng.jpg";
import acusan50bk from "../../../Statics/assets/by-trade-name/Acusan-50-ban.jpg";

import acusanplusfr from "../../../Statics/assets/by-trade-name/Acusan-Plus-eng.jpg";
import acusanplusbk from "../../../Statics/assets/by-trade-name/Acusan-Plus-ban.jpg";

import alatinfr from "../../../Statics/assets/by-trade-name/Alatin-eng.jpg";
import alatinbk from "../../../Statics/assets/by-trade-name/Alatin-ban.jpg";

import brocast10fr from "../../../Statics/assets/by-trade-name/Brocast-10-Tab-eng.jpg";
import brocast10bk from "../../../Statics/assets/by-trade-name/Brocast-10-ban.jpg";

import brokof100fr from "../../../Statics/assets/by-trade-name/Brokof-100-ml-eng.jpg";
import brokof100bk from "../../../Statics/assets/by-trade-name/Brokof-100-ml-ban.jpg";

import ceprocon500fr from "../../../Statics/assets/by-trade-name/Ceprocon-500-eng.jpg";
import ceprocon500bk from "../../../Statics/assets/by-trade-name/Ceprocon-500-ban.jpg";

import convitb200fr from "../../../Statics/assets/by-trade-name/Convit-B-200-ml-eng.jpg";
import convitb200bk from "../../../Statics/assets/by-trade-name/Convit-B-200-ml-ban.jpg";

import convitz100fr from "../../../Statics/assets/by-trade-name/Convit-Z-100-ml-eng.jpg";
import convitz100bk from "../../../Statics/assets/by-trade-name/Convit-Z-100-ml-ban.jpg";

import convitz200fr from "../../../Statics/assets/by-trade-name/Convit-Z-200-ml-eng.jpg";
import convitz200bk from "../../../Statics/assets/by-trade-name/Convit-Z-200-ml-ban.jpg";

import conzi100fr from "../../../Statics/assets/by-trade-name/Conzi-100-ml-eng.jpg";
import conzi100bk from "../../../Statics/assets/by-trade-name/Conzi-100-ml-ban.jpg";

import dapazin5fr from "../../../Statics/assets/by-trade-name/Dapazin-5-eng.jpg";
import dapazin5bk from "../../../Statics/assets/by-trade-name/Dapazin-5_Ban.jpg";

import dapazin10fr from "../../../Statics/assets/by-trade-name/Dapazin-10-eng.jpg";
import dapazin10bk from "../../../Statics/assets/by-trade-name/Dapazin-10-ban.jpg";

import dopagut10fr from "../../../Statics/assets/by-trade-name/Dopagut-10-eng.jpg";
import dopagut10bk from "../../../Statics/assets/by-trade-name/Dopagut-10-ban.jpg";

import dopagut60fr from "../../../Statics/assets/by-trade-name/Dopagut-60-ml-eng.jpg";
import dopagut60bk from "../../../Statics/assets/by-trade-name/Dopagut-60-ml-ban.jpg";

import doribac100fr from "../../../Statics/assets/by-trade-name/Doribac-100-ml-eng.jpg";
import doribac100bk from "../../../Statics/assets/by-trade-name/Doribac-100-ml-ban.jpg";

import doribac250fr from "../../../Statics/assets/by-trade-name/Doribac-250-eng.jpg";
import doribac250bk from "../../../Statics/assets/by-trade-name/Doribac-250-ban.jpg";

import doribac500fr from "../../../Statics/assets/by-trade-name/Doribac-500-eng.jpg";
import doribac500bk from "../../../Statics/assets/by-trade-name/Doribac-500-ban.jpg";

import erectus10fr from "../../../Statics/assets/by-trade-name/Erectus-10-eng.jpg";
import erectus10bk from "../../../Statics/assets/by-trade-name/Erectus-10-ban.jpg";

import erectus20fr from "../../../Statics/assets/by-trade-name/Erectus-20-eng.jpg";
import erectus20bk from "../../../Statics/assets/by-trade-name/Erectus-20-ban.jpg";

import esmax20fr from "../../../Statics/assets/by-trade-name/Esmax-20-Tab-eng.jpg";
import esmax20bk from "../../../Statics/assets/by-trade-name/Esmax-20-Tab-ban.jpg";

import esmax40fr from "../../../Statics/assets/by-trade-name/Esmax-40-eng.jpg";
import esmax40bk from "../../../Statics/assets/by-trade-name/Esmax-40-Cap-ban.jpg";

import fexocon120fr from "../../../Statics/assets/by-trade-name/Fexocon-120-eng.jpg";
import fexocon120bk from "../../../Statics/assets/by-trade-name/Fexocon-120-ban.jpg";

import fexocon180fr from "../../../Statics/assets/by-trade-name/Fexocon-180-eng.jpg";
import fexocon180bk from "../../../Statics/assets/by-trade-name/Fexocon-180-ban.jpg";

import flunapen50fr from "../../../Statics/assets/by-trade-name/Flunapen-50-eng.jpg";
import flunapen50bk from "../../../Statics/assets/by-trade-name/Flunapen-50-ban.jpg";

import flunapen150fr from "../../../Statics/assets/by-trade-name/Flunapen-150-eng.jpg";
import flunapen150bk from "../../../Statics/assets/by-trade-name/Flunapen-150-ban.jpg";

import hexicon50fr from "../../../Statics/assets/by-trade-name/Hexicon-Hand-Rub-50-ml.jpg";
import hexicon50bk from "../../../Statics/assets/by-trade-name/Hexicon-Hand-Rub-50-ml.jpg";

import hexicon250fr from "../../../Statics/assets/by-trade-name/Hexicon-Hand-Rub-250-ml.jpg";
import hexicon250bk from "../../../Statics/assets/by-trade-name/Hexicon-Hand-Rub-250-ml.jpg";

import holicef1gmfr from "../../../Statics/assets/by-trade-name/Holicef-1-g-IM-eng.jpg";
import holicef1gmbk from "../../../Statics/assets/by-trade-name/Holicef-1-gm-IM-ban.jpg";

import holicef500mgfr from "../../../Statics/assets/by-trade-name/Holicef-500-mg-IV-eng.jpg";
import holicef500mgbk from "../../../Statics/assets/by-trade-name/Holicef-500-mg-IV-ban.jpg";

import linacon5fr from "../../../Statics/assets/by-trade-name/Linacon-5-eng.jpg";
import linacon5bk from "../../../Statics/assets/by-trade-name/Linacon-5-ban.jpg";

import macrobac15fr from "../../../Statics/assets/by-trade-name/Macrobac-15-ml-eng.jpg";
import macrobac15bk from "../../../Statics/assets/by-trade-name/Macrobac-15-ml-ban.jpg";

import macrobac35fr from "../../../Statics/assets/by-trade-name/Macrobac-35-ml-eng.jpg";
import macrobac35bk from "../../../Statics/assets/by-trade-name/Macrobac-35-ml-ban.jpg";

import macrobac500fr from "../../../Statics/assets/by-trade-name/Macrobac-500-Tab-eng.jpg";
import macrobac500bk from "../../../Statics/assets/by-trade-name/Macrobac-500-Tab-ban.jpg";

import maxdol10fr from "../../../Statics/assets/by-trade-name/Maxdol-10-eng.jpg";
import maxdol10bk from "../../../Statics/assets/by-trade-name/Maxdol-10-ban.jpg";

import maxdol30fr from "../../../Statics/assets/by-trade-name/Maxdol-30-mg-IM-IV-eng.jpg";
import maxdol30bk from "../../../Statics/assets/by-trade-name/Maxdol-30-Inj-ban.jpg";

import maxdol60fr from "../../../Statics/assets/by-trade-name/Maxdol-60-mg-IM-IV-eng.jpg";
import maxdol60bk from "../../../Statics/assets/by-trade-name/Maxdol-60-mg-IM-ban.jpg";

import maxvitd20000fr from "../../../Statics/assets/by-trade-name/Maxvit-D-20000-eng.jpg";
import maxvitd20000bk from "../../../Statics/assets/by-trade-name/Maxvit-D-20000-ban.jpg";

import maxvitd40000fr from "../../../Statics/assets/by-trade-name/Maxvit-D-40000-eng.jpg";
import maxvitd40000bk from "../../../Statics/assets/by-trade-name/Maxvit-D-40000-ban.jpg";

import microcef400fr from "../../../Statics/assets/by-trade-name/Microcef-400-eng.jpg";
import microcef400bk from "../../../Statics/assets/by-trade-name/Microcef-400-ban.jpg";

import microcef200fr from "../../../Statics/assets/by-trade-name/Microcef-200-eng.jpg";
import microcef200bk from "../../../Statics/assets/by-trade-name/Microcef-200-ban.jpg";

import microcef50fr from "../../../Statics/assets/by-trade-name/Microcef-50-ml-eng.jpg";
import microcef50bk from "../../../Statics/assets/by-trade-name/Microcef-50-ml-ban.jpg";

import monocaldboxfr from "../../../Statics/assets/by-trade-name/Monocal-D-Box-eng.jpg";
import monocaldboxbk from "../../../Statics/assets/by-trade-name/Monocal-D-Box-ban.jpg";

import monocaldpotfr from "../../../Statics/assets/by-trade-name/Monocal-D-Pot-eng.jpg";
import monocaldpotbk from "../../../Statics/assets/by-trade-name/Monocal-D-Pot-ban.jpg";

import myzincfr from "../../../Statics/assets/by-trade-name/My-Zinc-eng.jpg";
import myzincbk from "../../../Statics/assets/by-trade-name/My-Zinc-ban.jpg";

import novera6fr from "../../../Statics/assets/by-trade-name/Neovera-6-eng.jpg";
import novera6bk from "../../../Statics/assets/by-trade-name/Neovera-6-ban.jpg";

import novera12fr from "../../../Statics/assets/by-trade-name/Neovera-12-eng.jpg";
import novera12bk from "../../../Statics/assets/by-trade-name/Neovera-12-ban.jpg";

import neuropraxpotfr from "../../../Statics/assets/by-trade-name/Neuroprax-Pot-eng.jpg";
import neuropraxpotbk from "../../../Statics/assets/by-trade-name/Neuroprax-Pot-ban.jpg";

import norxitfr from "../../../Statics/assets/by-trade-name/Norxit-eng.jpg";
import norxitbk from "../../../Statics/assets/by-trade-name/Norxit-ban.jpg";

import novotril05fr from "../../../Statics/assets/by-trade-name/Novotril-0.5-mg-ban.jpg";
import novotril05bk from "../../../Statics/assets/by-trade-name/Novotril-0.5-eng.jpg";

import opmax20fr from "../../../Statics/assets/by-trade-name/OPmax-20-Capsule-eng.jpg";
import opmax20bk from "../../../Statics/assets/by-trade-name/Opmax-20-Cap-ban.jpg";

import picocef70fr from "../../../Statics/assets/by-trade-name/Picocef-70-ml-eng.jpg";
import picocef70bk from "../../../Statics/assets/by-trade-name/Picocef-70-ml-ban.jpg";

import pregacap50fr from "../../../Statics/assets/by-trade-name/Pregacap-50-eng.jpg";
import pregacap50bk from "../../../Statics/assets/by-trade-name/Pregacap-50-ban.jpg";

import pregacap75fr from "../../../Statics/assets/by-trade-name/Pregacap-75-eng.jpg";
import pregacap75bk from "../../../Statics/assets/by-trade-name/Pregacap-75-ban.jpg";

import relikofkidzfr from "../../../Statics/assets/by-trade-name/Relikof-Kidz-eng.jpg";
import relikofkidzbk from "../../../Statics/assets/by-trade-name/Relikof-Kidz-ban.jpg";

import sefcon500fr from "../../../Statics/assets/by-trade-name/Sefcon-500-eng.jpg";
import sefcon500bk from "../../../Statics/assets/by-trade-name/Sefcon-500-ban.jpg";

import sefconds100fr from "../../../Statics/assets/by-trade-name/Sefcon-DS-100-ml-eng.jpg";
import sefconds100bk from "../../../Statics/assets/by-trade-name/Sefcon-DS-100-ml-ban.jpg";

import unirab20fr from "../../../Statics/assets/by-trade-name/Unirab-20-eng.jpg";
import unirab20bk from "../../../Statics/assets/by-trade-name/Unirab-20-ban.jpg";

import optivas10fr from "../../../Statics/assets/by-trade-name/Optivas-10-eng.jpg";
import optivas10bk from "../../../Statics/assets/by-trade-name/Optivas-10-ban.jpg";

import panagra100fr from "../../../Statics/assets/by-trade-name/Panagra-100-eng.jpg";
import panagra100bk from "../../../Statics/assets/by-trade-name/Panagra-100-ban.jpg";

import peacepil3fr from "../../../Statics/assets/by-trade-name/Peacepil-3-mg-eng.jpg";
import peacepil3bk from "../../../Statics/assets/by-trade-name/Peacepil-3-mg-ban.jpg";

import picocef250fr from "../../../Statics/assets/by-trade-name/Picocef-250-eng.jpg";
import picocef250bk from "../../../Statics/assets/by-trade-name/Picocef-250-ban.jpg";

import picocef500fr from "../../../Statics/assets/by-trade-name/Picocef-500-eng.jpg";
import picocef500bk from "../../../Statics/assets/by-trade-name/Picocef-500-ban.jpg";

import plavasplusfr from "../../../Statics/assets/by-trade-name/Plavas-Plus-eng.jpg";
import plavasplusbk from "../../../Statics/assets/by-trade-name/Plavas-Plus-ban.jpg";

import polimet500fr from "../../../Statics/assets/by-trade-name/Polimet-500-eng.jpg";
import polimet500bk from "../../../Statics/assets/by-trade-name/Polimet-500-ban.jpg";

import polimet850fr from "../../../Statics/assets/by-trade-name/Polimet-850-eng.jpg";
import polimet850bk from "../../../Statics/assets/by-trade-name/Polimet-850-ban.jpg";

import paramax20fr from "../../../Statics/assets/by-trade-name/Pramax-20-eng.jpg";
import paramax20bk from "../../../Statics/assets/by-trade-name/Pramax-20-ban.jpg";

import paramax40fr from "../../../Statics/assets/by-trade-name/Pramax-40-eng.jpg";
import paramax40bk from "../../../Statics/assets/by-trade-name/Pramax-40-ban.jpg";

import radibac500fr from "../../../Statics/assets/by-trade-name/Radibac-500-eng.jpg";
import radibac500bk from "../../../Statics/assets/by-trade-name/Radibac-500-ban.jpg";

import roclav250fr from "../../../Statics/assets/by-trade-name/Roclav-250-eng.jpg";
import roclav250bk from "../../../Statics/assets/by-trade-name/Roclav-250-ban.jpg";

import roclav500fr from "../../../Statics/assets/by-trade-name/Roclav-500-eng.jpg";
import roclav500bk from "../../../Statics/assets/by-trade-name/Roclav-500-ban.jpg";

import rosucard10fr from "../../../Statics/assets/by-trade-name/Rosucard-10-eng.jpg";
import rosucard10bk from "../../../Statics/assets/by-trade-name/Rosucard-10-ban.jpg";

import rotagan200fr from "../../../Statics/assets/by-trade-name/Rotagan-200-eng.jpg";
import rotagan200bk from "../../../Statics/assets/by-trade-name/Rotagan-200-ban.jpg";

import tispafr from "../../../Statics/assets/by-trade-name/Tispa-eng.jpg";
import tispabk from "../../../Statics/assets/by-trade-name/Tispa-ban.jpg";

import unilorfr from "../../../Statics/assets/by-trade-name/unilor-eng.png";
import unilorbk from "../../../Statics/assets/by-trade-name/Unilor-ban.jpg";

import vildaglip50fr from "../../../Statics/assets/by-trade-name/Vildaglip-50-mg-eng.jpg";
import vildaglip50bk from "../../../Statics/assets/by-trade-name/Vildaglip-50-mg-ban.jpg";

import vildaglipm850fr from "../../../Statics/assets/by-trade-name/Vildaglip-M-850-eng.jpg";
import vildaglipm850bk from "../../../Statics/assets/by-trade-name/Vildaglip-M-850-ban.jpg";

import xdol60fr from "../../../Statics/assets/by-trade-name/X-Dol-60-Tab-eng.jpg";
import xdol60bk from "../../../Statics/assets/by-trade-name/X-dol-60-Tab-ban.jpg";

import xdol90fr from "../../../Statics/assets/by-trade-name/X-Dol-90-eng.jpg";
import xdol90bk from "../../../Statics/assets/by-trade-name/X-Dol-90-ban.jpg";

import xdol120fr from "../../../Statics/assets/by-trade-name/X-Dol-120-eng.jpg";
import xdol120bk from "../../../Statics/assets/by-trade-name/X-Dol-120-ban.jpg";

export const ByTherapeutic = [
  {
    id: 0,
    title: "Acedol Tablet",
    value: "acedol tablet",
    therapeutic_class: "nsaids",
    text1: " ",
    text2: " ",
    imgf: acedolfr,
    imge: acedolbk,
    img: [
      {
        id: 0,
        imgf: acedolfr,
        imge: acedolbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acedol",
    innerComposition: "Aceclofenac BP",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each film coated tablet contains- Aceclofenac BP 100 mg.",
          "Acedol® SR Tablet: Each sustained release tablet contains- Aceclofenac BP 200 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Aceclofenac is a non-steroidal agent with marked anti-inflammatory and analgesic properties. It is a potent inhibitor of the enzyme cycloxygenase which is involved in the production of prostaglandin.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "For the relief of pain and inflammation in osteoarthritis, rheumatoid arthritis and ankylosing spondylitis.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Acedol® Tablet: Adults: The recommended dose is 100 mg, twice daily. Children: There are no clinical data on the use of Aceclofenac in children. Elderly: The pharmacokinetics of Aceclofenac is not altered in elderly patients, therefore it is not considered necessary to modify the dose or dose frequency. Acedol® SR Tablet:The recommended dose is 200 mg, once daily.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION AND PRECAUTION",
        innerData:
          "Aceclofenac should not be administered to patients with active or suspected peptic ulcer or gastro-intestinal bleeding. It should not be given to patients with moderate to severe renal impairment. Close medical surveillance is also imperative in patients suffering from severe impairment of hepatic function. It should not be prescribed during pregnancy, unless there are compelling reasons for doing so. The lowest effective dosage should be used. Aceclofenac should not be administered to patients previously sensitive to Aceclofenac or in whom aspirin or NSAIDs precipitate attacks of asthma, acute rhinitis or urticaria or who are hypersensitive to these drugs.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECT",
        innerData:
          "The majority of side-effects observed have been reversible and of a minor nature and include gastro-intestinal disorders (dyspepsia, abdominal pain, nausea and diarrhea) and occasional occurrence of dizziness. Dermatological complaints including pruritus and rash and abnormal hepatic enzyme levels and raised serum creatinine have occasionally been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "There are no human data available on the consequences of Aceclofenac over dosage. If over dosage is observed, therapeutic measures should be taken according to symptoms; supportive and symptomatic treatment should be given for complications such as hypotension, gastro-intestinal irritation, respiratory depression, and convulsions.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Lithium and Digoxin: Aceclofenac, like many NSAIDs may increase plasma concentrations of lithium and Digoxin. Diuretics: Aceclofenac, like other NSAIDs, may interact the activity of diuretics. Anticoagulants: Like other NSAIDs, Aceclofenac may enhance the activity of anticoagulant. Close monitoring of patients on combined anticoagulants and Aceclofenac therapy should be undertaken. Methotrexate: Caution should be exercised if NSAIDs and Methotrexate are administered within 24 hours of each other, since NSAIDs may increase Methotrexate plasma levels, resulting in increased toxicity",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "The use of Aceclofenac should be avoided in pregnancy and lactation unless the potential benefits to the mother outweigh the possible risks to the fetus.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each box containing 10x10’s tablet, in Alu-PVC blister pack.",
          "Acedol® SR Tablet: Each box containing 5x10’s tablet, in Alu Opaque PVDC blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 1,
    title: "Acedol SR Tablet",
    text1: " ",
    text2: " ",
    therapeutic_class: "nsaids",
    imgf: acedolsrfr,
    imge: acedolsrbk,
    img: [
      {
        id: 1,
        imgf: acedolsrfr,
        imge: acedolsrbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acedol SR",
    innerComposition: "Aceclofenac BP",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each film coated tablet contains- Aceclofenac BP 100 mg.",
          "Acedol® SR Tablet: Each sustained release tablet contains- Aceclofenac BP 200 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Aceclofenac is a non-steroidal agent with marked anti-inflammatory and analgesic properties. It is a potent inhibitor of the enzyme cycloxygenase which is involved in the production of prostaglandin.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "For the relief of pain and inflammation in osteoarthritis, rheumatoid arthritis and ankylosing spondylitis.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Acedol® Tablet: Adults: The recommended dose is 100 mg, twice daily. Children: There are no clinical data on the use of Aceclofenac in children. Elderly: The pharmacokinetics of Aceclofenac is not altered in elderly patients, therefore it is not considered necessary to modify the dose or dose frequency. Acedol® SR Tablet:The recommended dose is 200 mg, once daily.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION AND PRECAUTION",
        innerData:
          "Aceclofenac should not be administered to patients with active or suspected peptic ulcer or gastro-intestinal bleeding. It should not be given to patients with moderate to severe renal impairment. Close medical surveillance is also imperative in patients suffering from severe impairment of hepatic function. It should not be prescribed during pregnancy, unless there are compelling reasons for doing so. The lowest effective dosage should be used. Aceclofenac should not be administered to patients previously sensitive to Aceclofenac or in whom aspirin or NSAIDs precipitate attacks of asthma, acute rhinitis or urticaria or who are hypersensitive to these drugs.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECT",
        innerData:
          "The majority of side-effects observed have been reversible and of a minor nature and include gastro-intestinal disorders (dyspepsia, abdominal pain, nausea and diarrhea) and occasional occurrence of dizziness. Dermatological complaints including pruritus and rash and abnormal hepatic enzyme levels and raised serum creatinine have occasionally been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "There are no human data available on the consequences of Aceclofenac over dosage. If over dosage is observed, therapeutic measures should be taken according to symptoms; supportive and symptomatic treatment should be given for complications such as hypotension, gastro-intestinal irritation, respiratory depression, and convulsions.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Lithium and Digoxin: Aceclofenac, like many NSAIDs may increase plasma concentrations of lithium and Digoxin. Diuretics: Aceclofenac, like other NSAIDs, may interact the activity of diuretics. Anticoagulants: Like other NSAIDs, Aceclofenac may enhance the activity of anticoagulant. Close monitoring of patients on combined anticoagulants and Aceclofenac therapy should be undertaken. Methotrexate: Caution should be exercised if NSAIDs and Methotrexate are administered within 24 hours of each other, since NSAIDs may increase Methotrexate plasma levels, resulting in increased toxicity",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "The use of Aceclofenac should be avoided in pregnancy and lactation unless the potential benefits to the mother outweigh the possible risks to the fetus.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each box containing 10x10’s tablet, in Alu-PVC blister pack.",
          "Acedol® SR Tablet: Each box containing 5x10’s tablet, in Alu Opaque PVDC blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 2,
    title: "Acubis 2.5  Tablet",
    therapeutic_class: "cardiovascular",
    text1: " ",
    text2: " ",
    imgf: acubis25fr,
    imge: acubis25bk,
    img: [
      {
        id: 2,
        imgf: acubis25fr,
        imge: acubis25bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acubis",

    innerComposition: "Bisoprolol Fumarate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Acubis®2.5 Tablet: Each film coated tablet contains- Bisoprolol Fumarate BP 2.5 mg.
            Acubis®5 Tablet: Each film coated tablet contains- Bisoprolol Fumarate BP 5 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Bisoprolol is the most selective beta-1 blocker. It displays
            highest level of affinity for the beta-1 receptor than any other
            beta-blocker available up to now. Selectively blocks beta-1
            adrenergic receptor in the heart and vascular smooth muscle and
            reduces heart rate and cardiac output resulting in decrease of
            arterial hypertension. Lipid metabolism can be adversely affected
            by beta-blockers, in patients with non-beta 1 selective
            beta-blocker, but Bisoprolol does not cause any change in the
            cholesterol fraction including the cardioprotective
            HDL-cholesterol, in long-term therapy.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Bisoprolol is indicated in the treatment of hypertension, angina and heart failure. It may be used alone or in combination with other antihypertensive agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: `Bisoprolol is indicated in the treatment of hypertension, angina
        and heart failure. It may be used alone or in combination with
        other antihypertensive agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Hypertension and angina: Usually 5-10 mg once daily, maximum 20 mg
        daily, Moderate to severe heart failure: Initially 1.25 mg once
        daily (in the morning) for 1 week then, if well tolerated,
        increased to 2.5 mg once daily for 1 week, then 3.75 mg once daily
        for 1 week, then 5 mg once daily for 4 weeks, then 7.5 mg once
        daily for 4 weeks, then 10 mg once daily; maximum 10 mg daily.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Fatigue, dizziness, headache, disturbances of the gut such as
        nausea, vomiting, diarrhoea, constipation or abdominal pain, cold
        or numb extremities, e.g. hands and feet, muscle weakness or
        cramps, slower than normal heart beat (bradycardia), worsening of
        heart failure, sleep disturbance, depression, breathing
        difficulties due to a narrowing of the airways (bronchospasm) in
        people with asthma or COPD.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Contraindications",
        innerData: `Bisoprolol is contraindicated in patients with cardiogenic shock,
        overt cardiac failure, second or third degree AV block and marked
        sinus bradycardia.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy Category C. There are no adequate and well-controlled
        studies in pregnant women. Bisoprolol should be used during
        pregnancy only if the potential benefit justifies the potential
        risk to the fetus. Lactating Mothers: Small amounts of Bisoprolol
        2% of the dose have been detected in the milk of lactating rats.
        It is not known whether this drug is excreted in human milk.
        Because many drugs are excreted in human milk caution should be
        exercised when Bisoprolol is administered to lactating women.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Bisoprolol should not be combined with other beta-blocking agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Overdosage",
        innerData: `The most common signs expected with over dosage of a beta-blocker
        are bradycardia, hypotension, congestive heart failure,
        bronchospasm, and hypoglycemia. To date, a few cases of overdose
        (maximum: 2000 mg) with Bisoprolol have been reported. Bradycardia
        and/or hypotension were noted. Sympathomimetic agents were given
        in some cases, and all patients recovered. In general, if overdose
        occurs, Bisoprolol therapy should be stopped and supportive and
        symptomatic treatment should be provided. Limited data suggest
        that Bisoprolol is not dialyzable. Based on the expected
        pharmacologic actions and recommendations for other beta-blockers,
        the following general measures should be considered when
        clinically warranted.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Monitoring of renal, hepatic, and hematopoietic function should be
        performed at regular intervals during long-term treatment with
        Bisoprolol.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData: `Monitoring of renal, hepatic, and hematopoietic function should be
        performed at regular intervals during long-term treatment with
        Bisoprolol.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from
        light. Keep out of the reach of children.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Commercial Pack",
        innerData: `Acubis®2.5 Tablet : Each box contains 3x10’s tablets in blister
        strip. Acubis®5 Tablet : Each box contains 3x10’s tablets in
        blister strip.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 3,
    title: "Acubis 5  Tablet",
    therapeutic_class: "cardiovascular",
    text1: " ",
    text2: " ",
    imgf: acubis5fr,
    imge: acubis5bk,
    img: [
      {
        id: 3,
        imgf: acubis5fr,
        imge: acubis5bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acubis 5",
    innerComposition: "Bisoprolol Fumarate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Acubis®2.5 Tablet: Each film coated tablet contains- Bisoprolol Fumarate BP 2.5 mg.
            Acubis®5 Tablet: Each film coated tablet contains- Bisoprolol Fumarate BP 5 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Bisoprolol is the most selective beta-1 blocker. It displays
            highest level of affinity for the beta-1 receptor than any other
            beta-blocker available up to now. Selectively blocks beta-1
            adrenergic receptor in the heart and vascular smooth muscle and
            reduces heart rate and cardiac output resulting in decrease of
            arterial hypertension. Lipid metabolism can be adversely affected
            by beta-blockers, in patients with non-beta 1 selective
            beta-blocker, but Bisoprolol does not cause any change in the
            cholesterol fraction including the cardioprotective
            HDL-cholesterol, in long-term therapy.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Bisoprolol is indicated in the treatment of hypertension, angina and heart failure. It may be used alone or in combination with other antihypertensive agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: `Bisoprolol is indicated in the treatment of hypertension, angina
        and heart failure. It may be used alone or in combination with
        other antihypertensive agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Hypertension and angina: Usually 5-10 mg once daily, maximum 20 mg
        daily, Moderate to severe heart failure: Initially 1.25 mg once
        daily (in the morning) for 1 week then, if well tolerated,
        increased to 2.5 mg once daily for 1 week, then 3.75 mg once daily
        for 1 week, then 5 mg once daily for 4 weeks, then 7.5 mg once
        daily for 4 weeks, then 10 mg once daily; maximum 10 mg daily.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Fatigue, dizziness, headache, disturbances of the gut such as
        nausea, vomiting, diarrhoea, constipation or abdominal pain, cold
        or numb extremities, e.g. hands and feet, muscle weakness or
        cramps, slower than normal heart beat (bradycardia), worsening of
        heart failure, sleep disturbance, depression, breathing
        difficulties due to a narrowing of the airways (bronchospasm) in
        people with asthma or COPD.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Contraindications",
        innerData: `Bisoprolol is contraindicated in patients with cardiogenic shock,
        overt cardiac failure, second or third degree AV block and marked
        sinus bradycardia.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy Category C. There are no adequate and well-controlled
        studies in pregnant women. Bisoprolol should be used during
        pregnancy only if the potential benefit justifies the potential
        risk to the fetus. Lactating Mothers: Small amounts of Bisoprolol
        2% of the dose have been detected in the milk of lactating rats.
        It is not known whether this drug is excreted in human milk.
        Because many drugs are excreted in human milk caution should be
        exercised when Bisoprolol is administered to lactating women.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Bisoprolol should not be combined with other beta-blocking agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Overdosage",
        innerData: `The most common signs expected with over dosage of a beta-blocker
        are bradycardia, hypotension, congestive heart failure,
        bronchospasm, and hypoglycemia. To date, a few cases of overdose
        (maximum: 2000 mg) with Bisoprolol have been reported. Bradycardia
        and/or hypotension were noted. Sympathomimetic agents were given
        in some cases, and all patients recovered. In general, if overdose
        occurs, Bisoprolol therapy should be stopped and supportive and
        symptomatic treatment should be provided. Limited data suggest
        that Bisoprolol is not dialyzable. Based on the expected
        pharmacologic actions and recommendations for other beta-blockers,
        the following general measures should be considered when
        clinically warranted.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Monitoring of renal, hepatic, and hematopoietic function should be
        performed at regular intervals during long-term treatment with
        Bisoprolol.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData: `Monitoring of renal, hepatic, and hematopoietic function should be
        performed at regular intervals during long-term treatment with
        Bisoprolol.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from
        light. Keep out of the reach of children.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Commercial Pack",
        innerData: `Acubis®2.5 Tablet : Each box contains 3x10’s tablets in blister
        strip. Acubis®5 Tablet : Each box contains 3x10’s tablets in
        blister strip.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 4,
    title: "Acudipin Plus  Tablet",
    therapeutic_class: "cardiovascular",
    text1: " ",
    text2: " ",
    imgf: acudipinplusfr,
    imge: acudipinplusbk,
    img: [
      {
        id: 4,
        imgf: acudipinplusfr,
        imge: acudipinplusbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acudipin",
    innerComposition: "Amlodipine BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Acudipin® 5 Tablet: Each tablet contains Amlodipine Besylate BP equivalent to 5 mg of Amlodipine. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Amlodipine is a dihydropyridine calcium antagonist that inhibits the transmembrane influx of calcium ions into vascular smooth muscle and cardiac muscle. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: ["Hypertension", "Angina"],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: [
          "Adult: Recommended starting dose: 5 mg once daily with maximum dose 10 mg once daily ",
          "Elderly patients or patients with hepatic insufficiency: May start with 2.5 mg once daily",
          "Pediatric: Starting dose: 2.5 mg to 5 mg once daily (in patient 6-17 years)",
        ],
      },

      {
        innerHead: "SIDE-EFFECT",
        innerData:
          "Headache, fatigue, nausea, flushing, dizziness, erythema are reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Contraindicated in patients with hypersensitivity to Amlodipine.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Since the vasodilation induced by Amlodipine is gradual in onset, acute hypotension has rarely been reported after oral administration of Amlodipine. Nonetheless, caution should be exercised when administering Amlodipine with any other peripheral vasodilator particularly in patients with severe aortic stenosis.Use in patients with congestive heart failure: Although haemodynamic studies and a controlled in class II-III heart failure patients have shown that Amlodipine did not lead to clinical deterioration as measured by exercise tolerance, left ventricular ejection fraction and clinical symptomatology; in general, all calcium channel blockers should be used with caution in patients with heart failure.Beta-blocker withdrawal: Amlodipine is not a beta-blocker and therefore gives no protection against the danger of abrupt beta-blocker withdrawal; any such withdrawal should be gradual reduction of the dose of beta-blocker.Patients with hepatic failure: Since Amlodipine is extensively metabolized by the liver and plasma elimination half life is 56 hours in patients with impaired hepatic function, caution should be exercised when administering Amlodipine to patients with hepatic impairment.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN SPECIAL GROUP",
        innerData:
          "Pregnancy and lactation: Not recommended.Pediatric use: Effect of Amlodipine on blood pressure in patients less than 6 years of age is not known.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "The use of Aceclofenac should be avoided in pregnancy and lactation unless the potential benefits to the mother outweigh the possible risks to the fetus.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "Available data suggest that gross overdosage could result in excessive peripheral vasodilatation and possibly reflex tachycardia. Marked and probably prolonged systemic hypotension up to and including shock with fatal outcome have been reported. Intravenous calcium gluconate may be beneficial in reversing the effects of calcium channel blockade.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Carbamazepine reduces the effects of Amlodipine",
          "Itraconazole, ketoconazole inhibit the metabolism of Amlodipine",
        ],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acudipin® 5 Tablet: Each box contains 5 x 10’s tablets in Alu-Alu blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 5,
    title: "Acusan 50  Tablet",
    therapeutic_class: "cardiovascular",
    text1: " ",
    text2: " ",
    imgf: acusan50fr,
    imge: acusan50bk,
    img: [
      {
        id: 5,
        imgf: acusan50fr,
        imge: acusan50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Acusan",
    innerComposition: "Losartan Potassium",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Acusan® 50 Tablet: Each film coated tablet contains Losartan Potassium BP 50 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Acusan® 50 (Losartan Potassium), the first of a new class of antihypertensives, is an angiotensin II receptor (type AT1) antagonist. Angiotensin II is a potent vasoconstrictor, the primary vasoactive hormone of the renin-angiotensin system and an important component in the pathophysiology of hypertension. `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "MODE OF ACTION",
        innerData: `Losartan and its principal active metabolite block the vasoconstrictor and aldosterone secreting effects of angiotensin II by selectively blocking the binding of angiotensin II to the AT1 receptor found in many tissues. Losartan Potassium is now regarded as the first-line therapy option for treating high blood pressure.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: `Acusan® 50 (Losartan Potassium) is indicated for-`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "All grades of hypertension",
          "Chronic heart failure",
          "Stroke risk reduction in hypertension",
          "●LVH and Nephropathy in type 2 Diabetes. It may be used alone or in combination with other antihypertensive agents. It is an effective alternative for patients who have to discontinue an ACE inhibitor because of persistent dry cough.",
        ],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `The usual starting and maintenance dose of Losartan Potassium is 50 mg once daily for most patients. Some patients may receive an additional benefit by increasing the dose to 100 mg once daily. In patients who are salt depleted corrective measures should be used before starting Losartan Potassium, the initial dose should be reduced to 25 mg`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Overall incidence of side-effects of Losartan Potassium is comparable to placebo in clinical studies. The most common adverse events occurring with Losartan Potassium at a rate of >1% above placebo were upper respiratory infection (7.9% vs. 6.9%), dizziness (3.5% vs. 2.1%) and leg pain (1.0% vs. 0.0%).`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Losartan Potassium should be used with caution in patients with known hypersensitivity to the drugs that act through renin-angiotensin system. Special precaution should be taken when it is administered to the patients with renal and hepatic impairment. Safety and effectiveness of Losartan Potassium in pediatric patients have not been established.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Contraindications",
        innerData: `Bisoprolol is contraindicated in patients with cardiogenic shock,
        overt cardiac failure, second or third degree AV block and marked
        sinus bradycardia.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Losartan Potassium must be discontinued as soon as possible when pregnancy is detected. It should not be prescribed during lactation as there is no information in humans on the passage of Losartan into breast milk.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `No drug interactions of clinical significance have been identified. Drugs which have been studied in clinical pharmacokinetic trials include- Hydrochlorothiazide, Digoxin, Warfarin, Cimetidine, Ketoconazole and Phenobarbital.`,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "Overdosage",
        innerData: `Limited data are available regarding overdosage in humans. The most likely manifestation of overdosage would be hypotension and tachycardia. Bradycardia could occur from parasympathetic (vagal) stimulation. Supportive treatment should include repletion of the intravascular volume. Neither losartan nor the active metabolite can be removed by hemodialysis.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },

      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Acusan® 50 Tablet: Each box containing 3x10’s tablets in blister strips.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 6,
    title: "Acusan Plus  Tablet",
    therapeutic_class: "cardiovascular",
    text1: " ",
    text2: " ",
    imgf: acusanplusfr,
    imge: acusanplusbk,
    img: [
      {
        id: 6,
        imgf: acusanplusfr,
        imge: acusanplusbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "",
    innerComposition: "",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each film coated tablet contains- Aceclofenac BP 100 mg.",
          "Acedol® SR Tablet: Each sustained release tablet contains- Aceclofenac BP 200 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Aceclofenac is a non-steroidal agent with marked anti-inflammatory and analgesic properties. It is a potent inhibitor of the enzyme cycloxygenase which is involved in the production of prostaglandin.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "For the relief of pain and inflammation in osteoarthritis, rheumatoid arthritis and ankylosing spondylitis.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Acedol® Tablet: Adults: The recommended dose is 100 mg, twice daily. Children: There are no clinical data on the use of Aceclofenac in children. Elderly: The pharmacokinetics of Aceclofenac is not altered in elderly patients, therefore it is not considered necessary to modify the dose or dose frequency. Acedol® SR Tablet:The recommended dose is 200 mg, once daily.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION AND PRECAUTION",
        innerData:
          "Aceclofenac should not be administered to patients with active or suspected peptic ulcer or gastro-intestinal bleeding. It should not be given to patients with moderate to severe renal impairment. Close medical surveillance is also imperative in patients suffering from severe impairment of hepatic function. It should not be prescribed during pregnancy, unless there are compelling reasons for doing so. The lowest effective dosage should be used. Aceclofenac should not be administered to patients previously sensitive to Aceclofenac or in whom aspirin or NSAIDs precipitate attacks of asthma, acute rhinitis or urticaria or who are hypersensitive to these drugs.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECT",
        innerData:
          "The majority of side-effects observed have been reversible and of a minor nature and include gastro-intestinal disorders (dyspepsia, abdominal pain, nausea and diarrhea) and occasional occurrence of dizziness. Dermatological complaints including pruritus and rash and abnormal hepatic enzyme levels and raised serum creatinine have occasionally been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "There are no human data available on the consequences of Aceclofenac over dosage. If over dosage is observed, therapeutic measures should be taken according to symptoms; supportive and symptomatic treatment should be given for complications such as hypotension, gastro-intestinal irritation, respiratory depression, and convulsions.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Lithium and Digoxin: Aceclofenac, like many NSAIDs may increase plasma concentrations of lithium and Digoxin. Diuretics: Aceclofenac, like other NSAIDs, may interact the activity of diuretics. Anticoagulants: Like other NSAIDs, Aceclofenac may enhance the activity of anticoagulant. Close monitoring of patients on combined anticoagulants and Aceclofenac therapy should be undertaken. Methotrexate: Caution should be exercised if NSAIDs and Methotrexate are administered within 24 hours of each other, since NSAIDs may increase Methotrexate plasma levels, resulting in increased toxicity",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "The use of Aceclofenac should be avoided in pregnancy and lactation unless the potential benefits to the mother outweigh the possible risks to the fetus.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acedol® Tablet: Each box containing 10x10’s tablet, in Alu-PVC blister pack.",
          "Acedol® SR Tablet: Each box containing 5x10’s tablet, in Alu Opaque PVDC blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 7,
    title: "Alatin Tablet",
    therapeutic_class: "anti-histamine",
    text1: " ",
    text2: " ",
    imgf: alatinfr,
    imge: alatinbk,
    img: [

      {
        id: 7,
        imgf: alatinfr,
        imge: alatinbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Alatin",
    innerComposition: "Cetirizine Dihydrochloride BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Alatin® Tablet: Each tablet contains Cetirizine Dihydrochloride BP 10 mg.  ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Alatin® is a piperazine derivative and a potent functional antagonist of histamine H1 receptors. Alatin® is a long acting antihistamine. Central sedation or antimuscarinic effects do not generally occur with the usual doses of Alatin®. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Alatin® is indicated for the prevention and symptomatic relief of allergic manifestations, such as:",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Seasonal allergic rhinitis",
          "Perennial allergic rhinitis",
          "Chronic idiopathic urticaria",
        ],
      },
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults and children over 12 years: 10 mg (1 tablet) once daily. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Cetirizine is contraindicated in patients who have shown hypersensitivity or idiosyncrasy to it or its parent compound- Hydroxyzine.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },

      {
        innerHead: "ADVERSE REACTION",
        innerData:
          "No potentially life threatening effects have been encountered.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Neonates: The drug is not usually administered to neonates.Children: Cetirizine is effective & well tolerated in children. No special precautions are required in children over 6 yrs of age.Lactating mother: The extent of Cetirizine excretion in human breast milk is unknown but some animal studies have shown excretion in breast milk. Nursing mothers are advised not to take this medication.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY",
        innerData:
          "Cetirizine is not teratogenic in animals. Since the animal studies are not always predictive of human response, it should be used only if the potential benefit justifies the potential risk to the fetus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "There are no reports of hazardous interactions with other drugs to date. Concomitant administration with alcohol or diazepam does not impair psychomotor performance any more than the impairment of performance produced by alcohol alone.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ c. Temp.) and dry place, protected from light. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Alatin® Tablet: Each Box contains 10x10’s tablet in blister strips.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 8,
    title: "Brocast 10  Tablet",
    therapeutic_class: "leukotrine",
    text1: " ",
    text2: " ",
    imgf: brocast10fr,
    imge: brocast10bk,
    img: [
      {
        id: 8,
        imgf: brocast10fr,
        imge: brocast10bk,
      },
    ],
    backpagelink: "/by-trade-name",
    backpagename: "By Trade Name",
    innerMainHeading: "Brocast",
    innerComposition: "Montelukast",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Brocast® 10 Tablet: Each film coated tablet contains Montelukast Sodium INN 10.38 mg Eqv. to 10 mg Montelukast.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Montelukast is a selective and orally active leukotriene receptor antagonist that inhibits the cysteinyl leukotriene CysLT1 receptor. The cysteinyl leukotrienes (LTC4, LTD4, LTE4) are products of arachidonic acid metabolism and are released from various cells, including mast cells and eosinophils. These eicosanoids bind to cysteinyl leukotriene receptors (CysLT) found in the human airway. Montelukast inhibits physiologic actions of LTD4 at the CysLT1 receptor without any agonist activity.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: "Montelukast is indicated for:",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Prophylaxis and chronic treatment of asthma in patients 12 months of age and older.",
          "Acute prevention of Exercise-Induced Bronchoconstriction (EIB) in patients 6 years of age and older.",
          "Relief of symptoms of Allergic Rhinitis (AR): Seasonal Allergic Rhinitis (SAR) in patients 2 years of age and older, and perennial allergic rhinitis (PAR) in patients 6 months of age and older.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
        isinnerSub: true,
        innerSubHead: "By indications-",
        innerSubData: "",
        isSublist: true,
        listSubData: [
          "Asthma: Once daily in the evening for patients 12 months and older.",
          "Acute prevention of exercise-induced bronchoconstriction: One tablet at least 2 hours before exercise for patients 6 years of age and older.",
          "Seasonal allergic rhinitis: Once daily for patients 2 years and older.",
          "Perennial allergic rhinitis: Once daily for patients 6 months and older.",
        ],
        isinnerSub1: true,
        innerSubHead1: "By age-",
        innerSubData1: "",
        isSublist1: true,
        listSubData1: [
          "15 years and older: One 10 mg tablet.",
          "6 to 14 years: One 5 mg chewable tablet.",
          "2 to 5 years: One 4 mg chewable tablet ",
        ],
      },
      {
        innerHead: "SIDE EFFECT",
        innerData:
          "Montelukast appears to be well tolerated. In clinical trials, the most common adverse effect reported was headache, occurring in approximately 18% of patients. Rash, dyspepsia, dizziness, and abdominal pain were all reported in less than 2% of patients. Elevated liver transaminases have been reported with montelukast use, but not at a greater incidence than with placebo. A small percentage of pediatric patients have experienced diarrhea, sinusitis and otitis media during montelukast clinical trials.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Montelukast is not indicated for use in the reversal of bronchospasm in acute asthma attacks. Montelukast should not be abruptly substituted for inhaled or oral corticosteroids. Montelukast should not be used as monotherapy for the treatment and management of exercise-induced bronchospasm. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Montelukast is contraindicated in patients with Hypersensitivity to any component of this product.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData:
          "Montelukast is classified as pregnancy category B. The drug has been shown to cross the placenta of pregnant rats and rabbits, but there have been no reports of its use in pregnant women. Montelukast is also known to be excreted into breast-milk, but only limited information is available on the significance of this finding. Caution should be used prior to initiating montelukast therapy in nursing mothers",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "Montelukast may be administered with other therapies routinely used in the prophylaxis and chronic treatment of asthma. In drug-interactions studies, the recommended clinical dose of montelukast did not have clinically important effects on the following medicinal products: theophylline, prednisone, prednisolone, oral contraceptives, terfenadine, digoxin and warfarin. Caution should be exercised, particularly in children, when montelukast is co-administered with phenytoin, phenobarbital and rifampicin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "There were no adverse experiences reported in the majority of over dosage reports. The most frequent adverse experiences observed were thirst, somnolence, hyperkinesia and abdominal pain.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Brocast® 10: Each box contains 2×10 tablets in blister strips.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 9,
    title: "Brokof 100  Syrup",
    therapeutic_class: "mucolytic",
    text1: " ",
    text2: " ",
    imgf: brokof100fr,
    imge: brokof100bk,
    img: [
      {
        id: 9,
        imgf: brokof100fr,
        imge: brokof100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Brokof",
    innerComposition: "Bromhexine Hydrochloride BP",
    innerdata: [
      {
        inner1Head: "PRESENTATION",
        innerData:
          "Brokof® Syrup: Each 5 ml syrup contains Bromhexine Hydrochloride BP 4 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        inner1Head: "MECHANISM OF ACTION",
        innerData:
          "Brokof® (Bromhexine) is an oral mucolytic agent with a low level of associated toxicity. It acts on the mucus at the formative stages in the glands, within the mucus-secreting cells. Bromhexine disrupts the structure of acid mucopolysaccharide fibres in mucoid sputum and produces less viscous mucus which is easier to expectorate.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        inner1Head: "INDICATION",
        innerData:
          "Brokof® is indicated in the treatment of respiratory disorders associated with viscid or excessive mucus or productive cough. This include: Tracheobronchitis, Bronchitic with emphysema, Bronchiectasis, Bronchitis with bronchospasm, Chronic inflammatory pulmonary conditions, Pneumoconiosis",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults and Children over 10 years: 2 to 4 teaspoonfuls (8-16 mg), 3 times daily. Initially 4 teaspoonfuls, 3 times daily, then as required.",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Children 5-10 years: 1 teaspoonful (4 mg), 3 times daily",
          "Children 2-5 years: ½ teaspoonful (2 mg), 3 times daily.",
          "Children below 2 years: ¼ teaspoonful (1 mg), 3 times daily.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Gastrointestinal side-effects may occur occasionally with bromhexine and a transient rise in serum aminotransferase values has been reported. Other reported adverse effects include headache, vertigo (dizziness), sweating and allergic reactions.",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Bromhexine is contraindicated for use in patients with known hypersensitivity or idiosyncratic reaction to bromhexine hydrochloride (or any of the other ingredients in the product).",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Since mucolytics may disrupt the gastric mucosal barrier, bromhexine should be used with caution in patients with a history of gastric ulceration. Clearance of bromhexine or its metabolites may be reduced in patients with severe hepatic or renal impairment.",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Category B: Bromhexine has been taken by a large number of pregnant women and women of child bearing age without any proven increase in the frequency of malformations or other direct or indirect harmful effects on the foetus having been observed. It is not known whether bromhexine is excreted in breast milk or whether it has a harmful effect on the breastfeeding infant. Therefore it is not recommended for breastfeeding mothers unless the potential benefits to the patient are weighed against the possible risk to the infant.",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
      {
        innerHead: "STORAGE CONDITION",
        innerData:
          "Store in a cool (Below 30⁰C Temp.), dry place & protect from light. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Brokof® Syrup: Each bottle contains 100 ml syrup with a measuring cup.",
        istable: false,
        table: {},
        islist: true,
        listData: [""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 10,
    title: "Ceprocon 500  Tablet",
    therapeutic_class: "antibiotic",
    text1: " ",
    text2: " ",
    imgf: ceprocon500fr,
    imge: ceprocon500bk,
    img: [
      {
        id: 10,
        imgf: ceprocon500fr,
        imge: ceprocon500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Ceprocon",
    innerComposition: "Ciprofloxacin Hydrochloride USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Ceprocon® 500 Tablet: Each film coated tablet contains Ciprofloxacin Hydrochloride USP equivalent to Ciprofloxacin 500 mg.",
          "Ceprocon® Pellets for suspension: Each 5 ml suspension contains Ciprofloxacin 250 mg as Ciprofloxacin Hydrochloride USP.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "The active ingredient of Ceprocon® 500 mg Tablet and Ceprocon® PFS is Ciprofloxacin Hydrochloride USP. Ciprofloxacin a fluoroquinolone, is an extremely broad spectrum antimicrobial agent and acts by inhibiting a subunit of DNA gyrase which is essential in the reproduction of bacterial DNA. This mode of action differs from that of Penicillins, Cephalosporins, Aminoglycosides and Tetracyclines and therefore, organisms resistant to these antibiotics are generally sensitive to Ciprofloxacin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData:
          ".Ciprofloxacin is indicated for the treatment of the following infections caused by sensitive bacteria..Severe systemic infections: e.g; septicemia, bacteremia, peritonitis, infections in immuno- suppressed patients with haematological or solid tumors and in patients in intensive care unit with specific problems such as infected burns. .Respiratory tract infections: Lobar and broncho pneumonia, acute and chronic bronchitis and empyema. .Urinary tract infections: Uncomplicated and complicated urethritis, cystitis, pyelonephritis, prostatitis and epididymitis. .Skin and soft tissue infections: Infected ulcers, wound infections, abscesses, cellulitis, otitis externa, erysipelas and infected burns.  .Gastrointestinal infections: Enteric fever, infective diarrhea. .Infections of the biliary tract: Cholangitis, cholecystitis, empyema of the gall bladder.  .Intra-abdominal infections: Peritonitis, intra abdominal abscesses. .Bone and joint infections: Osteomyelitis, septic arthritis. .Pelvic infections: Salpingitis, endometritis, pelvic inflammatory diseases. .Eye, ear, nose and throat infections: Otitis media, sinusitis, mastoiditis, tonsillitis. .Gonorrhoea: Urethral, rectal and pharyngeal gonorrhoea caused by beta-lactamase producing organism or organisms moderately sensitive to penicillin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData:
          "Adult Dose: For oral tablet & suspension: Urinary Tract infection: Acute uncomplicated: 250 mg twice daily for 3 days; Mild/Moderate: 250 mg twice daily for 7 to 14 days; Severe/Complicated: 500 mg twice daily for 7 to 14 days; Chronic Bacterial Prostitis : 500 mg twice daily for 28 days; Lower Respiratory Tract infection: Mild/Moderate: 500 mg twice daily for 7 to 14 days, Severe/Complicated : 750 mg twice daily for 7 to 14 days; Acute Sinusitis : 500 mg twice daily for 10 days; Skin and Skin Structure infection: Mild/Moderate : 500 mg twice daily for 7 to 14 days, Severe/Complicated : 750 mg twice daily for 7 to 14 days, Bone and joint infection: Mild/Moderate 500 mg twice daily for 4 to 6 weeks, Severe/Complicated : 750 mg twice daily for 4 to 6 weeks, Intra Abdominal Infection: 500 mg twice daily for 7 to 14 days, Infectious Diarrhea: Mild/Moderate/Severe: 500 mg twice daily for 5 to 7 days, Typhoid Fever : 500 mg twice daily for 10 days, Urethral & Cervical Gonococcal Infections: Uncomplicated: 250 mg Single dose.Children: The dosage should be 10-30 mg/kg/day depending upon the severity of infections, administered in two divided doses.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Gastrointestinal disturbances e.g. nausea, diarrhoea, vomiting, dyspepsia, abdominal pain. Disturbance of the central nervous system e.g. dizziness, headache, tiredness, confusion, convulsions. Hypersensitivity reactions e.g. skin rashes, pruritus and possible systemic reactions. The following other reactions have also been reported, joint pain, mild photosensitivity and transient increase in liver enzymes (particularly in patients with previous liver damage) serum bilirubin, urea or creatinine levels.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Ciprofloxacin is contraindicated in patients who have shown hypersensitivity to Ciprofloxacin or other quinolones.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Ciprofloxacin should be used with caution in patients with a history of convulsive disorders. Crystalluria related to the use of Ciprofloxacin has been observed only rarely. Patients receiving Ciprofloxacin should be well hydrated and excessive alkalinity of the urine should be avoided",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Concurrent administration of Ciprofloxacin with theophylline may lead to elevated plasma concentrations of theophylline and prolongation of its elimination half-life. This may result in increased risk of theophylline related adverse reactions. If concomitant use cannot be avoided, plasma levels of theophylline should be monitored and dosage adjustments made as appropriate. Antacids containing magnesium hydroxide or aluminium hydroxide may interfere with the absorption of Ciprofloxacin resulting in serum and urine levels lower than desired, concurrent administration of these agents with Ciprofloxacin should be avoided. Probenecid interferes with renal tubular secretion of Ciprofloxacin and produces an increase in the level of Ciprofloxacin in the serum. This should be considered if patients are receiving both drugs concomitantly. As with other broad spectrum antibiotics prolonged use of Ciprofloxacin may result in overgrowth of non susceptible organism. Repeated evaluation of the patient's condition and microbial susceptibility testing is essential. If superinfection occurs during therapy, appropriate measures should be taken.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Reproduction studies performed in mice, rats and rabbits using parenteral and oral administration did not reveal any evidence of teratogenicity, impairment of fertility or impairment of pre/post natal development. However as with other quinolones, Ciprofloxacin has been shown to cause arthropathy in immature animals and therefore its use during pregnancy is not recommended. Studies in rats have indicated that Ciprofloxacin is secreted in milk, administration to nursing mothers is thus not recommended.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "No information on over dosage is available. Routine measures such as gastric lavage should be performed as soon as possible after ingestion of Ceprocon tablets or suspension. Serum levels of Ciprofloxacin are reduced by dialysis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Ceprocon® 500 Tablet: Box containing 3x10’s, in blister strips.",
          "Ceprocon® Pellets for Suspension: Bottle containing dry Pellets to reconstitute 60 ml suspension with a measuring cup or dropper for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 11,
    title: "Convit B 200 Syrup",

    therapeutic_class: "vitamin & minerals",
    text1: " ",
    text2: " ",
    imgf: convitb200fr,
    imge: convitb200bk,
    img: [
      {
        id: 11,
        imgf: convitb200fr,
        imge: convitb200bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Convit B",
    innerComposition: "Vitamin B Complex",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Convit® B Syrup: Each 5 ml syrup contains Thiamine Hydrochloride (B1) BP 5.00 mg, Riboflavin (B2) BP 2.00 mg, Pyridoxine Hydrochloride (B6) BP 2.00 mg, Nicotinamide (B3) BP 20.00 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Convit® B contains the most important members of the vitamin B group in pure form and in therapeutically balanced proportions. The members of the vitamin B group contained in Vitamin-B complex are components of enzyme systems that regulate various stages of carbohydrate, fat and protein metabolism, each of the components playing a specific biological role. Deficiency of B vitamin causes glossitis, stomatitis, cheilosis, polyneuritis, beriberi, pellagra and vascularisation of cornea.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData:
          "Convit® B is indicated for prophylactic or therapeutic nutritional supplementation in physiologically stressful conditions. These include: Conditions causing depletion, or reduced absorption or bioavailability of essential B-vitamins manifested by glossitis, stomatitis, cheilosis, beriberi and polyneuritis, the maintenance of normal growth and health during the early days of children, apathy and anorexia in elderly patients, prevention of vitamin deficiencies, particularly when depletion is suspected- pregnancy and lactation, patients on restricted diets.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: "2-3 teaspoonful daily or as directed by the physician.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Vitamin-B complex is contraindicated in patients hypersensitive to any of its components.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Pyridoxine may reduce the therapeutic efficacy of Levodopa. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECT ",
        innerData:
          "Adverse reactions have been reported with specific vitamins and minerals, but generally at levels substantially higher than those in Convit® B. However, allergic and idiosyncratic reactions are possible at lower levels. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "As little as 5 mg pyridoxine daily can decrease the efficacy of levodopa in the treatment of Parkinsonism. Therefore, Convit® B is not recommended for patients undergoing such therapy.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData:
          "It is safe to use Vitamin-B complex in pregnancy and lactation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 300 C. Temp.) and dry place, protected from light. Keep out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Convit® B 200 mI Syrup: Each bottle contains 200 mI syrup with a measuring cup.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 12,
    title: "Convit Z 100 ml Syrup",
    therapeutic_class: "vitamin & minerals",
    text1: " ",
    text2: " ",
    imgf: convitz100fr,
    imge: convitz100bk,
    img: [
      {
        id: 12,
        imgf: convitz100fr,
        imge: convitz100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Convit®Z",
    innerComposition: "Vitamin-B Complex & Zinc",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Convit®Z Syrup: Each 5 ml syrup contains- Thiamine HCl BP 5 mg, Riboflavin-5-Phosphate Sodium BP 2.74 mg eqvt. to Riboflavin 2 mg, Pyridoxine HCl BP 2 mg, Nicotinamide BP 20 mg, Zinc Sulphate Monohydrate USP 27.45 mg eqvt. to Elemental Zinc 10 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Convit Z is a special preparation of Zinc and B-vitamins. In Convit Z  Zinc is present as Zinc Sulphate Monohydrate USP. Zinc is an essential trace element required for human nutrition and involved in a number of body enzyme system. Severe Zinc deficiency causes skin lesion, alopecia, diarrhoea, increased susceptibility of infections, cognitive impairment and failure to thrive in children. Vitamin-B complex aids in energy utilization from food, helps in proper functions of nervous system and facilitates RBC formation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData:
          "Convit®Z is indicated for the treatment of Vitamin-B and Zinc deficiency diseases e.g. gastritis, stomatitis, beri-beri syndrome.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Children (under 10 kg): 1 teaspoonful (5 ml) once daily after meal or as prescribed by the physician.Children (10-30 kg): 1 teaspoonful (5 ml) 3 times daily after meal or as prescribed by the physician.Adults and Children (over 30 kg): 1-2 teaspoonful (5-10 ml) 3 times daily after meal or as prescribed by the physician.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Convit®Z is contraindicated in patients with known hypersensitivity to any of the ingredients of this product.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Drug should be discontinued to the patients with hypertensive to Vitamin-B complex.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: "Convit®Z is recommended during pregnancy & lactation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Convit®Z is usually well-tolerated. However, a few side- effects including nausea, vomiting, constipation or diarrhoea may occur.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "Zinc Sulphate is corrosive in overdose. Symptoms are corrosion and inflammation of the mucous membrane of the mouth and stomach.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Concomitant intake of tetracycline and Convit®Z may decrease the absorption of both tetracycline and zinc. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (below 30°C) and dry place. Keep away from light and out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Convit®Z 100 mI Syrup: Each bottle contains 100 mI syrup with a measuring cup.",
          "Convit®Z 100 mI Syrup: Each bottle contains 100 mI syrup with a measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 13,
    title: "Convit Z 200 ml Syrup",
    therapeutic_class: "vitamin & minerals",
    text1: " ",
    text2: " ",
    imgf: convitz200fr,
    imge: convitz200bk,
    img: [
      {
        id: 13,
        imgf: convitz200fr,
        imge: convitz200bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Convit®Z",
    innerComposition: "Vitamin-B Complex & Zinc",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Convit®Z Syrup: Each 5 ml syrup contains- Thiamine HCl BP 5 mg, Riboflavin-5-Phosphate Sodium BP 2.74 mg eqvt. to Riboflavin 2 mg, Pyridoxine HCl BP 2 mg, Nicotinamide BP 20 mg, Zinc Sulphate Monohydrate USP 27.45 mg eqvt. to Elemental Zinc 10 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Convit Z is a special preparation of Zinc and B-vitamins. In Convit Z  Zinc is present as Zinc Sulphate Monohydrate USP. Zinc is an essential trace element required for human nutrition and involved in a number of body enzyme system. Severe Zinc deficiency causes skin lesion, alopecia, diarrhoea, increased susceptibility of infections, cognitive impairment and failure to thrive in children. Vitamin-B complex aids in energy utilization from food, helps in proper functions of nervous system and facilitates RBC formation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData:
          "Convit®Z is indicated for the treatment of Vitamin-B and Zinc deficiency diseases e.g. gastritis, stomatitis, beri-beri syndrome.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Children (under 10 kg): 1 teaspoonful (5 ml) once daily after meal or as prescribed by the physician.Children (10-30 kg): 1 teaspoonful (5 ml) 3 times daily after meal or as prescribed by the physician.Adults and Children (over 30 kg): 1-2 teaspoonful (5-10 ml) 3 times daily after meal or as prescribed by the physician.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Convit®Z is contraindicated in patients with known hypersensitivity to any of the ingredients of this product.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Drug should be discontinued to the patients with hypertensive to Vitamin-B complex.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: "Convit®Z is recommended during pregnancy & lactation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Convit®Z is usually well-tolerated. However, a few side- effects including nausea, vomiting, constipation or diarrhoea may occur.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "Zinc Sulphate is corrosive in overdose. Symptoms are corrosion and inflammation of the mucous membrane of the mouth and stomach.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Concomitant intake of tetracycline and Convit®Z may decrease the absorption of both tetracycline and zinc. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (below 30°C) and dry place. Keep away from light and out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Convit®Z 100 mI Syrup: Each bottle contains 100 mI syrup with a measuring cup.",
          "Convit®Z 100 mI Syrup: Each bottle contains 100 mI syrup with a measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 14,
    title: "Conzi 100 ml Syrup",
    therapeutic_class: "vitamin & minerals",
    text1: " ",
    text2: " ",
    imgf: conzi100fr,
    imge: conzi100bk,
    img: [
      {
        id: 14,
        imgf: conzi100fr,
        imge: conzi100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Conzi",
    innerComposition: "Zinc Sulphate",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Conzi® Syrup: Each 5 ml contains- Zinc Sulphate Monohydrate USP equivalent to 10 mg elemental Zinc.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Conzi® is the preparations of zinc which is an essential trace element and involved in a number of body enzyme systems. The body needs zinc for normal growth and health. Zinc is vital for growth and development, sexual maturation and reproduction, dark vision adaptation, olfactory and gustatory activity, insulin storage and release. Zinc deficiency may lead to impaired immune function, delayed wound healing, a decrease sense of taste and smell, a reduced ability to fight infections, poor night vision, increased risk of abortion, alopecia, mental lethargy, skin changes and poor development of reproductive organs.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData:
          "Conzi® is indicated in zinc deficiency and/or zinc losing conditions. It is indicated in the following conditions - Recurrent respiratory tract infections, Diarrhoea, Loss of appetite, Severe growth retardation, Deformed bone formation, Impaired immunological response, Acrodermatitsenteropathica, Parakeratatic skin lesions, Defective and delayed wound healing, Anaemia, Night blindness & Mental disturbances.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData:
          "Zinc supplements are most effective if it is taken at least 1 hour before or 2 hours after meal.",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Zinc supplements are most effective if it is taken at least 1 hour before or 2 hours after meal.",
          "Child between 10 - 30 kg: 10 ml (2 teaspoonful) 1-3 times daily.",
          "Adults and child over 30 kg: 20 ml (4 teaspoonful) 1-3 times daily.",
        ],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Zinc may cause nausea, vomiting, diarrhoea, stomach upset, heartburn and gastritis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "It is contraindicated in those who are hypersensitive to any component of the ingredient of this zinc containing supplement.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData:
          "Zinc is used during pregnancy and lactation at a dose of 20 mg per day. Zinc crosses the placenta and is present in breast milk.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "In acute renal failure zinc accumulation may occur; so doses adjustment is needed.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "Concomitant intake of a tetracycline and zinc may decrease the absorption of both the tetracycline and zinc. Similarly concomitant administration of zinc and quinolone may also decrease the absorption of both. Concomitant intake of penicillamine and zinc may depress absorption of zinc.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "Symptoms of overdose may include severe nausea, vomiting, dizziness, fainting and shortness of breath. If overdose is suspected, then contact with local poison control center or emergency room may be needed.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK:",
        innerData:
          "Conzi® Syrup: Bottle containing 100 ml syrup with a measuring cup.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 15,
    title: "Dapazin 5 Tablet",
    therapeutic_class: "anti-diabetic",
    text1: " ",
    text2: " ",
    imgf: dapazin5fr,
    imge: dapazin5bk,
    img: [
      {
        id: 15,
        imgf: dapazin5fr,
        imge: dapazin5bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Dapazin",
    innerComposition: "Dapagliflozin INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Dapazin® 5 tablet: Each film coated tablet contains Dapagliflozin INN 5 mg.",
          "Dapazin® 10 tablet: Each film coated tablet contains Dapagliflozin INN 10 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY:",
        innerData:
          "Dapazin® (Dapagliflozin) helps lower blood glucose levels by helping the body to filter more excess glucose out of the blood. Sodium-glucose co transporter 2 (SGLT2), expressed in the proximal renal tubules, is responsible for the majority of the re-absorption of filtered glucose from the tubular lumen. Dapagliflozin is an inhibitor of SGLT2. By inhibiting SGLT2, Dapagliflozin reduces reabsorption of filtered glucose and lowers the renal threshold for glucose, and thereby increases urinary glucose excretion.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Dapazin® (Dapagliflozin) is indicated as an adjunct to diet and exercise to improve glycemic control in adults with type 2 diabetes mellitus.Limitation of Use: Dapagliflozin is not recommended for  patients with type 1 diabetes mellitus or for the treatment of diabetic ketoacidosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "The recommended starting dose is 5 mg once daily, taken in the morning, with or without food.",
          "Dose can be increased to 10 mg once daily in patients who require additional glycemic control.",
          "Assess renal function before initiating Dapazin. Do not initiate Dapazin if eGFR is below 60 mL/min/1.73 m².",
          "Discontinue Dapazin if eGFR falls persistently below 60 mL/min/1.73 m².",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Dapagliflozin may cause female genital mycotic infections, nasopharyngitis and urinary tract infections.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Hypoglycemic Agents: May enhance the adverse/toxic effect of other hypoglycemic agents.",
          "Hypotensive Agents: May enhance the adverse/toxic effect of other hypotensive agents.",
          "Loop Diuretics: May diminish the hypoglycemic effect of hypoglycemic agents.",
          "MAO Inhibitors: May enhance the hypoglycemic effect of hypoglycemic agents.",
          "Selective Serotonin Reuptake Inhibitors:- May enhance the hypoglycemic effect of hypoglycemic agents.",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION:",
        innerData:
          "Pregnancy: There are no adequate well controlled studies in pregnant women. Use during pregnancy only if the potential benefit justifies the potential risk to fetus.Nursing mother: Discontinue Dapazin or discontinue nursing.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There were no reports of overdose during the clinical development program for Dapagliflozin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Dapazin® 5 tablet: Each box containing 2 X 14’s tablet in Alu-Alu blister strips.Dapazin® 10 tablet: Each box containing 1 X 14’s tablet in Alu-Alu blister strips.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 16,
    title: "Dapazin 10 Tablet",
    therapeutic_class: "anti-diabetic",
    text1: " ",
    text2: " ",
    imgf: dapazin10fr,
    imge: dapazin10bk,
    img: [
      {
        id: 16,
        imgf: dapazin10fr,
        imge: dapazin10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Dapazin 10",
    innerComposition: "Dapagliflozin INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Dapazin® 5 tablet: Each film coated tablet contains Dapagliflozin INN 5 mg.",
          "Dapazin® 10 tablet: Each film coated tablet contains Dapagliflozin INN 10 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY:",
        innerData:
          "Dapazin® (Dapagliflozin) helps lower blood glucose levels by helping the body to filter more excess glucose out of the blood. Sodium-glucose co transporter 2 (SGLT2), expressed in the proximal renal tubules, is responsible for the majority of the re-absorption of filtered glucose from the tubular lumen. Dapagliflozin is an inhibitor of SGLT2. By inhibiting SGLT2, Dapagliflozin reduces reabsorption of filtered glucose and lowers the renal threshold for glucose, and thereby increases urinary glucose excretion.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Dapazin® (Dapagliflozin) is indicated as an adjunct to diet and exercise to improve glycemic control in adults with type 2 diabetes mellitus.Limitation of Use: Dapagliflozin is not recommended for  patients with type 1 diabetes mellitus or for the treatment of diabetic ketoacidosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "The recommended starting dose is 5 mg once daily, taken in the morning, with or without food.",
          "Dose can be increased to 10 mg once daily in patients who require additional glycemic control.",
          "Assess renal function before initiating Dapazin. Do not initiate Dapazin if eGFR is below 60 mL/min/1.73 m².",
          "Discontinue Dapazin if eGFR falls persistently below 60 mL/min/1.73 m².",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Dapagliflozin may cause female genital mycotic infections, nasopharyngitis and urinary tract infections.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Hypoglycemic Agents: May enhance the adverse/toxic effect of other hypoglycemic agents.",
          "Hypotensive Agents: May enhance the adverse/toxic effect of other hypotensive agents.",
          "Loop Diuretics: May diminish the hypoglycemic effect of hypoglycemic agents.",
          "MAO Inhibitors: May enhance the hypoglycemic effect of hypoglycemic agents.",
          "Selective Serotonin Reuptake Inhibitors:- May enhance the hypoglycemic effect of hypoglycemic agents.",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION:",
        innerData:
          "Pregnancy: There are no adequate well controlled studies in pregnant women. Use during pregnancy only if the potential benefit justifies the potential risk to fetus.Nursing mother: Discontinue Dapazin or discontinue nursing.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There were no reports of overdose during the clinical development program for Dapagliflozin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData:
          "Dapazin® 5 tablet: Each box containing 2 X 14’s tablet in Alu-Alu blister strips.Dapazin® 10 tablet: Each box containing 1 X 14’s tablet in Alu-Alu blister strips.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 17,
    title: "Dopagut 10 Tablet",
    therapeutic_class: "gastroprokinetic",
    text1: " ",
    text2: " ",
    imgf: dopagut10fr,
    imge: dopagut10bk,
    img: [
      {
        id: 17,
        imgf: dopagut10fr,
        imge: dopagut10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Dopagut",
    innerComposition: "Domperidone BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Dopagut® Tablet: Each film coated tablet contains- Domperidone BP 10 mg as Domperidone Maleate BP. <br/>   Dopagut® Suspension: Each 5 ml Suspension contains- Domperidone BP 5 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Domperidone is a dopamine antagonist. It acts peripherally rather than central action; since it cannot readily enter the central nervous system due to blood brain barrier, its effects are confined to the periphery and acts principally at the receptor site in the chemoreceptor trigger zone.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Dyspeptic symptom complex, often associated with delayed gastric emptying, Gastroesophageal reflux and esophagitis: Epigastric sense of fullness, feeling of abdominal distension, upper abdominal pain Eructation, flatulence, early satiety, Nausea and vomiting, Heartburn with or without regurgitations of gastric contents in the mouth, Diabetic gastroparesis, Non-ulcer dyspepsia.<br/>   \tAcute nausea and vomiting of functional, organic, infectious, dietetic origin or induced by radiotherapy or drug therapy or induced in migraine.<br/>   \tParkinson's disease: In doparnine-agonist induced-nausea and vomiting.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Dopagut® should be taken 15-30 minutes before meals and, if necessary, before retiring.   The usual recommended oral dose of Domperidone is as follow:   Adults: 10-20 mg (1-2 Dopagut® tablet or 10-20 ml Dopagut® suspension) every 4-8 hours daily.   Children: 2-4 ml Dopagut® suspension/10 kg every 4-8 hours daily.   In dyspeptic symptom:   Adults: 10-20 mg (1-2 Dopagut® tablet or 10-20 ml Dopagut® suspension), every 4-8 hours daily.   Children: 0.2-0.4 mg/kg (2-4 ml Dopagut® suspension/10 kg) body weight, every 4-8 hours daily.   In acute and sub-acute conditions (mainly in acute nausea and vomiting):   Adults: 20 mg (2 Dopagut® tablet or 20 ml Dopagut® suspension), every 4-8 hours.   Children: 0.2-0.4 mg/kg (2-4 ml Dopagut® suspension/10 kg) body weigh; every 4-8 hours daily. (In acute nausea and vomiting maximum period of treatment is 12 weeks).",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Domperidone may produce hyperprolactinemia (1/3%). This may result in galactorrhea, breast enlargement, soreness and reduced libido. Dry mouth (1%), thirst, headache (1.2%), nervousness, drowsiness (0.4%), diarrhea (0.2%), skin rash and itching (0.1%) may occur during treatment with domperidone. Extrapyramidal reactions are seen in 0.05% of patients in clinical studies.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Domperidone should be used with absolute caution in case of children because there may be increased risk of extra-pyramidal reactions in young children because of an incompletely developed blood-brain barrier. Since domperidone is highly metabolized in liver, it should be used with caution in patient with hepatic impairment.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Domperidone is contraindicated to patients having known hypersensitivity to this drug and in case of neonates. Domperidone should not be used whenever gastro-intestinal stimulation might be dangerous i.e., gastrointestinal hemorrhage, mechanical obstruction or perforation. It is also contraindicated in patients with prolactin releasing pituitary tumor (prolactinoma).",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "  Pregnant woman: The safety of domperidone has not been proven and it is therefore not recommended during pregnancy. Animal studies have not demonstrated teratogenic effect in the fetus.     Lactating mother: Domperidone may precipitate galactorrhea and improve postnatal lactation. It is secreted in breast milk but in very small quantities insufficient to be considered harmful.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Apuldon may reduce the hypoprolactinemic effect of bromocriptine. The effect of antimuscarinics & opioid analgesics may antagonize Apuldon on GI function.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There is no specific antidote to domperidone, but in the event of overdose, standard symptomatic treatment should be given immediately. Gastric lavage as well as the administration of activated charcoal, may be useful. ECG monitoring should be undertaken, because of the possibility of QT interval prolongation. Close medical supervision and supportive therapy is recommended. Anticholinergic, anti-parkinson drugs may be helpful in controlling the extra pyramidal reactions.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Dopagut® Tablet: Box containing 10x10’s tablets, in blister strips.",
          "Dopagut® Suspension: Bottle containing 60 ml suspension.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 18,
    title: "Dopagut 60 ml Syrup",
    therapeutic_class: "gastroprokinetic",
    text1: " ",
    text2: " ",
    imgf: dopagut60fr,
    imge: dopagut60bk,
    img: [
      {
        id: 18,
        imgf: dopagut60fr,
        imge: dopagut60bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Dopagut",
    innerComposition: "Domperidone BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Dopagut® Tablet: Each film coated tablet contains- Domperidone BP 10 mg as Domperidone Maleate BP. <br/>   Dopagut® Suspension: Each 5 ml Suspension contains- Domperidone BP 5 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Domperidone is a dopamine antagonist. It acts peripherally rather than central action; since it cannot readily enter the central nervous system due to blood brain barrier, its effects are confined to the periphery and acts principally at the receptor site in the chemoreceptor trigger zone.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Dyspeptic symptom complex, often associated with delayed gastric emptying, Gastroesophageal reflux and esophagitis: Epigastric sense of fullness, feeling of abdominal distension, upper abdominal pain Eructation, flatulence, early satiety, Nausea and vomiting, Heartburn with or without regurgitations of gastric contents in the mouth, Diabetic gastroparesis, Non-ulcer dyspepsia.<br/>   \tAcute nausea and vomiting of functional, organic, infectious, dietetic origin or induced by radiotherapy or drug therapy or induced in migraine.<br/>   \tParkinson's disease: In doparnine-agonist induced-nausea and vomiting.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Dopagut® should be taken 15-30 minutes before meals and, if necessary, before retiring.   The usual recommended oral dose of Domperidone is as follow:   Adults: 10-20 mg (1-2 Dopagut® tablet or 10-20 ml Dopagut® suspension) every 4-8 hours daily.   Children: 2-4 ml Dopagut® suspension/10 kg every 4-8 hours daily.   In dyspeptic symptom:   Adults: 10-20 mg (1-2 Dopagut® tablet or 10-20 ml Dopagut® suspension), every 4-8 hours daily.   Children: 0.2-0.4 mg/kg (2-4 ml Dopagut® suspension/10 kg) body weight, every 4-8 hours daily.   In acute and sub-acute conditions (mainly in acute nausea and vomiting):   Adults: 20 mg (2 Dopagut® tablet or 20 ml Dopagut® suspension), every 4-8 hours.   Children: 0.2-0.4 mg/kg (2-4 ml Dopagut® suspension/10 kg) body weigh; every 4-8 hours daily. (In acute nausea and vomiting maximum period of treatment is 12 weeks).",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Domperidone may produce hyperprolactinemia (1/3%). This may result in galactorrhea, breast enlargement, soreness and reduced libido. Dry mouth (1%), thirst, headache (1.2%), nervousness, drowsiness (0.4%), diarrhea (0.2%), skin rash and itching (0.1%) may occur during treatment with domperidone. Extrapyramidal reactions are seen in 0.05% of patients in clinical studies.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Domperidone should be used with absolute caution in case of children because there may be increased risk of extra-pyramidal reactions in young children because of an incompletely developed blood-brain barrier. Since domperidone is highly metabolized in liver, it should be used with caution in patient with hepatic impairment.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Domperidone is contraindicated to patients having known hypersensitivity to this drug and in case of neonates. Domperidone should not be used whenever gastro-intestinal stimulation might be dangerous i.e., gastrointestinal hemorrhage, mechanical obstruction or perforation. It is also contraindicated in patients with prolactin releasing pituitary tumor (prolactinoma).",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATIO",
        innerData:
          "  Pregnant woman: The safety of domperidone has not been proven and it is therefore not recommended during pregnancy. Animal studies have not demonstrated teratogenic effect in the fetus.     Lactating mother: Domperidone may precipitate galactorrhea and improve postnatal lactation. It is secreted in breast milk but in very small quantities insufficient to be considered harmful.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Apuldon may reduce the hypoprolactinemic effect of bromocriptine. The effect of antimuscarinics & opioid analgesics may antagonize Apuldon on GI function.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There is no specific antidote to domperidone, but in the event of overdose, standard symptomatic treatment should be given immediately. Gastric lavage as well as the administration of activated charcoal, may be useful. ECG monitoring should be undertaken, because of the possibility of QT interval prolongation. Close medical supervision and supportive therapy is recommended. Anticholinergic, anti-parkinson drugs may be helpful in controlling the extra pyramidal reactions.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Dopagut® Tablet: Box containing 10x10’s tablets, in blister strips.",
          "Dopagut® Suspension: Bottle containing 60 ml suspension.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 19,
    title: "Doribac 100 ml Syrup",
    therapeutic_class: "antibiotic",
    text1: " ",
    text2: " ",
    imgf: doribac100fr,
    imge: doribac100bk,
    img: [
      {
        id: 19,
        imgf: doribac100fr,
        imge: doribac100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Doribac",
    innerComposition: "Flucloxacillin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® PFS:  Each 5 ml contains  Flucloxacillin Sodium BP equivalent to Flucloxacillin 125mg .",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Flucloxacillin is isoxazolyl penicillin of the beta-lactam group of antibiotics which exerts a bactericidal effect upon many gram-positive organism including beta- lactamase-producing staphylococcus and streptococci. It is not active against methicillin-resistant staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Flucloxacillin is indicated for the treatment of infections due to Gram-positive organisms, including infections caused by beta-lactamase producing staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "TYPICAL INDICATIONS INCLUDE",
        innerData:
          "Skin and soft tissue infections: Boils, abscesses, carbuncles, furunculosis, cellulitis; infected skin conditions, e.g. ulcer, eczema and acne; infected wounds, infected burns, protection for skin grafts and impetigo.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "RESPIRATORY TRACT INFECTIONS",
        innerData:
          "pneumonia, lung abscess, empyema, sinusitis, pharyngitis, tonsillitis, quinsy, otitis media and externa. Other infections caused by Flucloxacillin-sensitive organisms: osteomyelitis, enteritis, endocarditis, urinary tract infections, meningitis, septicaemia. Flucloxacillin is also indicated for use as a prophylactic agent during major surgical procedures where appropriate; for example, cardiothoracic and orthopaedic surgery.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Oral doses should be administered half to one hour before meals.Adult dosage (including elderly patients): 250 mg four times daily. In severe infections: dosage should be doubled. In osteomyelitis and endocarditis: up to 8 gm daily, in divided doses 6 to 8 hourly. In case of secondary bacterial infection in chicken pox. Flucloxacillin 500 mg 6 hourly should be prescribed.For Children: The usual dose for children of 1-3 year are 1/2 -1 teaspoonful (2.5-5 ml) of Doribac® Suspension 4 times daily and Children of 3-10 years: 1-2 teaspoonful (5-10 ml) Doribac® Suspension 4 times daily for 7-10 days according to severity of infections.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSE ADJUSTMENT IN RENAL IMPAIRMENT",
        innerData:
          "As common with other penicillins, Flucloxacillin usage in patients with renal impairment does not usually require dosage reduction. However, in the presence of severe renal failure (creatinine clearance < 10 ml/min) a reduction in dose or an extension of dose interval should be considered. Flucloxacillin is not significantly removed by dialysis and hence no supplementary dosage needs to be administered either during or at the end of the dialysis period.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Side effects as with other penicillin, are uncommon and mainly of a mild and transitory nature. Gastro-intestinal upsets (e.g. nausea, diarrhoea) and skin rashes have been reported. If skin rash occurs, treatment should be discontinued.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Flucloxacillin is contraindicated in patients with known hypersensitivity to Penicillin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Flucloxacillin should be given with caution to patients with a history of allergy of allergy, especially to drugs. before initiating therapy with Flucloxacillin, carefully enquiry should be made concerning previous hypersensitivity reaction to B lactums.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "The use of Flucloxacillin in pregnancy should be reserved for cases considered essential by the clinician. Use of the drug in the second and third trimesters may result in the sensitization of the fetus. During lactation, trace quantities of penicillins can be detected in breast milk.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "Problems of over dosage with Flucloxacillin are unlikely to occur, If encountered they may be symptomatically.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "The administration of Probenecid with Flucloxacillin results in higher serum peak concentrations and prolongs the time that therapeutic concentrations of Flucloxacillin are achieved in serum. Physical incompatibility and/or loss of activity of Flucloxacillin in solution has been reported when given with Gentamycin sulphate, Streptomycin sulphate, Vitamin mixtures. Flucloxacillin should not be added to intravenous lipids, blood products and protein hydrolysates or other proteinaceous fluids.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool ( Below 30⁰ C. Temp. ) and dry place, protected from light. Keep out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® 500 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® PFS : Each bottle contains -100 ml PFS with measuring Cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 20,
    title: "Doribac 250 Capsule",
    therapeutic_class: "antibiotic",
    text1: " ",
    text2: " ",
    imgf: doribac250fr,
        imge: doribac250bk,
    img: [
      {
        id: 20,
        imgf: doribac250fr,
        imge: doribac250bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Doribac",
    innerComposition: "Flucloxacillin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® PFS:  Each 5 ml contains  Flucloxacillin Sodium BP equivalent to Flucloxacillin 125mg .",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Flucloxacillin is isoxazolyl penicillin of the beta-lactam group of antibiotics which exerts a bactericidal effect upon many gram-positive organism including beta- lactamase-producing staphylococcus and streptococci. It is not active against methicillin-resistant staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Flucloxacillin is indicated for the treatment of infections due to Gram-positive organisms, including infections caused by beta-lactamase producing staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "TYPICAL INDICATIONS INCLUDE",
        innerData:
          "Skin and soft tissue infections: Boils, abscesses, carbuncles, furunculosis, cellulitis; infected skin conditions, e.g. ulcer, eczema and acne; infected wounds, infected burns, protection for skin grafts and impetigo.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "RESPIRATORY TRACT INFECTIONS",
        innerData:
          "pneumonia, lung abscess, empyema, sinusitis, pharyngitis, tonsillitis, quinsy, otitis media and externa. Other infections caused by Flucloxacillin-sensitive organisms: osteomyelitis, enteritis, endocarditis, urinary tract infections, meningitis, septicaemia. Flucloxacillin is also indicated for use as a prophylactic agent during major surgical procedures where appropriate; for example, cardiothoracic and orthopaedic surgery.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Oral doses should be administered half to one hour before meals.Adult dosage (including elderly patients): 250 mg four times daily. In severe infections: dosage should be doubled. In osteomyelitis and endocarditis: up to 8 gm daily, in divided doses 6 to 8 hourly. In case of secondary bacterial infection in chicken pox. Flucloxacillin 500 mg 6 hourly should be prescribed.For Children: The usual dose for children of 1-3 year are 1/2 -1 teaspoonful (2.5-5 ml) of Doribac® Suspension 4 times daily and Children of 3-10 years: 1-2 teaspoonful (5-10 ml) Doribac® Suspension 4 times daily for 7-10 days according to severity of infections.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSE ADJUSTMENT IN RENAL IMPAIRMENT",
        innerData:
          "As common with other penicillins, Flucloxacillin usage in patients with renal impairment does not usually require dosage reduction. However, in the presence of severe renal failure (creatinine clearance < 10 ml/min) a reduction in dose or an extension of dose interval should be considered. Flucloxacillin is not significantly removed by dialysis and hence no supplementary dosage needs to be administered either during or at the end of the dialysis period.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Side effects as with other penicillin, are uncommon and mainly of a mild and transitory nature. Gastro-intestinal upsets (e.g. nausea, diarrhoea) and skin rashes have been reported. If skin rash occurs, treatment should be discontinued.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Flucloxacillin is contraindicated in patients with known hypersensitivity to Penicillin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Flucloxacillin should be given with caution to patients with a history of allergy of allergy, especially to drugs. before initiating therapy with Flucloxacillin, carefully enquiry should be made concerning previous hypersensitivity reaction to B lactums.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "The use of Flucloxacillin in pregnancy should be reserved for cases considered essential by the clinician. Use of the drug in the second and third trimesters may result in the sensitization of the fetus. During lactation, trace quantities of penicillins can be detected in breast milk.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "Problems of over dosage with Flucloxacillin are unlikely to occur, If encountered they may be symptomatically.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "The administration of Probenecid with Flucloxacillin results in higher serum peak concentrations and prolongs the time that therapeutic concentrations of Flucloxacillin are achieved in serum. Physical incompatibility and/or loss of activity of Flucloxacillin in solution has been reported when given with Gentamycin sulphate, Streptomycin sulphate, Vitamin mixtures. Flucloxacillin should not be added to intravenous lipids, blood products and protein hydrolysates or other proteinaceous fluids.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool ( Below 30⁰ C. Temp. ) and dry place, protected from light. Keep out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® 500 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® PFS : Each bottle contains -100 ml PFS with measuring Cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 21,
    title: "Doribac 500 Capsule",
    therapeutic_class: "antibiotic",
    text1: " ",
    text2: " ",
    imgf: doribac500fr,
    imge: doribac500bk,
    img: [
      {
        id: 21,
        imgf: doribac500fr,
        imge: doribac500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Doribac",
    innerComposition: "Flucloxacillin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® 250 capsule: Each capsule contains Flucloxacillin sodium BP equivalent to Flucloxacillin 250 mg.",
          "Doribac® PFS:  Each 5 ml contains  Flucloxacillin Sodium BP equivalent to Flucloxacillin 125mg .",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Flucloxacillin is isoxazolyl penicillin of the beta-lactam group of antibiotics which exerts a bactericidal effect upon many gram-positive organism including beta- lactamase-producing staphylococcus and streptococci. It is not active against methicillin-resistant staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Flucloxacillin is indicated for the treatment of infections due to Gram-positive organisms, including infections caused by beta-lactamase producing staphylococcus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "TYPICAL INDICATIONS INCLUDE",
        innerData:
          "Skin and soft tissue infections: Boils, abscesses, carbuncles, furunculosis, cellulitis; infected skin conditions, e.g. ulcer, eczema and acne; infected wounds, infected burns, protection for skin grafts and impetigo.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "RESPIRATORY TRACT INFECTIONS",
        innerData:
          "pneumonia, lung abscess, empyema, sinusitis, pharyngitis, tonsillitis, quinsy, otitis media and externa. Other infections caused by Flucloxacillin-sensitive organisms: osteomyelitis, enteritis, endocarditis, urinary tract infections, meningitis, septicaemia. Flucloxacillin is also indicated for use as a prophylactic agent during major surgical procedures where appropriate; for example, cardiothoracic and orthopaedic surgery.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Oral doses should be administered half to one hour before meals.Adult dosage (including elderly patients): 250 mg four times daily. In severe infections: dosage should be doubled. In osteomyelitis and endocarditis: up to 8 gm daily, in divided doses 6 to 8 hourly. In case of secondary bacterial infection in chicken pox. Flucloxacillin 500 mg 6 hourly should be prescribed.For Children: The usual dose for children of 1-3 year are 1/2 -1 teaspoonful (2.5-5 ml) of Doribac® Suspension 4 times daily and Children of 3-10 years: 1-2 teaspoonful (5-10 ml) Doribac® Suspension 4 times daily for 7-10 days according to severity of infections.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSE ADJUSTMENT IN RENAL IMPAIRMENT",
        innerData:
          "As common with other penicillins, Flucloxacillin usage in patients with renal impairment does not usually require dosage reduction. However, in the presence of severe renal failure (creatinine clearance < 10 ml/min) a reduction in dose or an extension of dose interval should be considered. Flucloxacillin is not significantly removed by dialysis and hence no supplementary dosage needs to be administered either during or at the end of the dialysis period.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Side effects as with other penicillin, are uncommon and mainly of a mild and transitory nature. Gastro-intestinal upsets (e.g. nausea, diarrhoea) and skin rashes have been reported. If skin rash occurs, treatment should be discontinued.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Flucloxacillin is contraindicated in patients with known hypersensitivity to Penicillin.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Flucloxacillin should be given with caution to patients with a history of allergy of allergy, especially to drugs. before initiating therapy with Flucloxacillin, carefully enquiry should be made concerning previous hypersensitivity reaction to B lactums.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "The use of Flucloxacillin in pregnancy should be reserved for cases considered essential by the clinician. Use of the drug in the second and third trimesters may result in the sensitization of the fetus. During lactation, trace quantities of penicillins can be detected in breast milk.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSAGE",
        innerData:
          "Problems of over dosage with Flucloxacillin are unlikely to occur, If encountered they may be symptomatically.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "The administration of Probenecid with Flucloxacillin results in higher serum peak concentrations and prolongs the time that therapeutic concentrations of Flucloxacillin are achieved in serum. Physical incompatibility and/or loss of activity of Flucloxacillin in solution has been reported when given with Gentamycin sulphate, Streptomycin sulphate, Vitamin mixtures. Flucloxacillin should not be added to intravenous lipids, blood products and protein hydrolysates or other proteinaceous fluids.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool ( Below 30⁰ C. Temp. ) and dry place, protected from light. Keep out of reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Doribac® 250 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® 500 Capsule : Each box contains -7×4's capsule in Alu-Alu blister pack.",
          "Doribac® PFS : Each bottle contains -100 ml PFS with measuring Cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 22,
    title: "Erectus 10 Tablet",
    therapeutic_class: "pde",
    text1: " ",
    text2: " ",
    imgf: erectus10fr,
    imge: erectus10bk,
    img: [
      {
        id: 22,
        imgf: erectus10fr,
        imge: erectus10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Erectus",
    innerComposition: "Tadalafil INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Erectus-10 Tablet: Each film coated tablet contains- Tadalafil INN 10 mg.",
          "Erectus-20 Tablet: Each film coated tablet contains- Tadalafil INN 20 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Tadalafil is an inhibitor of phosphodiesterase type 5 (PDE5). The sexual stimulation causes the natural production of nitric oxide which releases required quantity of cGMP. PDE5 is present in the corpus cavernosum smooth muscle, vascular & visceral smooth muscle, kidney, lungs & pancreas. Tadalafil has no effect on penile blood flow in the absence of sexual stimulation. Tadalafil has no effect on penile blood flow in the absence of sexual stimulation. The effect of PDE5 inhibition on cGMP concentration in the corpus cavernosum and pulmonary arteries is also observed in the smooth muscle of the prostate, the bladder and their vascular supply.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION AND USAGE",
        innerData:
          "Tadalafil is indicated for the treatment of-• Erectile Dysfunction• Signs & symptoms of Benign Prostatic Hyperplasia (BPH) • Erectile Dysfunction with Benign Prostatic Hyperplasia",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData:
          "Erectile Dysfunction: For Use as Needed • The recommended starting dose of Tadalafil for use as needed in most patients is 10 mg, taken prior to anticipated sexual activity, without regard to food. It can be taken from 30 mins to 12 hours prior to sexual activity. The dose may be increased to 20 mg or decreased to 5 mg, based on individual efficacy and tolerability. The maximum recommended dosing frequency is once per day in most patients.For regular Once Daily Use • The recommended starting dose of Tadalafil for once daily use is 2.5 mg, taken at approximately the same time every day, without regard to timing of sexual activity. The Tadalafil dose for once daily use may be increased to 5 mg, based on individual efficacy and tolerability.  Sign & Symptoms of Benign Prostatic Hyperplasia: The recommended dose of Tadalafil for once daily use is 5 mg, taken at approximately the same time every day. Erectile Dysfunction with Benign Prostatic Hyperplasia  The recommended dose of Tadalafil for once daily use is 5 mg, taken at approximately the same time every day, without regard to timing of sexual activity. Renal Insufficiency: Use as Needed: • Mild (creatinine clearance 51 to 80 mL/min): No dose adjustment is required. • Moderate (creatinine clearance 31 to 50 mL/min): A starting dose of 5 mg not more than once per day is recommended, and the maximum dose should be limited to 10 mg not more than once in every 48 hours.• Severe (creatinine clearance <30 mL/min and on hemodialysis): The maximum recommended dose is 5 mg not more than once in every 72 hours. For Regular Once Daily Use: • Mild to moderate (creatinine clearance 31 to 80 mL/min): No dose adjustment is required. • Severe (creatinine clearance <30 mL/min and on hemodialysis): Tadalafil for regular once daily use is not recommended. Hepatic Impairment Use as Needed: • Mild or moderate: The dose should not exceed 10 mg once per day. • Severe: Not recommended. For Regular Once Daily Use: • Mild to moderate: Tadalafil for once daily use has not been extensively evaluated in patients with hepatic insufficiency. Therefore, caution is advised if Tadalafil for regular once daily use is prescribed to these patients.• Severe: Not recommended. Men with Diabetes: No dose adjustment is required in diabetic patients. Use in Children: Tadalafil should not be used in individuals below 18 years of age. Geriatrics: No dose adjustment is required in patients >65 years of age.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDEEFFECTS",
        innerData:
          "The most commonly reported adverse reactions are headache, dizziness, flushing and dyspepsia. Nasal congestion, back pain, myalgia, swelling of eyelids is uncommon adverse reactions. General: Hypersensitivity reactions including rash, urticaria, facial edema, Cardiovascular and cerebrovascular: Serious cardiovascular events, including myocardial infarction, sudden cardiac death, unstable angina pectoris, ventricular arrhythmia, stroke, transient ischemic attacks, chest pain, palpitations and tachycardia may occur. Most of the patients in whom these events have been reported had pre-existing cardiovascular risk factors. Hypotension (more commonly reported when Tadalafil is given to patients who are already taking antihypertensive agents), hypertension and syncope. Skin and subcutaneous tissues: hyperhydrosis (increased sweating). Gastrointestinal: abdominal pain and gastro-esophageal reflux disorder (GERD). Nervous system: migraine, transient global amnesia. Respiratory system: epistaxis. Special senses: blurred vision, non-arteritic anterior ischemic optic neuropathy, retinal vein occlusion, visual field defect. Otologic: Cases of sudden decrease or loss of hearing have been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Tadalafil is contraindicated in patients with a known hypersensitivity to it. Hypersensitivity reactions have been reported, including Stevens-Johnson syndrome and exfoliative dermatitis. Administration of Tadalafil to patients who are using any form of organic nitrate, either regularly and/or intermittently, is contraindicated. In clinical pharmacology studies, Tadalafil was shown to potentiate the hypotensive effect of nitrates. The following groups of patients with cardiovascular disease were not included in clinical trials and the use of Tadalafil is therefore contraindicated:  • Patients with myocardial infarction within the last 90 days. • Patients with unstable angina or angina occurring during sexual intercourse. • Patients with uncontrolled arrhythmias, hypotension (90/50 mmHg) or uncontrolled hypertension. • Patients with a stroke within the last 6 months.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData: "It is not indicated for use in women.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Prior to initiating any treatment for erectile dysfunction, physicians should consider the cardiovascular status of their patients, since there is a degree of cardiac risk associated with sexual activity. Tadalafil has vasodilator properties, resulting in mild and transient decreases in blood pressure. Tadalafil should not be administered to patients with hereditary problems of galactose intolerance. The safety and efficacy of combinations of Tadalafil and other treatments for erectile dysfunction have not been studied. Therefore, the use of such combinations is not recommended. Caution should be exercised when Tadalafil is administered to patients with anatomical deformation of the penis. There have been rare reports of prolonged erections greater than 4 hours and priapism (painful erections greater than 6 hours in duration) for this class of compounds. Priapism, if not treated promptly, can result in irreversible damage to the erectile tissue. Patients who have an erection lasting greater than 4 hours, whether painful or not, should seek emergency medical attention. Tadalafil should be used with caution in patients who have conditions that might predispose them to priapism (such as sickle cell anemia, multiple myeloma, or leukemia), or in patients with anatomical deformation of the penis (such as angulation, cavernosal fibrosis, or Peyronie's disease). Caution is advised when PDE5 inhibitors are co-administered with alpha blockers, renal insufficiency, hepatic impairment & consumption of alcohol.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Effects of other medicinal products on Tadalafil: Although specific interactions have not been studied CYP3A4 inhibitors, such as erythromycin, clarithromycin, itraconazole and grapefruit juice, should be co-administered with caution as they would be expected to increase plasma concentrations of Tadalafil. Concomitant administration of other CYP3A4 inducers, such as rifampicin, phenobarbital, phenytoin and carbamazepine, will also decrease plasma concentrations of Tadalafil. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
        isinnerSub: true,
        innerSubHead: "Effects of Tadalafil on other medicinal products:",
        innerSubData:
          "In clinical studies, Tadalafil (10 mg) was shown to augment the hypotensive effects of nitrates. Therefore, administration of Tadalafil to patients who are using any form of organic nitrate is contra-indicated. Concomitant administration of Tadalafil with the major  classes of antihypertensive agents were studied, including calcium channel blockers (amlodipine), angiotensin converting enzyme (ACE) inhibitors (enalapril), beta-adrenergic receptor blockers (metoprolol), thiazide diuretics (bendrofluazide), and angiotensin II receptor blockers, did  not affect the hypotensive effect of these drugs. ",
        isSublist: false,
        listSubData: [""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "Adverse events were similar to those seen at lower doses. In case of overdose, standard supportive measure should be adopted as required.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Erectus-10 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
          "Erectus-20 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 23,
    title: "Erectus 20 Tablet",
    therapeutic_class: "pde",
    text1: " ",
    text2: " ",
    imgf: erectus20fr,
    imge: erectus20bk,
    img: [
      {
        id: 23,
        imgf: erectus20fr,
        imge: erectus20bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Erectus",
    innerComposition: "Tadalafil INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Erectus-10 Tablet: Each film coated tablet contains- Tadalafil INN 10 mg.",
          "Erectus-20 Tablet: Each film coated tablet contains- Tadalafil INN 20 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Tadalafil is an inhibitor of phosphodiesterase type 5 (PDE5). The sexual stimulation causes the natural production of nitric oxide which releases required quantity of cGMP. PDE5 is present in the corpus cavernosum smooth muscle, vascular & visceral smooth muscle, kidney, lungs & pancreas. Tadalafil has no effect on penile blood flow in the absence of sexual stimulation. Tadalafil has no effect on penile blood flow in the absence of sexual stimulation. The effect of PDE5 inhibition on cGMP concentration in the corpus cavernosum and pulmonary arteries is also observed in the smooth muscle of the prostate, the bladder and their vascular supply.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION AND USAGE",
        innerData:
          "Tadalafil is indicated for the treatment of-• Erectile Dysfunction• Signs & symptoms of Benign Prostatic Hyperplasia (BPH) • Erectile Dysfunction with Benign Prostatic Hyperplasia",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData:
          "Erectile Dysfunction: For Use as Needed • The recommended starting dose of Tadalafil for use as needed in most patients is 10 mg, taken prior to anticipated sexual activity, without regard to food. It can be taken from 30 mins to 12 hours prior to sexual activity. The dose may be increased to 20 mg or decreased to 5 mg, based on individual efficacy and tolerability. The maximum recommended dosing frequency is once per day in most patients.For regular Once Daily Use • The recommended starting dose of Tadalafil for once daily use is 2.5 mg, taken at approximately the same time every day, without regard to timing of sexual activity. The Tadalafil dose for once daily use may be increased to 5 mg, based on individual efficacy and tolerability.  Sign & Symptoms of Benign Prostatic Hyperplasia: The recommended dose of Tadalafil for once daily use is 5 mg, taken at approximately the same time every day. Erectile Dysfunction with Benign Prostatic Hyperplasia  The recommended dose of Tadalafil for once daily use is 5 mg, taken at approximately the same time every day, without regard to timing of sexual activity. Renal Insufficiency: Use as Needed: • Mild (creatinine clearance 51 to 80 mL/min): No dose adjustment is required. • Moderate (creatinine clearance 31 to 50 mL/min): A starting dose of 5 mg not more than once per day is recommended, and the maximum dose should be limited to 10 mg not more than once in every 48 hours.• Severe (creatinine clearance <30 mL/min and on hemodialysis): The maximum recommended dose is 5 mg not more than once in every 72 hours. For Regular Once Daily Use: • Mild to moderate (creatinine clearance 31 to 80 mL/min): No dose adjustment is required. • Severe (creatinine clearance <30 mL/min and on hemodialysis): Tadalafil for regular once daily use is not recommended. Hepatic Impairment Use as Needed: • Mild or moderate: The dose should not exceed 10 mg once per day. • Severe: Not recommended. For Regular Once Daily Use: • Mild to moderate: Tadalafil for once daily use has not been extensively evaluated in patients with hepatic insufficiency. Therefore, caution is advised if Tadalafil for regular once daily use is prescribed to these patients.• Severe: Not recommended. Men with Diabetes: No dose adjustment is required in diabetic patients. Use in Children: Tadalafil should not be used in individuals below 18 years of age. Geriatrics: No dose adjustment is required in patients >65 years of age.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDEEFFECTS",
        innerData:
          "The most commonly reported adverse reactions are headache, dizziness, flushing and dyspepsia. Nasal congestion, back pain, myalgia, swelling of eyelids is uncommon adverse reactions. General: Hypersensitivity reactions including rash, urticaria, facial edema, Cardiovascular and cerebrovascular: Serious cardiovascular events, including myocardial infarction, sudden cardiac death, unstable angina pectoris, ventricular arrhythmia, stroke, transient ischemic attacks, chest pain, palpitations and tachycardia may occur. Most of the patients in whom these events have been reported had pre-existing cardiovascular risk factors. Hypotension (more commonly reported when Tadalafil is given to patients who are already taking antihypertensive agents), hypertension and syncope. Skin and subcutaneous tissues: hyperhydrosis (increased sweating). Gastrointestinal: abdominal pain and gastro-esophageal reflux disorder (GERD). Nervous system: migraine, transient global amnesia. Respiratory system: epistaxis. Special senses: blurred vision, non-arteritic anterior ischemic optic neuropathy, retinal vein occlusion, visual field defect. Otologic: Cases of sudden decrease or loss of hearing have been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Tadalafil is contraindicated in patients with a known hypersensitivity to it. Hypersensitivity reactions have been reported, including Stevens-Johnson syndrome and exfoliative dermatitis. Administration of Tadalafil to patients who are using any form of organic nitrate, either regularly and/or intermittently, is contraindicated. In clinical pharmacology studies, Tadalafil was shown to potentiate the hypotensive effect of nitrates. The following groups of patients with cardiovascular disease were not included in clinical trials and the use of Tadalafil is therefore contraindicated:  • Patients with myocardial infarction within the last 90 days. • Patients with unstable angina or angina occurring during sexual intercourse. • Patients with uncontrolled arrhythmias, hypotension (90/50 mmHg) or uncontrolled hypertension. • Patients with a stroke within the last 6 months.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData: "It is not indicated for use in women.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Prior to initiating any treatment for erectile dysfunction, physicians should consider the cardiovascular status of their patients, since there is a degree of cardiac risk associated with sexual activity. Tadalafil has vasodilator properties, resulting in mild and transient decreases in blood pressure. Tadalafil should not be administered to patients with hereditary problems of galactose intolerance. The safety and efficacy of combinations of Tadalafil and other treatments for erectile dysfunction have not been studied. Therefore, the use of such combinations is not recommended. Caution should be exercised when Tadalafil is administered to patients with anatomical deformation of the penis. There have been rare reports of prolonged erections greater than 4 hours and priapism (painful erections greater than 6 hours in duration) for this class of compounds. Priapism, if not treated promptly, can result in irreversible damage to the erectile tissue. Patients who have an erection lasting greater than 4 hours, whether painful or not, should seek emergency medical attention. Tadalafil should be used with caution in patients who have conditions that might predispose them to priapism (such as sickle cell anemia, multiple myeloma, or leukemia), or in patients with anatomical deformation of the penis (such as angulation, cavernosal fibrosis, or Peyronie's disease). Caution is advised when PDE5 inhibitors are co-administered with alpha blockers, renal insufficiency, hepatic impairment & consumption of alcohol.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Effects of other medicinal products on Tadalafil: Although specific interactions have not been studied CYP3A4 inhibitors, such as erythromycin, clarithromycin, itraconazole and grapefruit juice, should be co-administered with caution as they would be expected to increase plasma concentrations of Tadalafil. Concomitant administration of other CYP3A4 inducers, such as rifampicin, phenobarbital, phenytoin and carbamazepine, will also decrease plasma concentrations of Tadalafil. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
        isinnerSub: true,
        innerSubHead: "Effects of Tadalafil on other medicinal products:",
        innerSubData:
          "In clinical studies, Tadalafil (10 mg) was shown to augment the hypotensive effects of nitrates. Therefore, administration of Tadalafil to patients who are using any form of organic nitrate is contra-indicated. Concomitant administration of Tadalafil with the major  classes of antihypertensive agents were studied, including calcium channel blockers (amlodipine), angiotensin converting enzyme (ACE) inhibitors (enalapril), beta-adrenergic receptor blockers (metoprolol), thiazide diuretics (bendrofluazide), and angiotensin II receptor blockers, did  not affect the hypotensive effect of these drugs. ",
        isSublist: false,
        listSubData: [""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData:
          "Adverse events were similar to those seen at lower doses. In case of overdose, standard supportive measure should be adopted as required.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Erectus-10 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
          "Erectus-20 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 24,
    title: "Esmax 20 Capsule",
    therapeutic_class: "anti-ulcerant",
    text1: " ",
    text2: " ",
    imgf: esmax20fr,
    imge: esmax20bk,
    img: [
      {
        id: 24,
        imgf: esmax20fr,
        imge: esmax20bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Esmax 20",
    innerComposition: "Esomeprazole USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Esmax® 20 Capsule: Each capsule contains 20 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP in enteric coated pellets.",
          "Esmax® 20 Tablet: Each enteric coated tablet contains 20 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP.",
          "Esmax® 40 Capsule: Each capsule contains 40 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP in enteric coated pellets.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Esomeprazole is the s-isomer of Omeprazole. It is a proton pump inhibitor that suppresses gastric acid secretion by specific inhibition of the H+/K+-ATPase in the gastric parietal cell. By acting specifically on the proton pump, Esomeprazole blocks the final step in acid production, thus reducing gastric acidity. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Gastro-esophageal reflux disease (in the presence of erosive reflux esophagitis)",
          "Symptomatic treatment of Gastro-esophageal reflux disease (in the absence of esophagitis)",
          "NSAID associated gastric ulcer",
          "Duodenal ulcer associated with Helicobacter pylori",
          "Zollinger-Ellison syndrome",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Esomeprazole should be taken one hour before meal. According to disease pattern, the recommended dosage & administration:",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Gastro-esophageal reflux disease (in the presence of erosive reflux esophagitis), 40 mg once daily for 4 weeks, continued for further 4 weeks if not fully healed or symptoms persist",
          "Symptomatic treatment of Gastro-esophageal reflux disease (in the absence of esophagitis), 20 mg once daily for up to 4 weeks, then 20 mg daily when required",
          "NSAID associated gastric ulcer, 20 mg once daily for 4-8 weeks",
          "Duodenal ulcer associated with Helicobacter pylori:",
        ],
      },
      {
        innerHead:
          "Recommended regimens for Helicobacter pylori eradication in adults",
        innerData: ``,
        istable: true,
        table: {
          headers: [
            "Acid suppressant (Antibacterial)",
            "Amoxicillin",
            "Clarithromycin",
            "Metronidazole",
          ],
          body: [
            [
              "Esomeprazole 20 mg twice daily",
              "1 g twice daily",
              `500 mg twice daily`,
              `-------------`,
            ],
            ["", `-------------`, "250 mg twice daily", `400 mg twice daily`],
          ],
        },
        islist: true,
        listData: [
          "Zollinger-Ellison syndrome, initially 40 mg twice daily, adjusted according to response; usual range 80-160 mg daily",
          "Usual pediatric dose for Gastro-esophageal reflux disease:Short-term treatment: 1-11 years old: 10 mg once daily for up to 8 weeks, 12-17 years old: 20-40 mg once daily for up to 8 weeks",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Headache, flatulence, nausea, abdominal pain, diarrhea, dry mouth, dizziness/vertigo and constipation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Patients with known hypersensitivity to any component of the formulation. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Symptomatic response to therapy with Esomeprazole does not preclude the presence of gastric malignancy. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN SPECIAL GROUP",
        innerData:
          "Pregnancy: The safety of esomeprazole in pregnancy has not been established but esomeprazole can be used during pregnancy only if clearly needed.Lactation: The excretion of Esomeprazole in breast milk has not been studied. A decision should be made whether to discontinue nursing or to discontinue the drug, taking into account the importance of the drug to the mother.Pediatric use: Safety and efficacy have been established for the short-term treatment of GERD in patients of 1-17 years of age.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "Esomeprazole inhibits gastric acid secretion. Therefore, Esomeprazole may interfere with the absorption of drugs where gastric pH is an important determinant of bioavailability (e.g. Ketoconazole, Iron salts and Digoxin). ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Esmax® 20 Capsule: Each box contains 10 x 10 capsules, in Alu-Alu blister pack.",
          "Esmax® 20 Tablet: Each box contains 6 x 10 capsules, in Alu-Alu blister pack.",
          "Esmax® 40 Capsule: Each box contains 5 x 4 capsules, in Alu-Alu blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 25,
    title: "Esmax 40 Capsule",
    therapeutic_class: "anti-ulcerant",
    text1: " ",
    text2: " ",
    imgf: esmax40fr,
    imge: esmax40bk,
    img: [
      {
        id: 25,
        imgf: esmax40fr,
        imge: esmax40bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Esmax 40",
    innerComposition: "Esomeprazole USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Esmax® 20 Capsule: Each capsule contains 20 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP in enteric coated pellets.",
          "Esmax® 20 Tablet: Each enteric coated tablet contains 20 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP.",
          "Esmax® 40 Capsule: Each capsule contains 40 mg of Esomeprazole as Esomeprazole Magnesium Trihydrate USP in enteric coated pellets.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Esomeprazole is the s-isomer of Omeprazole. It is a proton pump inhibitor that suppresses gastric acid secretion by specific inhibition of the H+/K+-ATPase in the gastric parietal cell. By acting specifically on the proton pump, Esomeprazole blocks the final step in acid production, thus reducing gastric acidity. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Gastro-esophageal reflux disease (in the presence of erosive reflux esophagitis)",
          "Symptomatic treatment of Gastro-esophageal reflux disease (in the absence of esophagitis)",
          "NSAID associated gastric ulcer",
          "Duodenal ulcer associated with Helicobacter pylori",
          "Zollinger-Ellison syndrome",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Esomeprazole should be taken one hour before meal. According to disease pattern, the recommended dosage & administration:",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Gastro-esophageal reflux disease (in the presence of erosive reflux esophagitis), 40 mg once daily for 4 weeks, continued for further 4 weeks if not fully healed or symptoms persist",
          "Symptomatic treatment of Gastro-esophageal reflux disease (in the absence of esophagitis), 20 mg once daily for up to 4 weeks, then 20 mg daily when required",
          "NSAID associated gastric ulcer, 20 mg once daily for 4-8 weeks",
          "Duodenal ulcer associated with Helicobacter pylori:",
        ],
      },
      {
        innerHead:
          "Recommended regimens for Helicobacter pylori eradication in adults",
        innerData: ``,
        istable: true,
        table: {
          headers: [
            "Acid suppressant (Antibacterial)",
            "Amoxicillin",
            "Clarithromycin",
            "Metronidazole",
          ],
          body: [
            [
              "Esomeprazole 20 mg twice daily",
              "1 g twice daily",
              `500 mg twice daily`,
              `-------------`,
            ],
            ["", `-------------`, "250 mg twice daily", `400 mg twice daily`],
          ],
        },
        islist: true,
        listData: [
          "Zollinger-Ellison syndrome, initially 40 mg twice daily, adjusted according to response; usual range 80-160 mg daily",
          "Usual pediatric dose for Gastro-esophageal reflux disease:Short-term treatment: 1-11 years old: 10 mg once daily for up to 8 weeks, 12-17 years old: 20-40 mg once daily for up to 8 weeks",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData:
          "Headache, flatulence, nausea, abdominal pain, diarrhea, dry mouth, dizziness/vertigo and constipation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Patients with known hypersensitivity to any component of the formulation. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "Symptomatic response to therapy with Esomeprazole does not preclude the presence of gastric malignancy. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN SPECIAL GROUP",
        innerData:
          "Pregnancy: The safety of esomeprazole in pregnancy has not been established but esomeprazole can be used during pregnancy only if clearly needed.Lactation: The excretion of Esomeprazole in breast milk has not been studied. A decision should be made whether to discontinue nursing or to discontinue the drug, taking into account the importance of the drug to the mother.Pediatric use: Safety and efficacy have been established for the short-term treatment of GERD in patients of 1-17 years of age.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "Esomeprazole inhibits gastric acid secretion. Therefore, Esomeprazole may interfere with the absorption of drugs where gastric pH is an important determinant of bioavailability (e.g. Ketoconazole, Iron salts and Digoxin). ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Esmax® 20 Capsule: Each box contains 10 x 10 capsules, in Alu-Alu blister pack.",
          "Esmax® 20 Tablet: Each box contains 6 x 10 capsules, in Alu-Alu blister pack.",
          "Esmax® 40 Capsule: Each box contains 5 x 4 capsules, in Alu-Alu blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 26,
    title: "Fexocon 120 Tablet",
    therapeutic_class: "anti-histamine",
    text1: " ",
    text2: " ",
    imgf: fexocon120fr,
    imge: fexocon120bk,
    img: [
      {
        id: 26,
        imgf: fexocon120fr,
        imge: fexocon120bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Fexocon",
    innerComposition: "Fexofenadine Hydrochloride USP",
    innerdata: [
      {
        innerHead: "COMPOSITIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Fexocon®120 Tablet: Each film coated tablet contains Fexofenadine Hydrochloride USP 120 mg. ",
          "Fexocon®180 Tablet: Each film coated tablet contains Fexofenadine Hydrochloride USP 180 mg. ",
          "Fexocon® Suspension: Each 5 ml suspension contains Fexofenadine Hydrochloride USP 30 mg. ",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Fexocon® is a preparation of Fexofenadine Hydrochloride. It is an orally active non- sedating H1-receptor antagonist and is effective for the relief of symptoms associated with allergic rhinitis. It inhibits antigen-induced bronchospasm. Fexofenadine Hydrochloride is rapidly absorbed after oral doses with peak plasma concentrations being reached in 1-3 hours. It is about 60 to 75% bound to plasma proteins.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "MODE OF ACTION",
        innerData:
          "Fexofenadine Hydrochloride plays its antihistamine role by its selective peripheral H1- receptor antagonist activity. It inhibits histamine release from peritoneal mast cells. No anticholinergic, alpha-adrenergic or beta-adrenergic receptor blocking effects were observed. No sedative or other CNS effects observed. Fexofenadine does not cross BBB.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Relief of symptoms associated with seasonal allergic rhinitis.",
          "Relief of symptoms associated with seasonal allergic rhinitis.",
          "Relief of symptoms associated with perennial allergic rhinitis.",
        ],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: true,
        table: {
          headers: [
            "Patient Population",
            "Fexocon® tablets",
            "Fexocon® oral suspension",
          ],
          body: [
            [
              "Adults and children >12 years",
              `60 mg twice daily1,
            or 120 mg once daily
            or 180 mg once daily1
            `,
              "N/A",
            ],
            [
              "Adults and children >12 years",
              `60 mg twice daily1,
            or 120 mg once daily
            or 180 mg once daily1
            `,
              "N/A",
            ],
            [
              "Children 6 to 11 years",
              "30 mg twice daily1",
              "30 mg twice daily1",
            ],
            ["Children 2 to 5 years", "N/A", "30 mg twice daily1"],
            [
              "Children 6 months to less than 2 years",
              "N/A",
              "15 mg twice daily1.3",
            ],
          ],
        },
        islist: true,
        listData: [
          "Starting dose in patients with decreased renal function should be the recommended dose indicated above but administered once daily.",
          "dose not for use in patients with decreased renal function",
          "indicated for chronic idiopathic urticaria only",
        ],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Fexocon® is contraindicated in patients with known hypersensitivity to active ingredient.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Common side effects are abdominal discomfort, diarrhoea, nausea & vomiting, headache, back pain, dizziness and pain in extremity.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Fexofenadine Hydrochloride should not be taken closely in time with aluminum and magnesium containing antacids. Co-administration of Fexofenadine Hydrochloride with either ketoconazole or erythromycin led to increased plasma concentrations of fexofenadine in healthy adult subjects. Fruit juices such as grapefruit, orange and apple may reduce the bioavailability and exposure of Fexofenadine.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Pregnancy Category C. There are no adequate and well-controlled studies in pregnant women. Fexofenadine Hydrochloride should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus. It is not known if Fexofenadine Hydrochloride is excreted in human milk. There are no adequate and well- controlled studies in women during lactation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Fexocon® 120 Tablet: Box containing 3 x 10’s tablets in blister pack.",
          "Fexocon® 120 Tablet: Box containing 3 x 10’s tablets in blister pack.",
          "Fexocon® Suspension: Bottle containing 50 ml suspension. Each 5 ml contains Fexofenadine hydrochloride USP 30mg.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 27,
    title: "Fexocon 180 Tablet",
    therapeutic_class: "anti-histamine",
    text1: " ",
    imgf: fexocon180fr,
    imge: fexocon180bk,
    text2: " ",
    img: [
      {
        id: 27,
        imgf: fexocon180fr,
        imge: fexocon180bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Fexocon 180",
    innerComposition: "Fexofenadine Hydrochloride USP",
    innerdata: [
      {
        innerHead: "COMPOSITIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Fexocon®120 Tablet: Each film coated tablet contains Fexofenadine Hydrochloride USP 120 mg. ",
          "Fexocon®180 Tablet: Each film coated tablet contains Fexofenadine Hydrochloride USP 180 mg. ",
          "Fexocon® Suspension: Each 5 ml suspension contains Fexofenadine Hydrochloride USP 30 mg. ",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Fexocon® is a preparation of Fexofenadine Hydrochloride. It is an orally active non- sedating H1-receptor antagonist and is effective for the relief of symptoms associated with allergic rhinitis. It inhibits antigen-induced bronchospasm. Fexofenadine Hydrochloride is rapidly absorbed after oral doses with peak plasma concentrations being reached in 1-3 hours. It is about 60 to 75% bound to plasma proteins.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "MODE OF ACTION",
        innerData:
          "Fexofenadine Hydrochloride plays its antihistamine role by its selective peripheral H1- receptor antagonist activity. It inhibits histamine release from peritoneal mast cells. No anticholinergic, alpha-adrenergic or beta-adrenergic receptor blocking effects were observed. No sedative or other CNS effects observed. Fexofenadine does not cross BBB.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Relief of symptoms associated with seasonal allergic rhinitis.",
          "Relief of symptoms associated with seasonal allergic rhinitis.",
          "Relief of symptoms associated with perennial allergic rhinitis.",
        ],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: true,
        table: {
          headers: [
            "Patient Population",
            "Fexocon® tablets",
            "Fexocon® oral suspension",
          ],
          body: [
            [
              "Adults and children >12 years",
              `60 mg twice daily1,
            or 120 mg once daily
            or 180 mg once daily1
            `,
              "N/A",
            ],
            [
              "Adults and children >12 years",
              `60 mg twice daily1,
            or 120 mg once daily
            or 180 mg once daily1
            `,
              "N/A",
            ],
            [
              "Children 6 to 11 years",
              "30 mg twice daily1",
              "30 mg twice daily1",
            ],
            ["Children 2 to 5 years", "N/A", "30 mg twice daily1"],
            [
              "Children 6 months to less than 2 years",
              "N/A",
              "15 mg twice daily1.3",
            ],
          ],
        },
        islist: true,
        listData: [
          "Starting dose in patients with decreased renal function should be the recommended dose indicated above but administered once daily.",
          "dose not for use in patients with decreased renal function",
          "indicated for chronic idiopathic urticaria only",
        ],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Fexocon® is contraindicated in patients with known hypersensitivity to active ingredient.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Common side effects are abdominal discomfort, diarrhoea, nausea & vomiting, headache, back pain, dizziness and pain in extremity.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Fexofenadine Hydrochloride should not be taken closely in time with aluminum and magnesium containing antacids. Co-administration of Fexofenadine Hydrochloride with either ketoconazole or erythromycin led to increased plasma concentrations of fexofenadine in healthy adult subjects. Fruit juices such as grapefruit, orange and apple may reduce the bioavailability and exposure of Fexofenadine.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Pregnancy Category C. There are no adequate and well-controlled studies in pregnant women. Fexofenadine Hydrochloride should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus. It is not known if Fexofenadine Hydrochloride is excreted in human milk. There are no adequate and well- controlled studies in women during lactation.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Fexocon® 120 Tablet: Box containing 3 x 10’s tablets in blister pack.",
          "Fexocon® 120 Tablet: Box containing 3 x 10’s tablets in blister pack.",
          "Fexocon® Suspension: Bottle containing 50 ml suspension. Each 5 ml contains Fexofenadine hydrochloride USP 30mg.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 28,
    title: "Flunapen 50 Capsule",
    text1: " ",
    therapeutic_class: "anti-fungal",
    text2: " ",
    imgf: flunapen50fr,
    imge: flunapen50bk,
    img: [
      {
        id: 28,
        imgf: flunapen50fr,
        imge: flunapen50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Flunapen 50",
    innerComposition: "Fluconazole",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Flunapen ® 50 Capsule: Each Capsule Contains Fluconazole USP 50 mg.",
          "Flunapen ® 150 Capsule: Each Capsule Contains Fluconazole USP 150 mg.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Fluconazole is a triazole antifungal agent. It is a potent and selective inhibitor of fungal cytochrome P-450 dependent enzymes necessary for the synthesis of ergosterol.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Fluconazole is well absorbed following oral administration. Bioavailability from the oral route is 90%. Mean peak plasma concentration of 6.72 pg per ml have been reported in healthy subjects following a 400 mg oral dose. Peak concentrations are reached within 1 to 2 hours of oral administration. The elimination phase half life ranges from 20 to 50 hours. Fluconazole is widely distributed and achieves concentration in joint fluid, saliva, sputum, vaginal fluids, and peritoneal fluid similar to those achieved in plasma. Concentration in the cerebrospinal fluid range from 50 to 90% of plasma concentrations. Protein binding is about 11%. 80% or more of Fluconazole is excreted unchanged in the urine. Fluconazole can be removed by dialysis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS AND DOSAGE",
        innerData:
          "The daily dose should be based on the nature and severity of the fungal infection. Most cases of fungal infections require multiple dose therapy. Treatment should be continued until clinical parameters or laboratory tests indicate that active fungal infection has subsided. An inadequate period of treatment may lead to recurrence of active infection. Immuno compromised patients usually require maintenance therapy to prevent relapse.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIAGNOSIS",
        innerData:
          "Vaginal Candidiasis, Oropharyngeal Candidiasis, Oesophageal Candidiasis, Systemic Candidiasis & Cryptococcal infection, Tinea corporis/Tinea cruris/Tinea pedis/OtherTinea, Kerion, Pityriasis versicolor, Onychomycosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "RECOMMENDED DOSAGE",
        innerData:
          "150 mg as a single dose, 200 mg in 1st day followed by 100 mg daily for 14 days. 200 mg in 1st day followed by 100 mg daily for 14-30 days. 400 mg in 1st day followed by 200 mg daily for 28 days or longer based on clinical response. 150 mg weekly for 4-6 weeks. 50 mg daily for 20 days. 400 mg as a single dose. 150 mg weekly for 12 months. Child over 1 year In Superficial Candidiasis 1-2 mg/kg daily In Systemic Candidiasis & Cryptococcal infection 3-6 mg/kg daily In serious life threatening infections upto 12 mg/kg daily has been given to children aged 5-13 years (Maximum 400 mg daily).",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OTHER USES",
        innerData:
          "Fungal urinary tract infections, ii. Disseminated candidiasis, iii. Prophylaxis for fungal infection in neutropenic cancer patients, iv. Acute treatment of other systemic fungal infections such as coccidioidomycosis and histoplasmosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN THE ELDERLY",
        innerData:
          "The normal dose should be used if there is no evidence of renal impairment.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN CHILDREN",
        innerData:
          "Few formal studies have been done in children. Doses of 3-6 mg/kg daily have been used without serious adverse reactions being reported. Renal clearance in children may be proportionately more rapid than in adults and doses up to 12 mg/kg is recommended.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON LIVER",
        innerData:
          "For the liver as a potential target organ, the available data indicates that, Fluconazole is not predictable hepatotoxic drug in man. In man, including those with existing hypercholesterolaemia, serum cholesterol is not adversely affected by Fluconazole.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON PREGNANT WOMEN",
        innerData:
          "Adverse foetal effects have been seen in animals only at doses ranging from 80 mg/kg to 320 mg/kg with maternal toxicity. These levels are 20-60 times the recommended therapeutic use. Still Fluconazole should be used in pregnancy only if the potential benefit justifies the possible risk to the foetus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON LACTATING MOTHERS",
        innerData:
          "Fluconazole is secreted in human milk at concentrations similar to plasma. Therefore, the use of Fluconazole in nursing mother is not recommended. Contraindications Fluconazole should not be used in patients with known hypersensitivity to Fluconazole or to related triazole compounds.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Fluconazole acts by inhibiting fungal cytochrome P-450 enzymes. It is much less active against mammalian P-450 enzymes, still potential exists for interaction with drugs that are metabolized by P-450, a. Cyclosporin Some data suggest that Fluconazole increases cyclosporin levels, b. Phenytoin Fluconazole significantly increases phenytoin levels, c. Anticoagulants Fluconazole has shown to prolong prothrombin time in subjects receiving warfarin, d. Oral hypoglycaemics Fluconazole has been shown to prolong the serum half life of concomitantly administered Tolbutamide. However no adverse effect on serum glucose levels was seen. e. Rifampicin Decreases levels of Fluconazole, f. Oral contraceptives No clinically significant interactions have been seen.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "ADVERSE EFFECTS",
        innerData:
          "Therapy with Fluconazole is well tolerated. In 4000 patients receiving Fluconazole for various indications and for durations of 7 days or more, the incidence of side effects were 16% . Only 1.5% of subjects required discontinuation of medication. The most common adverse events were related to the gastro-intestinal system: nausea (3.7%), abdominal pain (1.17%), vomiting (1.7%) and diarrhoea (1.5%). Headache (1.9%) and skin rash (1.8%) were also seen.lt should be noted that approximately one third of this group were patients with AIDS and severe systemic disorders. Therefore the data may not be applicable to patients receiving Fluconazole for the treatment of superficial mycoses.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "In the case of overdose, supportive measures and gastric lavage should be instituted. If deemed necessary, a 3 hrshaemodialysis will decrease plasma levels by about 50%.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Flunapen ® 50 Capsule: Box Containing 3x10’s Capsule in Alu Alu Blister Pack.",
          "Flunapen ® 50 Capsule: Box Containing 3x10’s Capsule in Alu Alu Blister Pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 29,
    title: "Flunapen 150 Capsule",
    therapeutic_class: "anti-fungal",
    text1: " ",
    text2: " ",
    imgf: flunapen150fr,
        imge: flunapen150bk,
    img: [
      {
        id: 29,
        imgf: flunapen150fr,
        imge: flunapen150bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Flunapen 150",
    innerComposition: "Fluconazole",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Flunapen ® 50 Capsule: Each Capsule Contains Fluconazole USP 50 mg.",
          "Flunapen ® 150 Capsule: Each Capsule Contains Fluconazole USP 150 mg.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData:
          "Fluconazole is a triazole antifungal agent. It is a potent and selective inhibitor of fungal cytochrome P-450 dependent enzymes necessary for the synthesis of ergosterol.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },

      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Fluconazole is well absorbed following oral administration. Bioavailability from the oral route is 90%. Mean peak plasma concentration of 6.72 pg per ml have been reported in healthy subjects following a 400 mg oral dose. Peak concentrations are reached within 1 to 2 hours of oral administration. The elimination phase half life ranges from 20 to 50 hours. Fluconazole is widely distributed and achieves concentration in joint fluid, saliva, sputum, vaginal fluids, and peritoneal fluid similar to those achieved in plasma. Concentration in the cerebrospinal fluid range from 50 to 90% of plasma concentrations. Protein binding is about 11%. 80% or more of Fluconazole is excreted unchanged in the urine. Fluconazole can be removed by dialysis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS AND DOSAGE",
        innerData:
          "The daily dose should be based on the nature and severity of the fungal infection. Most cases of fungal infections require multiple dose therapy. Treatment should be continued until clinical parameters or laboratory tests indicate that active fungal infection has subsided. An inadequate period of treatment may lead to recurrence of active infection. Immuno compromised patients usually require maintenance therapy to prevent relapse.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIAGNOSIS",
        innerData:
          "Vaginal Candidiasis, Oropharyngeal Candidiasis, Oesophageal Candidiasis, Systemic Candidiasis & Cryptococcal infection, Tinea corporis/Tinea cruris/Tinea pedis/OtherTinea, Kerion, Pityriasis versicolor, Onychomycosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "RECOMMENDED DOSAGE",
        innerData:
          "150 mg as a single dose, 200 mg in 1st day followed by 100 mg daily for 14 days. 200 mg in 1st day followed by 100 mg daily for 14-30 days. 400 mg in 1st day followed by 200 mg daily for 28 days or longer based on clinical response. 150 mg weekly for 4-6 weeks. 50 mg daily for 20 days. 400 mg as a single dose. 150 mg weekly for 12 months. Child over 1 year In Superficial Candidiasis 1-2 mg/kg daily In Systemic Candidiasis & Cryptococcal infection 3-6 mg/kg daily In serious life threatening infections upto 12 mg/kg daily has been given to children aged 5-13 years (Maximum 400 mg daily).",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OTHER USES",
        innerData:
          "Fungal urinary tract infections, ii. Disseminated candidiasis, iii. Prophylaxis for fungal infection in neutropenic cancer patients, iv. Acute treatment of other systemic fungal infections such as coccidioidomycosis and histoplasmosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN THE ELDERLY",
        innerData:
          "The normal dose should be used if there is no evidence of renal impairment.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN CHILDREN",
        innerData:
          "Few formal studies have been done in children. Doses of 3-6 mg/kg daily have been used without serious adverse reactions being reported. Renal clearance in children may be proportionately more rapid than in adults and doses up to 12 mg/kg is recommended.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON LIVER",
        innerData:
          "For the liver as a potential target organ, the available data indicates that, Fluconazole is not predictable hepatotoxic drug in man. In man, including those with existing hypercholesterolaemia, serum cholesterol is not adversely affected by Fluconazole.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON PREGNANT WOMEN",
        innerData:
          "Adverse foetal effects have been seen in animals only at doses ranging from 80 mg/kg to 320 mg/kg with maternal toxicity. These levels are 20-60 times the recommended therapeutic use. Still Fluconazole should be used in pregnancy only if the potential benefit justifies the possible risk to the foetus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "EFFECTS ON LACTATING MOTHERS",
        innerData:
          "Fluconazole is secreted in human milk at concentrations similar to plasma. Therefore, the use of Fluconazole in nursing mother is not recommended. Contraindications Fluconazole should not be used in patients with known hypersensitivity to Fluconazole or to related triazole compounds.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Fluconazole acts by inhibiting fungal cytochrome P-450 enzymes. It is much less active against mammalian P-450 enzymes, still potential exists for interaction with drugs that are metabolized by P-450, a. Cyclosporin Some data suggest that Fluconazole increases cyclosporin levels, b. Phenytoin Fluconazole significantly increases phenytoin levels, c. Anticoagulants Fluconazole has shown to prolong prothrombin time in subjects receiving warfarin, d. Oral hypoglycaemics Fluconazole has been shown to prolong the serum half life of concomitantly administered Tolbutamide. However no adverse effect on serum glucose levels was seen. e. Rifampicin Decreases levels of Fluconazole, f. Oral contraceptives No clinically significant interactions have been seen.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "ADVERSE EFFECTS",
        innerData:
          "Therapy with Fluconazole is well tolerated. In 4000 patients receiving Fluconazole for various indications and for durations of 7 days or more, the incidence of side effects were 16% . Only 1.5% of subjects required discontinuation of medication. The most common adverse events were related to the gastro-intestinal system: nausea (3.7%), abdominal pain (1.17%), vomiting (1.7%) and diarrhoea (1.5%). Headache (1.9%) and skin rash (1.8%) were also seen.lt should be noted that approximately one third of this group were patients with AIDS and severe systemic disorders. Therefore the data may not be applicable to patients receiving Fluconazole for the treatment of superficial mycoses.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "In the case of overdose, supportive measures and gastric lavage should be instituted. If deemed necessary, a 3 hrshaemodialysis will decrease plasma levels by about 50%.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Flunapen ® 50 Capsule: Box Containing 3x10’s Capsule in Alu Alu Blister Pack.",
          "Flunapen ® 50 Capsule: Box Containing 3x10’s Capsule in Alu Alu Blister Pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },
  // Yaha Tk Entry Hui Hai

  {
    id: 30,
    title: "Hexicon 50 ml Handrub",
    therapeutic_class: "hand-sanitizer",
    text1: " ",
    text2: " ",
    imgf: hexicon50fr,
    imge: hexicon50bk,
    img: [
      {
        id: 30,
        imgf: hexicon50fr,
        imge: hexicon50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "",
    innerComposition: "",
    innerdata: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Hand Rub",
  },

  {
    id: 31,
    title: "Hexicon 250 ml Handrub",
    therapeutic_class: "hand-sanitizer",

    text1: " ",
    text2: " ",
    imgf: hexicon250fr,
        imge: hexicon250bk,
    img: [
      {
        id: 31,
        imgf: hexicon250fr,
        imge: hexicon250bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "",
    innerComposition: "",
    innerdata: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Hand Rub",
  },

  {
    id: 32,
    title: "Holicef 1gm IM Injection",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: holicef1gmfr,
    imge: holicef1gmbk,
    img: [
      {
        id: 32,
        imgf: holicef1gmfr,
        imge: holicef1gmbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Holicef® Injection",
    innerComposition: "Ceftriaxone BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Holicef® 250 mg IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 250 mg. Each ampoule contains 2 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 500 mg IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 500 mg. Each ampoule contains 2 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 500 mg IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 500 mg. Each ampoule contains 5 ml water for injection BP.",
          "Holicef® 1 gm IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 1 gm. Each ampoule contains 3.5 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 1 gm IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 1 gm. Each ampoule contains- 10 ml water for injection BP.",
          "Holicef® 2 gm IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 2 gm. Each ampoule contains- 10 ml water for injection BP. (2 ampoule, 20 ml water for injection)",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Holicef® (Ceftriaxone) is a sterile semi-synthetic broad spectrum 3rd generation Cephalosporin antibiotic for intravenous or intramuscular administration. The bactericidal activity of Ceftriaxone results from inhibition of cell wall synthesis. Ceftriaxone has a high degree of stability in the presence of beta-lactamase, both penicillinases and cephalosporinases of gram-positive and gram-negative bacteria. Holicef® (Ceftriaxone), like other cephalosporins and penicillins, kills bacteria by interfering with the synthesis of the bacterial cell wall. A remarkable feature of Holicef® (Ceftriaxone) is its relatively long plasma elimination half-life of about 6 to 9 hours, which makes single or once-daily dosage of the drug appropriate for most patients. Ceftriaxone is not metabolized in the body. About 40-65% of a dose of Ceftriaxone is excreted unchanged in the urine; the remainder is excreted in the bile and ultimately found in the faeces as unchanged drug and microbiologically inactive compound. The drug is highly (95%) protein bound.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Holicef® is indicated for the treatment of the following infections- 1. Lower respiratory tract infections, particularly pneumonia 2. Renal and urinary tract infections 3. Gonococcal infections 4. Acute bacterial otitis media 5. Skin, soft tissue, bone and joint infections 6. Bacterial meningitis7. Ear, nose and throat infections 8. Typhoid fever 9. Septicemia 10. Infections in cancer patients. 11. Prevention of post-operative infections 12. Pre-operative prophylaxis of infections associated with surgery",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adult: By deep intramuscular injection or by intravenous injection over at least 2-4 minutes or by intravenous infusion, 1 gm daily; 2-4 gm daily in severe infections; intramuscular doses over 1 gm divided between more than one site. Neonate: By intravenous infusion over 60 minutes, 20-50 mg/kg daily (max. 50 mg/kg daily). Infant and child under 50 kg: By deep intramuscular injection or by intravenous injection over 2-4 minutes or by intravenous infusion, 20-50 mg/kg daily; up to 80 mg/kg daily in severe infections; doses of 50 mg/kg and over by intravenous infusion only; 50 kg and over, adult dose. Uncomplicated gonorrhea: By deep intramuscular injection, 250 mg as a single dose. Surgical prophylaxis: By deep intramuscular injection or by intravenous injection over at least 2-4 minutes, 1 gm at induction, Preparation of injections and direction for reconstitution of powder : For intramuscular injection : Holicef 250 mg or 500 mg should be dissolved in 2 ml of 1% Lidocaine HCl Injection, Holicef 1 gm  in 3.5 ml of 1% Lidocaine HCl Injection. For intravenous injection :Holicef 250 mg or 500 mg should be dissolved in 5 ml of Water for Injection, Holicef 1 gm in 10 ml of Water for Injection, Holicef 2 gm in 20 ml of water for Injection. Use the solution immediately after reconstitution of powder. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "GenerallyHolicef® (Ceftriaxone) is well-tolerated. However, few side-effects including- nausea, vomiting, diarrhoea, dizziness and fever may occur.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "ADVERSE DRUG REACTIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pain can occur at the site of injection.",
          "Diarrhea occurs in about 3% (children 5-6%).",
          "Convulsion or involuntary movements may occur with ceftriaxone USE.",
        ],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Ceftriaxone is contraindicated in patients with known allergy to ceftriaxone, other cephalosporins or penicillins.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Pregnancy: The safety of Ceftriaxone in the treatment of infection during pregnancy has not been established. Ceftriaxone should only be used during pregnancy if the likely benefit outweighs the potential risk to the fetus or the mother.Lactation: Ceftriaxone is excreted in breast milk at low concentrations. Therefore, caution should be exercised when Ceftriaxone is administered to a nursing mother.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: "No drug interactions have yet been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There is no specific antidote. Treatment of overdosage should be symptomatic.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store below 30°C, Protect from light & moisture. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Holicef® 250 mg IM Injection: Each box contains- 1 combipac (1 vial of 250 mg Ceftriaxone with1 ampoule of 2 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage & Baby needle.",
          "Holicef® 500 mg IM Injection: Each box contains- 1 combipac (1 vial of 500 mg Ceftriaxone with 1 ampoule of 2 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage.",
          "Holicef® 500 mg IV Injection: Each box contains- 1 combipac (1vial of 500 mg Ceftriaxone with 1 ampoule of 5 ml water for injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage & 1 vein set.",
          "Holicef® 1 gm IM Injection: Each box contains- 1 combipac (1 vial of 1 gm Ceftriaxone with 1 ampoule of 3.5 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage.",
          "Holicef® 1 gm IV Injection: Each box contains- 1 combipac (1vial of 1 gm Ceftriaxone with 1 ampoule of 10 ml water for injection), Sterile disposable syringe 10 ml, Alcohol pad, First aid bandage & 1 vein set.",
          "Holicef® 2 gm IV Injection: Each box contains- 1 combipac (1vial of 2 gm Ceftriaxone with 2 ampoules of 10 ml water for injection), Sterile disposable syringe 20 ml, Alcohol pad, First aid bandage & 1 vein set.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Injectables",
  },

  {
    id: 33,
    title: "Holicef 500mg IV Injection",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: holicef500mgfr,
    imge: holicef500mgbk,
    img: [
      {
        id: 33,
        imgf: holicef500mgfr,
        imge: holicef500mgbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Holicef® Injection",
    innerComposition: "Ceftriaxone BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Holicef® 250 mg IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 250 mg. Each ampoule contains 2 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 500 mg IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 500 mg. Each ampoule contains 2 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 500 mg IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 500 mg. Each ampoule contains 5 ml water for injection BP.",
          "Holicef® 1 gm IM Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 1 gm. Each ampoule contains 3.5 ml Lidocaine Hydrochloride 1% BP.",
          "Holicef® 1 gm IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 1 gm. Each ampoule contains- 10 ml water for injection BP.",
          "Holicef® 2 gm IV Injection: Each vial contains Ceftriaxone Sodium BP eqvt. to Ceftriaxone 2 gm. Each ampoule contains- 10 ml water for injection BP. (2 ampoule, 20 ml water for injection)",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Holicef® (Ceftriaxone) is a sterile semi-synthetic broad spectrum 3rd generation Cephalosporin antibiotic for intravenous or intramuscular administration. The bactericidal activity of Ceftriaxone results from inhibition of cell wall synthesis. Ceftriaxone has a high degree of stability in the presence of beta-lactamase, both penicillinases and cephalosporinases of gram-positive and gram-negative bacteria. Holicef® (Ceftriaxone), like other cephalosporins and penicillins, kills bacteria by interfering with the synthesis of the bacterial cell wall. A remarkable feature of Holicef® (Ceftriaxone) is its relatively long plasma elimination half-life of about 6 to 9 hours, which makes single or once-daily dosage of the drug appropriate for most patients. Ceftriaxone is not metabolized in the body. About 40-65% of a dose of Ceftriaxone is excreted unchanged in the urine; the remainder is excreted in the bile and ultimately found in the faeces as unchanged drug and microbiologically inactive compound. The drug is highly (95%) protein bound.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Holicef® is indicated for the treatment of the following infections- 1. Lower respiratory tract infections, particularly pneumonia 2. Renal and urinary tract infections 3. Gonococcal infections 4. Acute bacterial otitis media 5. Skin, soft tissue, bone and joint infections 6. Bacterial meningitis7. Ear, nose and throat infections 8. Typhoid fever 9. Septicemia 10. Infections in cancer patients. 11. Prevention of post-operative infections 12. Pre-operative prophylaxis of infections associated with surgery",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adult: By deep intramuscular injection or by intravenous injection over at least 2-4 minutes or by intravenous infusion, 1 gm daily; 2-4 gm daily in severe infections; intramuscular doses over 1 gm divided between more than one site. Neonate: By intravenous infusion over 60 minutes, 20-50 mg/kg daily (max. 50 mg/kg daily). Infant and child under 50 kg: By deep intramuscular injection or by intravenous injection over 2-4 minutes or by intravenous infusion, 20-50 mg/kg daily; up to 80 mg/kg daily in severe infections; doses of 50 mg/kg and over by intravenous infusion only; 50 kg and over, adult dose. Uncomplicated gonorrhea: By deep intramuscular injection, 250 mg as a single dose. Surgical prophylaxis: By deep intramuscular injection or by intravenous injection over at least 2-4 minutes, 1 gm at induction, Preparation of injections and direction for reconstitution of powder : For intramuscular injection : Holicef 250 mg or 500 mg should be dissolved in 2 ml of 1% Lidocaine HCl Injection, Holicef 1 gm  in 3.5 ml of 1% Lidocaine HCl Injection. For intravenous injection :Holicef 250 mg or 500 mg should be dissolved in 5 ml of Water for Injection, Holicef 1 gm in 10 ml of Water for Injection, Holicef 2 gm in 20 ml of water for Injection. Use the solution immediately after reconstitution of powder. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "GenerallyHolicef® (Ceftriaxone) is well-tolerated. However, few side-effects including- nausea, vomiting, diarrhoea, dizziness and fever may occur.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "ADVERSE DRUG REACTIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pain can occur at the site of injection.",
          "Diarrhea occurs in about 3% (children 5-6%).",
          "Convulsion or involuntary movements may occur with ceftriaxone USE.",
        ],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData:
          "Ceftriaxone is contraindicated in patients with known allergy to ceftriaxone, other cephalosporins or penicillins.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "Pregnancy: The safety of Ceftriaxone in the treatment of infection during pregnancy has not been established. Ceftriaxone should only be used during pregnancy if the likely benefit outweighs the potential risk to the fetus or the mother.Lactation: Ceftriaxone is excreted in breast milk at low concentrations. Therefore, caution should be exercised when Ceftriaxone is administered to a nursing mother.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: "No drug interactions have yet been reported.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "There is no specific antidote. Treatment of overdosage should be symptomatic.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store below 30°C, Protect from light & moisture. Keep out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Holicef® 250 mg IM Injection: Each box contains- 1 combipac (1 vial of 250 mg Ceftriaxone with1 ampoule of 2 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage & Baby needle.",
          "Holicef® 500 mg IM Injection: Each box contains- 1 combipac (1 vial of 500 mg Ceftriaxone with 1 ampoule of 2 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage.",
          "Holicef® 500 mg IV Injection: Each box contains- 1 combipac (1vial of 500 mg Ceftriaxone with 1 ampoule of 5 ml water for injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage & 1 vein set.",
          "Holicef® 1 gm IM Injection: Each box contains- 1 combipac (1 vial of 1 gm Ceftriaxone with 1 ampoule of 3.5 ml Lidocaine HCl 1% injection), Sterile disposable syringe 5 ml, Alcohol pad, First aid bandage.",
          "Holicef® 1 gm IV Injection: Each box contains- 1 combipac (1vial of 1 gm Ceftriaxone with 1 ampoule of 10 ml water for injection), Sterile disposable syringe 10 ml, Alcohol pad, First aid bandage & 1 vein set.",
          "Holicef® 2 gm IV Injection: Each box contains- 1 combipac (1vial of 2 gm Ceftriaxone with 2 ampoules of 10 ml water for injection), Sterile disposable syringe 20 ml, Alcohol pad, First aid bandage & 1 vein set.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Injectables",
  },

  {
    id: 34,
    title: "Linacon 5  Tablet",
    therapeutic_class: "anti-diabetic",

    text1: " ",
    text2: " ",
    imgf: linacon5fr,
    imge: linacon5bk,
    img: [
      {
        id: 34,
        imgf: linacon5fr,
        imge: linacon5bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Linacon",
    innerComposition: "Linagliptin INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Linacon® 5: Each film coated tablet contains Linagliptin INN 5 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Linacon ® 5 is an inhibitor of DPP-4 , an enzyme that degrades the incretin hormones GLP-1 and GIP. Thus, Linagliptin increases the concentrations of active incretin hormones, stimulating the release of insulin from pancreatic beta cells in a glucose-dependent manner and decreasing the secretion of glucangon from pancreatic alpha cells in the circulation. Thus it improves glycemic control in patients with type 2 diabetes mellitus.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData:
          "Linacon® 5 is indicated in the treatment of type 2 diabetes mellitus to improve glycaemic control in adults. As monotherapy-in patients inadequately controlled by diet and exercise alone and for whom metformin is inappropriate due to intolerance or contraindicated due to renal impairment. As combination therapy-in combination with metformin when diet and exercise plus metformin alone do not provide adequate glycaemic control-in combination with a sulphonylurea and metformin when diet and exercise plus dual therapy with these medicinal products do not provide adequate glycaemic control.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Linagliptin 5 mg once daily. If added to metformin, the dose of metformin should be maintained and linagliptin administered concomitantly. When used in combination with a sulfonylurea, a lower dose of the sulphonylurea may be considered to reduce the risk of hypoglycaemia.Patients with renal impairment: No dose adjustment required. Linagliptin can be taken with or without a meal at any time of the day.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION:",
        innerData:
          "Hypersensitivity to the active substance or to any of the excipients.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData:
          "Linagliptin should not be used in patients with type 1 diabetes or for the treatment of diabetic ketoacidosis.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECT",
        innerData:
          "There may be hypoglycaemia, nasopharyngitis, cough and pancreatitis in combination with metformin and sulfonylurea.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData:
          "Linagliptin is a weak competitive and a weak to moderate mechanism-based inhibitor of CYP isozyme CYP3A4, but does not inhibit other CYP isozymes. The risk for clinically meaningful interactions by other medicinal products on linagliptin is low and in clinical studies linagliptin had no clinically relevant effect on the pharmacokinetics of metformin, glyburide, simvastatin, warfarin, digoxin or oral contraceptives.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY AND LACTATION",
        innerData:
          "Avoid use during pregnancy. A risk to the breast-fed child cannot be excluded. ",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: "Each box contains 2 X 10 tablets in Alu-Alu blister pack.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 35,
    title: "Macrobac 15  Tablet",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: macrobac15fr,
        imge: macrobac15bk,
    img: [
      {
        id: 35,
        imgf: macrobac15fr,
        imge: macrobac15bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Macrobac 15",
    innerComposition: "Azithromycin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Macrobac® 500 Tablet: Each tablet contains Azithromycin BP  500 mg as Azithromycin Dihydrate BP.Macrobac® 15, 25, 35 & 50 ml PFS: After reconstitution, Each 5 ml suspension contains Azithromycin BP  200 mg as Azithromycin Dihydrate BP.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Azithromycin is an azalide, a subclass of macrolide antibiotics active against gram-positive and gram-negative organisms. It prevents bacteria from growing by interfering with their protein synthesis. It binds to the 50s subunit of the bacterial ribosome and thus inhibits translation of mRNA.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Respiratory tract infections, Otitis media, Skin and soft-tissue infections, Uncomplicated gonorrhoea, Uncomplicated genital chlamydial infections, Nongonococcal urethritis, Typhoid fever, Community acquired pneumonia, Chronic obstructive pulmonary disease, Mycobacterium avium complex.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults: 500 mg once daily orally for 3 days.Children (Over 6 months): 10 mg/kg once daily for 3 days or",
        istable: true,
        table: {
          headers: ["Body weight", "Dose", "Duration"],
          body: [
            ["15-25 kg", "200 mg once daily", "3 days"],
            ["26-35 kg", "300 mg once daily", "3 days"],
            ["36-45 kg", "200 mg once daily", "3 days"],
          ],
        },
        islist: true,
        listData: [
          "Uncomplicated gonorrhoea, uncomplicated genital chlamydial infections and non-gonococcal urethritis, 1 g as a single dose.",
          "Community acquired pneumonia and Chronic obstructive pulmonary disease, 500 mg as a single dose on day 1, followed by 250 mg once daily from day 2 to 5",
          "Macrobac® Tablet & PFS Can Be Taken With Or Without Food.",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy: Recent clinical studies have recommended that Azithromycin should be considered for the initial treatment of Chlamydial Cervicitis in pregnancy. In other infections, it should be used only when clearly needed. It is pregnancy category B drug.
        Lactation: It is not known whether Azithromycin is excreted in human milk. Because many drugs are excreted in human milk, caution should be exercised when it is administered to a nursing woman.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Azithromycin is well tolerated with a low incidence of side effects. Most common side effects are nausea, abdominal discomfort, vomiting, flatulence and diarrhea.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Azithromycin is contraindicated in patients hypersensitive to Azithromycin orother macrolide antibiotics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Azithromycin is principally eliminated via liver. Caution should be exercised when it is administered to patients with impaired hepatic function.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Food and antacid reduce the absorption of Azithromycin. So Azithromycinshould be administered 1 hour before or 2 hours after taking food or antacid. Macrolides have been known to increase the plasma concentration of digoxinand cyclosporine. So caution should be exercised while co-administration is
        necessary.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Macrobac® 500 Tablet: Each box contains 3 X 4’s tablets in Alu-Alu blister pack.",
          "Macrobac® 15 ml PFS: Each bottle contains Azithromycin dry powder for 15 ml suspension with a measuring cup.",
          "Macrobac® 25 ml PFS: Each bottle contains Azithromycin dry powder for 25 ml suspension with a measuring cup.",
          "Macrobac® 35 ml PFS: Each bottle contains Azithromycin dry powder for 35 ml suspension with a measuring cup.",
          "Macrobac® 50 ml PFS: Each bottle contains Azithromycin dry powder for 50 ml suspension with a measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 36,
    title: "Macrobac 35  Tablet",
    therapeutic_class: "antibiotic",

    text1: " ",
    imgf: macrobac35fr,
        imge: macrobac35bk,
    text2: " ",
    img: [
      {
        id: 36,
        imgf: macrobac35fr,
        imge: macrobac35bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Macrobac 35",
    innerComposition: "Azithromycin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Macrobac® 500 Tablet: Each tablet contains Azithromycin BP  500 mg as Azithromycin Dihydrate BP.Macrobac® 15, 25, 35 & 50 ml PFS: After reconstitution, Each 5 ml suspension contains Azithromycin BP  200 mg as Azithromycin Dihydrate BP.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Azithromycin is an azalide, a subclass of macrolide antibiotics active against gram-positive and gram-negative organisms. It prevents bacteria from growing by interfering with their protein synthesis. It binds to the 50s subunit of the bacterial ribosome and thus inhibits translation of mRNA.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Respiratory tract infections, Otitis media, Skin and soft-tissue infections, Uncomplicated gonorrhoea, Uncomplicated genital chlamydial infections, Nongonococcal urethritis, Typhoid fever, Community acquired pneumonia, Chronic obstructive pulmonary disease, Mycobacterium avium complex.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults: 500 mg once daily orally for 3 days.Children (Over 6 months): 10 mg/kg once daily for 3 days or",
        istable: true,
        table: {
          headers: ["Body weight", "Dose", "Duration"],
          body: [
            ["15-25 kg", "200 mg once daily", "3 days"],
            ["26-35 kg", "300 mg once daily", "3 days"],
            ["36-45 kg", "200 mg once daily", "3 days"],
          ],
        },
        islist: true,
        listData: [
          "Uncomplicated gonorrhoea, uncomplicated genital chlamydial infections and non-gonococcal urethritis, 1 g as a single dose.",
          "Community acquired pneumonia and Chronic obstructive pulmonary disease, 500 mg as a single dose on day 1, followed by 250 mg once daily from day 2 to 5",
          "Macrobac® Tablet & PFS Can Be Taken With Or Without Food.",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy: Recent clinical studies have recommended that Azithromycin should be considered for the initial treatment of Chlamydial Cervicitis in pregnancy. In other infections, it should be used only when clearly needed. It is pregnancy category B drug.
        Lactation: It is not known whether Azithromycin is excreted in human milk. Because many drugs are excreted in human milk, caution should be exercised when it is administered to a nursing woman.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Azithromycin is well tolerated with a low incidence of side effects. Most common side effects are nausea, abdominal discomfort, vomiting, flatulence and diarrhea.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Azithromycin is contraindicated in patients hypersensitive to Azithromycin orother macrolide antibiotics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Azithromycin is principally eliminated via liver. Caution should be exercised when it is administered to patients with impaired hepatic function.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Food and antacid reduce the absorption of Azithromycin. So Azithromycinshould be administered 1 hour before or 2 hours after taking food or antacid. Macrolides have been known to increase the plasma concentration of digoxinand cyclosporine. So caution should be exercised while co-administration is
        necessary.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Macrobac® 500 Tablet: Each box contains 3 X 4’s tablets in Alu-Alu blister pack.",
          "Macrobac® 15 ml PFS: Each bottle contains Azithromycin dry powder for 15 ml suspension with a measuring cup.",
          "Macrobac® 25 ml PFS: Each bottle contains Azithromycin dry powder for 25 ml suspension with a measuring cup.",
          "Macrobac® 35 ml PFS: Each bottle contains Azithromycin dry powder for 35 ml suspension with a measuring cup.",
          "Macrobac® 50 ml PFS: Each bottle contains Azithromycin dry powder for 50 ml suspension with a measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 37,
    title: "Macrobac 500  Tablet",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: macrobac500fr,
    imge: macrobac500bk,
    img: [
      {
        id: 37,
        imgf: macrobac500fr,
        imge: macrobac500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Macrobac 500",
    innerComposition: "Azithromycin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Macrobac® 500 Tablet: Each tablet contains Azithromycin BP  500 mg as Azithromycin Dihydrate BP.Macrobac® 15, 25, 35 & 50 ml PFS: After reconstitution, Each 5 ml suspension contains Azithromycin BP  200 mg as Azithromycin Dihydrate BP.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Azithromycin is an azalide, a subclass of macrolide antibiotics active against gram-positive and gram-negative organisms. It prevents bacteria from growing by interfering with their protein synthesis. It binds to the 50s subunit of the bacterial ribosome and thus inhibits translation of mRNA.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData:
          "Respiratory tract infections, Otitis media, Skin and soft-tissue infections, Uncomplicated gonorrhoea, Uncomplicated genital chlamydial infections, Nongonococcal urethritis, Typhoid fever, Community acquired pneumonia, Chronic obstructive pulmonary disease, Mycobacterium avium complex.",
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults: 500 mg once daily orally for 3 days.Children (Over 6 months): 10 mg/kg once daily for 3 days or",
        istable: true,
        table: {
          headers: ["Body weight", "Dose", "Duration"],
          body: [
            ["15-25 kg", "200 mg once daily", "3 days"],
            ["26-35 kg", "300 mg once daily", "3 days"],
            ["36-45 kg", "200 mg once daily", "3 days"],
          ],
        },
        islist: true,
        listData: [
          "Uncomplicated gonorrhoea, uncomplicated genital chlamydial infections and non-gonococcal urethritis, 1 g as a single dose.",
          "Community acquired pneumonia and Chronic obstructive pulmonary disease, 500 mg as a single dose on day 1, followed by 250 mg once daily from day 2 to 5",
          "Macrobac® Tablet & PFS Can Be Taken With Or Without Food.",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy: Recent clinical studies have recommended that Azithromycin should be considered for the initial treatment of Chlamydial Cervicitis in pregnancy. In other infections, it should be used only when clearly needed. It is pregnancy category B drug.
        Lactation: It is not known whether Azithromycin is excreted in human milk. Because many drugs are excreted in human milk, caution should be exercised when it is administered to a nursing woman.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Azithromycin is well tolerated with a low incidence of side effects. Most common side effects are nausea, abdominal discomfort, vomiting, flatulence and diarrhea.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Azithromycin is contraindicated in patients hypersensitive to Azithromycin orother macrolide antibiotics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Azithromycin is principally eliminated via liver. Caution should be exercised when it is administered to patients with impaired hepatic function.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Food and antacid reduce the absorption of Azithromycin. So Azithromycinshould be administered 1 hour before or 2 hours after taking food or antacid. Macrolides have been known to increase the plasma concentration of digoxinand cyclosporine. So caution should be exercised while co-administration is
        necessary.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Macrobac® 500 Tablet: Each box contains 3 X 4’s tablets in Alu-Alu blister pack.",
          "Macrobac® 15 ml PFS: Each bottle contains Azithromycin dry powder for 15 ml suspension with a measuring cup.",
          "Macrobac® 25 ml PFS: Each bottle contains Azithromycin dry powder for 25 ml suspension with a measuring cup.",
          "Macrobac® 35 ml PFS: Each bottle contains Azithromycin dry powder for 35 ml suspension with a measuring cup.",
          "Macrobac® 50 ml PFS: Each bottle contains Azithromycin dry powder for 50 ml suspension with a measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 38,
    title: "Maxdol 10  Tablet",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ", 
    imgf: maxdol10fr,
    imge: maxdol10bk,
    img: [
      {
        id: 38,
        imgf: maxdol10fr,
        imge: maxdol10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxdol",
    innerComposition: "Ketorolac Tromethamine USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Maxdol® 10 tablet: Each film coated tablet contains Ketorolac tromethamine USP 10 mg. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Ketorolac Tromethamine is a drug of pyrrolo-pyrrole group of nonsteroidal anti-inflammatory drug (NSAID). Chemically it is known as 5 benzoyle-2, 3-dihydro-1H-pyrroligine-1-carboxylic acid, compound with 2-amino-2 -(hydroxymethyl)-1, 3-propanediol (1:1). Ketorolac Tromethamine inhibits synthesis of prostaglandins and may be considered as a peripherally acting analgesic. The biological activity of Ketorolac Tromethamine is associated with the S-form. Pharmacokinetic property of Ketorolac Tromethamine is linear. It is highly protein bound and is largely metabolized in liver. The products of metabolism and some unchanged drugs are excreted in the urine.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Injections and tablets are indicated for the short-term management of moderate to severe acute post-operative pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Ketorolac tromethamine is for administration by intramuscular or bolus intravenous injection. The recommended initial dose of Ketorolac is 10 mg, followed by 10 to 30 mg every four to six hours as required. A total daily dose of 90 mg for non-elderly and 60 mg for the elderly, renally-impaired patients and patients less than 50 kg should not be exceeded. The maximum duration of treatment should not exceed two days. Ketorolac tablets are recommended for short-term use only (up to 7 days) and are not recommended for chronic use. 10mg every 4 to 6 hours as required. Doses exceeding 40 mg per day are not recommended. For patients receiving parenteral Ketorolac tromethamine and who are converted to Ketorolac tromethamine oral tablets, the total combined daily dose should not exceed 90 mg (60 mg for the elderly, renally-impaired patients and patients less than 50 kg) and the oral component should not exceed 40 mg on the day the change of formulation is made. Patients should be converted to oral treatment as soon as possible.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occurring side-effects are nausea, vomiting, gastro-intestinal bleeding, melaena, peptic ulcer, pancreatitis, anxiety, drowsiness, dizziness, headache, hallucination, excessive thirst, inability to concentrate, insomnia, malaise, fatigue, pruritus, urticaria, skin photosensitivity, Lyell's syndrome, Stevens Johnson syndrome, flushing, bradycardia, hypertension, palpitations, chest pain, infertility in female, dyspnoea, asthma, pulmonary oedema, fever & pain at injection site.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly , allergic disorder, renal , cardiac  & patient with low body weight (< 50kg)`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ketorolac tromethamine is contraindicated in patients having hypersensitivity to this drug or other NSAIDs and those patients in whom aspirin or other prostaglandin synthesis inhibitors induce allergic reactions. It is also contraindicated in a history of peptic ulcer or gastro-intestinal bleeding, moderate or severe renal impairment (serum creatinine> 160 micromol/l), a history of asthma. Ketorolac tromethamine is contra-indicated as prophylactic analgesia before surgery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ketorolac has been detected in human milk at low levels. Ketorolac is therefore contraindicated during pregnancy, labour or delivery, or in mothers who are breast feeding.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData: `Over dosage of Ketorolac Tromethamine may cause abdominal pain, peptic ulcers which healed after discontinuation of doses and Metabolic acidosis has been reported following intentional over dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Ketorolac tromethamine should not be used with other NSAIDs or in patients receiving aspirin because of the potential for additive side-effects. Care should be taken when administering Ketorolac tromethamine with anti-coagulants since co-administration may cause an enhanced anti-coagulant effect. Ketorolac tromethamine and other non-steroidal anti-inflammatory drugs can reduce the anti-hypertensive effect of beta-blockers .`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30 ⁰C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Maxdol® 10 tablet: Each box contains 3x10 tablets in Alu-Alu pack. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 39,
    title: "Maxdol 10  Tablet",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",
    imgf: maxdol10fr,
        imge: maxdol10bk,
    img: [
      {
        id: 39,
        imgf: maxdol10fr,
        imge: maxdol10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxdol",
    innerComposition: "Ketorolac Tromethamine USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Maxdol® 10 tablet: Each film coated tablet contains Ketorolac tromethamine USP 10 mg. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Ketorolac Tromethamine is a drug of pyrrolo-pyrrole group of nonsteroidal anti-inflammatory drug (NSAID). Chemically it is known as 5 benzoyle-2, 3-dihydro-1H-pyrroligine-1-carboxylic acid, compound with 2-amino-2 -(hydroxymethyl)-1, 3-propanediol (1:1). Ketorolac Tromethamine inhibits synthesis of prostaglandins and may be considered as a peripherally acting analgesic. The biological activity of Ketorolac Tromethamine is associated with the S-form. Pharmacokinetic property of Ketorolac Tromethamine is linear. It is highly protein bound and is largely metabolized in liver. The products of metabolism and some unchanged drugs are excreted in the urine.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Injections and tablets are indicated for the short-term management of moderate to severe acute post-operative pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Ketorolac tromethamine is for administration by intramuscular or bolus intravenous injection. The recommended initial dose of Ketorolac is 10 mg, followed by 10 to 30 mg every four to six hours as required. A total daily dose of 90 mg for non-elderly and 60 mg for the elderly, renally-impaired patients and patients less than 50 kg should not be exceeded. The maximum duration of treatment should not exceed two days. Ketorolac tablets are recommended for short-term use only (up to 7 days) and are not recommended for chronic use. 10mg every 4 to 6 hours as required. Doses exceeding 40 mg per day are not recommended. For patients receiving parenteral Ketorolac tromethamine and who are converted to Ketorolac tromethamine oral tablets, the total combined daily dose should not exceed 90 mg (60 mg for the elderly, renally-impaired patients and patients less than 50 kg) and the oral component should not exceed 40 mg on the day the change of formulation is made. Patients should be converted to oral treatment as soon as possible.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occurring side-effects are nausea, vomiting, gastro-intestinal bleeding, melaena, peptic ulcer, pancreatitis, anxiety, drowsiness, dizziness, headache, hallucination, excessive thirst, inability to concentrate, insomnia, malaise, fatigue, pruritus, urticaria, skin photosensitivity, Lyell's syndrome, Stevens Johnson syndrome, flushing, bradycardia, hypertension, palpitations, chest pain, infertility in female, dyspnoea, asthma, pulmonary oedema, fever & pain at injection site.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly , allergic disorder, renal , cardiac  & patient with low body weight (< 50kg)`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ketorolac tromethamine is contraindicated in patients having hypersensitivity to this drug or other NSAIDs and those patients in whom aspirin or other prostaglandin synthesis inhibitors induce allergic reactions. It is also contraindicated in a history of peptic ulcer or gastro-intestinal bleeding, moderate or severe renal impairment (serum creatinine> 160 micromol/l), a history of asthma. Ketorolac tromethamine is contra-indicated as prophylactic analgesia before surgery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ketorolac has been detected in human milk at low levels. Ketorolac is therefore contraindicated during pregnancy, labour or delivery, or in mothers who are breast feeding.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData: `Over dosage of Ketorolac Tromethamine may cause abdominal pain, peptic ulcers which healed after discontinuation of doses and Metabolic acidosis has been reported following intentional over dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Ketorolac tromethamine should not be used with other NSAIDs or in patients receiving aspirin because of the potential for additive side-effects. Care should be taken when administering Ketorolac tromethamine with anti-coagulants since co-administration may cause an enhanced anti-coagulant effect. Ketorolac tromethamine and other non-steroidal anti-inflammatory drugs can reduce the anti-hypertensive effect of beta-blockers .`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30 ⁰C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Maxdol® 10 tablet: Each box contains 3x10 tablets in Alu-Alu pack. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 40,
    title: "Maxdol 30 Injection",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",
    imgf: maxdol30fr,
        imge: maxdol30bk,
    img: [
      {
        id: 40,
        imgf: maxdol30fr,
        imge: maxdol30bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxdol 30 Injection",
    innerComposition: "Ketorolac Tromethamine USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxdol® 30 injection: Each 1 ml injection contains Ketorolac tromethamine USP 30 mg. ",
          "Maxdol® 60 injection: Each 2 ml injection contains Ketorolac tromethamine USP 60 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Ketorolac Tromethamine is a drug of pyrrolo-pyrrole group of nonsteroidal anti-inflammatory drug (NSAID). Chemically it is known as 5 benzoyle-2, 3-dihydro-1H-pyrroligine-1-carboxylic acid, compound with 2 - amino-2 -(hydroxymethyl)-1, 3-propanediol (1:1). Ketorolac Tromethamine inhibits synthesis of prostaglandins and may be considered as a peripherally acting analgesic. The biological activity of Ketorolac Tromethamine is associated with the S-form. Pharmacokinetic property of Ketorolac Tromethamine is linear. It is highly protein bound and is largely metabolized in liver. The products of metabolism and some unchanged drugs are excreted in the urine.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Injections and tablets are indicated for the short-term management of moderate to severe acute post-operative pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Ketorolac tromethamine is for administration by intramuscular or bolus intravenous injection. The recommended initial dose of Ketorolac is 10 mg, followed by 10 to 30 mg every four to six hours as required. A total daily dose of 90 mg for non-elderly and 60 mg for the elderly, renally-impaired patients and patients less than 50 kg should not be exceeded. The maximum duration of treatment should not exceed two days. Ketorolac tablets are recommended for short-term use only (up to 7 days) and are not recommended for chronic use. 10mg every 4 to 6 hours as required. Doses exceeding 40 mg per day are not recommended. For patients receiving parenteral Ketorolac tromethamine and who are converted to Ketorolac tromethamine oral tablets, the total combined daily dose should not exceed 90 mg (60 mg for the elderly, renally-impaired patients and patients less than 50 kg) and the oral component should not exceed 40 mg on the day the change of formulation is made. Patients should be converted to oral treatment as soon as possible.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occurring side-effects are nausea, vomiting, gastro-intestinal bleeding, melaena, peptic ulcer, pancreatitis, anxiety, drowsiness, dizziness, headache, hallucination, excessive thirst, inability to concentrate, insomnia, malaise, fatigue, pruritus, urticaria, skin photosensitivity, Lyell's syndrome, Stevens Johnson syndrome, flushing, bradycardia, hypertension, palpitations, chest pain, infertility in female, dyspnoea, asthma, pulmonary oedema, fever & pain at injection site.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly, allergic disorder, renal, cardiac  & patient with low body weight (< 50kg)`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ketorolac tromethamine is contraindicated in patients having hypersensitivity to this drug or other NSAIDs and those patients in whom aspirin or other prostaglandin synthesis inhibitors induce allergic reactions. It is also contraindicated in a history of peptic ulcer or gastro-intestinal bleeding, moderate or severe renal impairment (serum creatinine> 160 micromol/l), a history of asthma. Ketorolac tromethamine is contra-indicated as prophylactic analgesia before surgery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ketorolac has been detected in human milk at low levels. Ketorolac is therefore contraindicated during pregnancy, labour or delivery, or in mothers who are breast feeding.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE:",
        innerData: `Over dosage of Ketorolac Tromethamine may cause abdominal pain, peptic ulcers which healed after discontinuation of doses and Metabolic acidosis has been reported following intentional over dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS: ",
        innerData: `Ketorolac tromethamine should not be used with other NSAIDs or in patients receiving aspirin because of the potential for additive side-effects. Care should be taken when administering Ketorolac tromethamine with anti-coagulants since co-administration may cause an enhanced anti-coagulant effect. Ketorolac tromethamine and other non-steroidal anti-inflammatory drugs can reduce the anti-hypertensive effect of beta-blockers .`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxdol® 30 injection: Each box contains 1 ampoule of 1 ml sterile solution of Ketorolac tromethamine 30 mg injection.",
          "Maxdol® 60 injection: Each box contains 1 ampoule of 2 ml sterile solution of Ketorolac tromethamine 60 mg injection.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Injectables",
  },

  {
    id: 41,
    title: "Maxdol 60 Injection",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",
    imgf: maxdol60fr,
    imge: maxdol60bk,
    img: [
      {
        id: 41,
        imgf: maxdol60fr,
        imge: maxdol60bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxdol 60 Injection",
    innerComposition: "Ketorolac Tromethamine USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxdol® 30 injection: Each 1 ml injection contains Ketorolac tromethamine USP 30 mg. ",
          "Maxdol® 60 injection: Each 2 ml injection contains Ketorolac tromethamine USP 60 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Ketorolac Tromethamine is a drug of pyrrolo-pyrrole group of nonsteroidal anti-inflammatory drug (NSAID). Chemically it is known as 5 benzoyle-2, 3-dihydro-1H-pyrroligine-1-carboxylic acid, compound with 2 - amino-2 -(hydroxymethyl)-1, 3-propanediol (1:1). Ketorolac Tromethamine inhibits synthesis of prostaglandins and may be considered as a peripherally acting analgesic. The biological activity of Ketorolac Tromethamine is associated with the S-form. Pharmacokinetic property of Ketorolac Tromethamine is linear. It is highly protein bound and is largely metabolized in liver. The products of metabolism and some unchanged drugs are excreted in the urine.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Injections and tablets are indicated for the short-term management of moderate to severe acute post-operative pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Ketorolac tromethamine is for administration by intramuscular or bolus intravenous injection. The recommended initial dose of Ketorolac is 10 mg, followed by 10 to 30 mg every four to six hours as required. A total daily dose of 90 mg for non-elderly and 60 mg for the elderly, renally-impaired patients and patients less than 50 kg should not be exceeded. The maximum duration of treatment should not exceed two days. Ketorolac tablets are recommended for short-term use only (up to 7 days) and are not recommended for chronic use. 10mg every 4 to 6 hours as required. Doses exceeding 40 mg per day are not recommended. For patients receiving parenteral Ketorolac tromethamine and who are converted to Ketorolac tromethamine oral tablets, the total combined daily dose should not exceed 90 mg (60 mg for the elderly, renally-impaired patients and patients less than 50 kg) and the oral component should not exceed 40 mg on the day the change of formulation is made. Patients should be converted to oral treatment as soon as possible.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occurring side-effects are nausea, vomiting, gastro-intestinal bleeding, melaena, peptic ulcer, pancreatitis, anxiety, drowsiness, dizziness, headache, hallucination, excessive thirst, inability to concentrate, insomnia, malaise, fatigue, pruritus, urticaria, skin photosensitivity, Lyell's syndrome, Stevens Johnson syndrome, flushing, bradycardia, hypertension, palpitations, chest pain, infertility in female, dyspnoea, asthma, pulmonary oedema, fever & pain at injection site.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly, allergic disorder, renal, cardiac  & patient with low body weight (< 50kg)`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ketorolac tromethamine is contraindicated in patients having hypersensitivity to this drug or other NSAIDs and those patients in whom aspirin or other prostaglandin synthesis inhibitors induce allergic reactions. It is also contraindicated in a history of peptic ulcer or gastro-intestinal bleeding, moderate or severe renal impairment (serum creatinine> 160 micromol/l), a history of asthma. Ketorolac tromethamine is contra-indicated as prophylactic analgesia before surgery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ketorolac has been detected in human milk at low levels. Ketorolac is therefore contraindicated during pregnancy, labour or delivery, or in mothers who are breast feeding.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE:",
        innerData: `Over dosage of Ketorolac Tromethamine may cause abdominal pain, peptic ulcers which healed after discontinuation of doses and Metabolic acidosis has been reported following intentional over dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS: ",
        innerData: `Ketorolac tromethamine should not be used with other NSAIDs or in patients receiving aspirin because of the potential for additive side-effects. Care should be taken when administering Ketorolac tromethamine with anti-coagulants since co-administration may cause an enhanced anti-coagulant effect. Ketorolac tromethamine and other non-steroidal anti-inflammatory drugs can reduce the anti-hypertensive effect of beta-blockers .`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxdol® 30 injection: Each box contains 1 ampoule of 1 ml sterile solution of Ketorolac tromethamine 30 mg injection.",
          "Maxdol® 60 injection: Each box contains 1 ampoule of 2 ml sterile solution of Ketorolac tromethamine 60 mg injection.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Injectables",
  },

  {
    id: 42,
    title: "Maxvit D 20000 Tablet",
    therapeutic_class: "vitamin & minerals",

    text1: " ",
    imgf: maxvitd20000fr,
    imge: maxvitd20000bk,
    text2: " ",
    img: [
      {
        id: 42,
        imgf: maxvitd20000fr,
        imge: maxvitd20000bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxvit 2000",
    innerComposition: "Cholecalciferol BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxvit® D 20000 Capsule: Each capsule contains Cholecalciferol BP 20,000 IU.",
          "Maxvit® D 40000 Capsule: Each capsule contains Cholecalciferol BP 40,000 IU.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Maxvit® D is a preparation of Cholecalciferol, a synthetic of Vitamin D3. It is essential for normal bone growth and development and to maintain bone density. Cholecalciferol helps our body to utilize both Calcium and Phosphorus. It acts as a hormone and increases reabsorption of Calcium and Phosphorus by the kidneys.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Vitamin D is used to treat and prevent bone disorders. Vitamin D is also used with other medications to treat low levels of calcium or phosphate caused by certain disorder. It may be used in kidney disease to keep calcium levels normal and allow normal bone growth.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adult dose:`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Treatment of Vitamin D deficiency: 40,000 IU per week for 7 weeks, followed by maintenance therapy (1400-2000 IU/day).",
          "Prevention of Vitamin D deficiency : 20,000 IU per month.",
          "Children dose (12-18 years)",
          "Treatment of Vitamin D deficiency: 20,000 IU once every 2 weeks for 6 weeks.",
          "Prevention of Vitamin D deficiency: 20,000 IU once every 6 weeks.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occuring side effects are hypercalcaemia, hypercalciuria, skin rash, pruritus, urticaria, nausea, abdominal pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Precaution should be taken in renal, cardiac & all hypercalcaemia associated patient.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Vitamin D is contraindicated in patients with high amount of phosphate in the blood, high amount of calcium in the blood, excessive amount of Vitamin-D in the blood, nephrolithiasis, decreased kidney function. Vitamin D is also contraindicated in patients having hypersensitivity to Vitamin D. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Studies have shown safe use of doses up to 4,000 IU during pregnancy. The recommended daily intake for pregnant women is 400 IU, however, in women who are considered to be Vitamin D deficient a higher dose may be required. During pregnancy women should follow the advice of their medical practitioner as their requirements may vary depending on the severity of their disease and their response to treatment Vitamin D and its metabolites are excreted in breast milk. Overdose in infants induced by nursing mothers has not been observed; however, when prescribing additional Vitamin D to a breast-fed child the practitioner should consider the dose of any additional Vitamin D given to the mother.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Vitamin D can lead to hypervitaminosis D.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Vitamin D interferes with phenytoin, barbiturates, glucocorticoids, certain laxative (such as liquid paraffin), actinomycin and imidazole antifungal agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxvit® D 20000 Capsule: Each box contains 10 capsules of 20,000 IU of Cholecalciferol in Alu-Alu blister strips.",
          "Maxvit® D 40000 Capsule: Each box contains 10 capsules of 40,000 IU of Cholecalciferol in Alu-Alu blister strips.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 43,
    title: "Maxvit D 40000 Tablet",
    therapeutic_class: "vitamin & minerals",

    text1: " ",
    text2: " ",
    imgf: maxvitd40000fr,
        imge: maxvitd40000bk,
    img: [
      {
        id: 43,
        imgf: maxvitd40000fr,
        imge: maxvitd40000bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Maxvit 4000",
    innerComposition: "Cholecalciferol BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxvit® D 20000 Capsule: Each capsule contains Cholecalciferol BP 20,000 IU.",
          "Maxvit® D 40000 Capsule: Each capsule contains Cholecalciferol BP 40,000 IU.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Maxvit® D is a preparation of Cholecalciferol, a synthetic of Vitamin D3. It is essential for normal bone growth and development and to maintain bone density. Cholecalciferol helps our body to utilize both Calcium and Phosphorus. It acts as a hormone and increases reabsorption of Calcium and Phosphorus by the kidneys.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Vitamin D is used to treat and prevent bone disorders. Vitamin D is also used with other medications to treat low levels of calcium or phosphate caused by certain disorder. It may be used in kidney disease to keep calcium levels normal and allow normal bone growth.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adult dose:`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Treatment of Vitamin D deficiency: 40,000 IU per week for 7 weeks, followed by maintenance therapy (1400-2000 IU/day).",
          "Prevention of Vitamin D deficiency : 20,000 IU per month.",
          "Children dose (12-18 years)",
          "Treatment of Vitamin D deficiency: 20,000 IU once every 2 weeks for 6 weeks.",
          "Prevention of Vitamin D deficiency: 20,000 IU once every 6 weeks.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occuring side effects are hypercalcaemia, hypercalciuria, skin rash, pruritus, urticaria, nausea, abdominal pain.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Precaution should be taken in renal, cardiac & all hypercalcaemia associated patient.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Vitamin D is contraindicated in patients with high amount of phosphate in the blood, high amount of calcium in the blood, excessive amount of Vitamin-D in the blood, nephrolithiasis, decreased kidney function. Vitamin D is also contraindicated in patients having hypersensitivity to Vitamin D. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Studies have shown safe use of doses up to 4,000 IU during pregnancy. The recommended daily intake for pregnant women is 400 IU, however, in women who are considered to be Vitamin D deficient a higher dose may be required. During pregnancy women should follow the advice of their medical practitioner as their requirements may vary depending on the severity of their disease and their response to treatment Vitamin D and its metabolites are excreted in breast milk. Overdose in infants induced by nursing mothers has not been observed; however, when prescribing additional Vitamin D to a breast-fed child the practitioner should consider the dose of any additional Vitamin D given to the mother.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Vitamin D can lead to hypervitaminosis D.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Vitamin D interferes with phenytoin, barbiturates, glucocorticoids, certain laxative (such as liquid paraffin), actinomycin and imidazole antifungal agents.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Maxvit® D 20000 Capsule: Each box contains 10 capsules of 20,000 IU of Cholecalciferol in Alu-Alu blister strips.",
          "Maxvit® D 40000 Capsule: Each box contains 10 capsules of 40,000 IU of Cholecalciferol in Alu-Alu blister strips.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 44,
    title: "Microcef 50ml Syrup",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: microcef50fr,
    imge: microcef50bk,
    img: [
      {
        id: 44,
        imgf: microcef50fr,
        imge: microcef50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Microcef 50ml",
    innerComposition: "Cefixime Trihydrate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 200 mg.",
          "Microcef® 400 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 400 mg.",
          "Microcef® Powder for Suspension: After reconstitution each 5 ml suspension contains Cefixime Trihydrate BP equivalent to Cefixime 100 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefixime is a broad spectrum cephalosporin antibiotic of third generation for oral administration. It is a Bactericidal antibiotic. Cefixime kills bacteria by interfering in the synthesis of the bacterial cell wall. Cefixime is highly active against Neisseria gonorrhoeae, Haemophilus influenzae, Moraxella catarrhalis including betalactamase producers, most of the Enterobacteriaceae, betahaemolytic Streptococci (group A & B) and Streptococcus pneumoniae. Cefixime is more active than other oral cephalosporins against Escherichia coli, Klebsiella spp., Proteus mirabilis, Serratia marcescens and Streptococcus pyogenes. 40-50% of an oral dose is absorbed from gastro-intestinal tract, whether taken with meals or not. The plasma half-life is usually about 3 to 4 hours and may be prolonged when there is renal impairment.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Cefixime is indicated for the treatment of urinary tract infections, typhoid fever, tonsillitis, upper and lower respiratory tract infections, acute otitis media, gonococcal urethritis and enteric fever.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adult & child over 12 years: 200 - 400 mg daily in 1-2 divided doses for 7-14 days, according to the severity of the infection. Except for urinary tract infections where once daily dosing must be used.
        Uncomplicated gonorrhoea: Adult: 400 mg for 1 dose.
        Child over 6 month: 8 mg/kg/daily as a single dose or in two divided doses for 7-14 days. Except for urinary tract infections where once daily dosing must be used.
        Children weighing more than 50 kg or older than 12 years should be treated with the recommended adult dose.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `No data are available, so it is probably best to avoid using the drug during pregnancy and by the nursing mothers.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It should not be used in patients hypersensitive to any cephalosporin antibiotic.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Cefixime is generally well tolerated. The majority of side effects observed in clinical trials were mild and self-limiting in nature. Diarrhoea, nausea, abdominal pain, dyspepsia, Headache, dizziness have been reported.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefixime should be prescribed with caution in individuals with a history of gastrointestinal diseases, particularly colitis. Dosage adjustment is only necessary in severe renal failure (creatinine clearance <20 ml. min-1).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Patients receiving anticoagulants and Cefixime concomitantly increase prothrombin time.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Gastric lavage may be indicated; otherwise, no specific antidote exists. Cefixime is not removed in significant quantities from the circulation by hemodialysis or peritoneal dialysis. Adverse reactions in small numbers of healthy adult volunteers receiving single doses up to 2 g of Cefixime did not differ from the profile seen in patients treated at the recommended doses.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Capsule & Dry powder for Suspension: Store in a cool (Below 30⁰c. Temp.) and dry place, away from light. Keep out of the reach of children. The reconstituted suspension should be used within 7 days if kept in room temperature or within 14 days if refrigerated.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each commercial box contains 2 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® 400 Capsule: Each commercial box contains 1 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® Powder for Suspension: Each bottle contains dry powder for preparation of 30 & 50 ml suspension with a measuring cup and dropper for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 45,
    title: "Microcef 200 Capsule",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: microcef200fr,
    imge: microcef200bk,
    img: [
      {
        id: 45,
        imgf: microcef200fr,
        imge: microcef200bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Microcef",
    innerComposition: "Cefixime Trihydrate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 200 mg.",
          "Microcef® 400 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 400 mg.",
          "Microcef® Powder for Suspension: After reconstitution each 5 ml suspension contains Cefixime Trihydrate BP equivalent to Cefixime 100 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefixime is a broad spectrum cephalosporin antibiotic of third generation for oral administration. It is a Bactericidal antibiotic. Cefixime kills bacteria by interfering in the synthesis of the bacterial cell wall. Cefixime is highly active against Neisseria gonorrhoeae, Haemophilus influenzae, Moraxella catarrhalis including betalactamase producers, most of the Enterobacteriaceae, betahaemolytic Streptococci (group A & B) and Streptococcus pneumoniae. Cefixime is more active than other oral cephalosporins against Escherichia coli, Klebsiella spp., Proteus mirabilis, Serratia marcescens and Streptococcus pyogenes. 40-50% of an oral dose is absorbed from gastro-intestinal tract, whether taken with meals or not. The plasma half-life is usually about 3 to 4 hours and may be prolonged when there is renal impairment.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Cefixime is indicated for the treatment of urinary tract infections, typhoid fever, tonsillitis, upper and lower respiratory tract infections, acute otitis media, gonococcal urethritis and enteric fever.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adult & child over 12 years: 200 - 400 mg daily in 1-2 divided doses for 7-14 days, according to the severity of the infection. Except for urinary tract infections where once daily dosing must be used.
        Uncomplicated gonorrhoea: Adult: 400 mg for 1 dose.
        Child over 6 month: 8 mg/kg/daily as a single dose or in two divided doses for 7-14 days. Except for urinary tract infections where once daily dosing must be used.
        Children weighing more than 50 kg or older than 12 years should be treated with the recommended adult dose.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `No data are available, so it is probably best to avoid using the drug during pregnancy and by the nursing mothers.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It should not be used in patients hypersensitive to any cephalosporin antibiotic.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Cefixime is generally well tolerated. The majority of side effects observed in clinical trials were mild and self-limiting in nature. Diarrhoea, nausea, abdominal pain, dyspepsia, Headache, dizziness have been reported.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefixime should be prescribed with caution in individuals with a history of gastrointestinal diseases, particularly colitis. Dosage adjustment is only necessary in severe renal failure (creatinine clearance <20 ml. min-1).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Patients receiving anticoagulants and Cefixime concomitantly increase prothrombin time.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Gastric lavage may be indicated; otherwise, no specific antidote exists. Cefixime is not removed in significant quantities from the circulation by hemodialysis or peritoneal dialysis. Adverse reactions in small numbers of healthy adult volunteers receiving single doses up to 2 g of Cefixime did not differ from the profile seen in patients treated at the recommended doses.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Capsule & Dry powder for Suspension: Store in a cool (Below 30⁰c. Temp.) and dry place, away from light. Keep out of the reach of children. The reconstituted suspension should be used within 7 days if kept in room temperature or within 14 days if refrigerated.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each commercial box contains 2 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® 400 Capsule: Each commercial box contains 1 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® Powder for Suspension: Each bottle contains dry powder for preparation of 30 & 50 ml suspension with a measuring cup and dropper for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 46,
    title: "Microcef 400 Capsule",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: microcef400fr,
    imge: microcef400bk,
    img: [
      {
        id: 46,
        imgf: microcef400fr,
        imge: microcef400bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Microcef",
    innerComposition: "Cefixime Trihydrate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 200 mg.",
          "Microcef® 400 Capsule: Each capsule contains Cefixime Trihydrate BP equivalent to Cefixime 400 mg.",
          "Microcef® Powder for Suspension: After reconstitution each 5 ml suspension contains Cefixime Trihydrate BP equivalent to Cefixime 100 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefixime is a broad spectrum cephalosporin antibiotic of third generation for oral administration. It is a Bactericidal antibiotic. Cefixime kills bacteria by interfering in the synthesis of the bacterial cell wall. Cefixime is highly active against Neisseria gonorrhoeae, Haemophilus influenzae, Moraxella catarrhalis including betalactamase producers, most of the Enterobacteriaceae, betahaemolytic Streptococci (group A & B) and Streptococcus pneumoniae. Cefixime is more active than other oral cephalosporins against Escherichia coli, Klebsiella spp., Proteus mirabilis, Serratia marcescens and Streptococcus pyogenes. 40-50% of an oral dose is absorbed from gastro-intestinal tract, whether taken with meals or not. The plasma half-life is usually about 3 to 4 hours and may be prolonged when there is renal impairment.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Cefixime is indicated for the treatment of urinary tract infections, typhoid fever, tonsillitis, upper and lower respiratory tract infections, acute otitis media, gonococcal urethritis and enteric fever.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adult & child over 12 years: 200 - 400 mg daily in 1-2 divided doses for 7-14 days, according to the severity of the infection. Except for urinary tract infections where once daily dosing must be used.
        Uncomplicated gonorrhoea: Adult: 400 mg for 1 dose.
        Child over 6 month: 8 mg/kg/daily as a single dose or in two divided doses for 7-14 days. Except for urinary tract infections where once daily dosing must be used.
        Children weighing more than 50 kg or older than 12 years should be treated with the recommended adult dose.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `No data are available, so it is probably best to avoid using the drug during pregnancy and by the nursing mothers.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It should not be used in patients hypersensitive to any cephalosporin antibiotic.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Cefixime is generally well tolerated. The majority of side effects observed in clinical trials were mild and self-limiting in nature. Diarrhoea, nausea, abdominal pain, dyspepsia, Headache, dizziness have been reported.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefixime should be prescribed with caution in individuals with a history of gastrointestinal diseases, particularly colitis. Dosage adjustment is only necessary in severe renal failure (creatinine clearance <20 ml. min-1).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Patients receiving anticoagulants and Cefixime concomitantly increase prothrombin time.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Gastric lavage may be indicated; otherwise, no specific antidote exists. Cefixime is not removed in significant quantities from the circulation by hemodialysis or peritoneal dialysis. Adverse reactions in small numbers of healthy adult volunteers receiving single doses up to 2 g of Cefixime did not differ from the profile seen in patients treated at the recommended doses.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Capsule & Dry powder for Suspension: Store in a cool (Below 30⁰c. Temp.) and dry place, away from light. Keep out of the reach of children. The reconstituted suspension should be used within 7 days if kept in room temperature or within 14 days if refrigerated.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Microcef® 200 Capsule: Each commercial box contains 2 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® 400 Capsule: Each commercial box contains 1 x 7’s capsules in Alu-Alu blister pack.",
          "Microcef® Powder for Suspension: Each bottle contains dry powder for preparation of 30 & 50 ml suspension with a measuring cup and dropper for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 47,
    title: "Monocal D Box Tablet",
    therapeutic_class: "vitamin & minerals",

    text1: " ",
    text2: " ",
    imgf: monocaldboxfr,
    imge: monocaldboxbk,
    img: [
      {
        id: 47,
        imgf: monocaldboxfr,
        imge: monocaldboxbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Monocal",
    innerComposition: "Calcium  500",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Monocal Tablet: Each tablet contains Calcium Carbonate USP 1250 mg equivalent to 500 mg of Calcium.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Monocal is a preparation of Calcium Carbonate. Calcium Carbonate is a salt, which after taking provides calcium in the body. Calcium requirement varies with age. If calcium intake is inadequate, bone mineralization may be impaired in children and bone loss accelerated in adults.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Monocal is indicated -`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "For dietary calcium supplement when it is deficient",
          "As a phosphate binder in chronic renal failure",
          "As an adjunct therapy in the arrest or slowing down of bone demineralizationin osteoporosis",
          "Raised calcium requirement, e.g. during pregnancy and lactation, and in children and adolescents at times of rapid growth",
          "Disorders of osteogenesis and tooth formation (in addition to specific treatment) ",
          "Helps in maintaining bone mass",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adult: One tablet (500 mg elemental Calcium) daily or as directed by the physician. Higher doses should not be taken unless recommended by the physician.
        Children: 250 mg elemental Calcium daily or as directed by the physician. 
        Adolescents: 250-500 mg elemental Calcium daily or as directed by the physician.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Mild gastrointestinal disturbances (e.g. flatulence, abdominal pain, constipation) may occur. Hypercalcaemia and alkalosis are rarely produced with large doses. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Hypercalcaemia and hyperparathyroidism, Hypercalciuria and nephrolithiasis, Zollinger-Ellison syndrome. Concomitant digoxin therapy requires careful monitoring of serum calcium level.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Calcium Carbonate may enhance the cardiac effects of digoxin and other cardiac glycosides, if systemic hypercalcaemia occurs. Calcium Carbonate may interfere with the absorption of concomitantly administered tetracycline preparations.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Calcium containing drugs are used widely in pregnancy by way of oral calcium supplementation. Calcium Carbonate can be used in lactating women too.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `When hypercalcaemia occurs, discontinuation of the drug is usually sufficient to return serum calcium concentrations to normal. Calcium salts should be used cautiously in patients with sarcoidosis, renal or cardiac disease, and in patients receiving cardiac glycosides.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Monocal Tablet: Each box contains 5x10’s tablets in blister strip.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 48,
    title: "Monocal D Pot Tablet",
    therapeutic_class: "vitamin & minerals",

    text1: " ",
    text2: " ",
    imgf: monocaldpotfr,
    imge: monocaldpotbk,
    img: [
      {
        id: 48,
        imgf: monocaldpotfr,
        imge: monocaldpotbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Monocal-D",
    innerComposition: "Calcium USP  500 mg & Vitamin D3 USP 200 IU ",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Monocal-D: Each film coated tablet contains- Calcium Carbonate USP 1250 mg equivalent to 500 mg elemental Calcium and Vitamin D3 USP 200 IU.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGICAL ACTION",
        innerData: `Monocal-D is a combination of Calcium & Vitamin D3. Calcium is needed for the formation of strong bones and healthy teeth and is involved in helping the blood to clot when required. It is also required to transmit nerve signals and help muscles to work. Vitamin D3 is also essential for healthy bones as it aids in calcium absorption from the GI tract. In addition to this, it stimulates bone formation &calcium deposition. Clinical studies show that calcium and vitamin D3 has synergistic effects on bone growth as well as in osteoporosis and fracture prevention especially at older age.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Monocal-D is used for the treatment of osteoporosis, osteomalacia, rickets, tetany, and parathyroid diseases. It is used in higher calcium requirement for children and adolescents at times of rapid growth, inadequate intake of calcium in the diet, prevention and treatment of osteoporosis, disorders of osteogenesis and tooth formation (in addition to specific treatment), latent tetany and during pregnancy and lactation to meet the additional requirement. It is also used as routine supplement and phosphate binder in chronic renal failure.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adults, elderly and children above 12 years of age: 2 tablets daily, preferably one tablet in morning and evening.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Hypersensitivity to any component of Monocal-D. Hypercalcaemia, as a result of hyperparathyroidism, vitamin D3 overdose, decalcifying tumours such as myeloma, bone metastasis or sarcoidosis, severe hypercalciuria, renal stones  and osteoporosis due to prolonged immobilization.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `The use of calcium supplements may give rise to mild gastro-intestinal disturbances, such as constipation, flatulence, nausea, gastric pain, diarrhoea. Following administration of vitamin D3 supplements, occasional skin rashes has been reported. Hypercalciuria and in rare cases hypercalcaemia, have been seen with long term treatment at high dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Normal requirements of calcium & vitamin D3 are raised during pregnancy & lactation. Calcium is excreted in breast milk but not sufficiently to produce adverse effects in the infant. During pregnancy & lactation, Monocal-D therapy should be under strict medical supervision. Children: Children under 12 years of age should not be treated with Monocal-D.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION AND WARNING",
        innerData: `When hypercalcaemia occurs, discontinuation of the drug is usually sufficient to return serum calcium concentrations to normal. Calcium salts should be used cautiously in patients with sarcoidosis, renal or cardiac disease and in patients receiving cardiac glycosides. Patients with a history of stone formation should also be recommended to increase their fluid intake.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `It has possible interaction with digoxin, antacids containing calcium, aluminium or magnesium, other calcium supplements, calcitriol or other vitamin D3 supplements, tetracycline, doxycycline etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `The most serious consequence of acute or chronic overdose is hypercalcaemia due to vitamin D toxicity. Symptoms include nausea, vomiting, polyuria and constipation. Chronic overdoses can lead to vascular and organ calcification as a result of hypercalcaemia. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Each box contains 6x10 tablets in blister strip & 30 tablets in HDPE container.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 49,
    title: "My Zinc Tablet",
    therapeutic_class: "vitamin & minerals",

    text1: " ",
    text2: " ",
    imgf: myzincfr,
    imge: myzincbk,
    img: [
      {
        id: 49,
        imgf: myzincfr,
        imge: myzincbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "My zinc",
    innerComposition: "Zinc USP 20 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `My zinc® 20 tablet: Each tablet contains Zinc Sulphate monohydrate USP equivalent to 20mg elemental Zinc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Zinc is a mineral. It is called an "essential trace element" because very small amount of Zinc is necessary for human health. Zinc is needed for the proper growth and maintenance of the human body. It is found in several systems and biological reactions and it is needed for immune function, wound healing, blood clotting, thyroid function and much more.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Since the human body does not store excess Zinc, it must be consumed regularly as part of the diet. Zinc plays a key role in maintaining vision and it is present in high concentrations in the eye. Zinc might also have effects against viruses.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Children under 10 kg: 10mg or ½ tablet (if the children can swallow) 2 times daily or as directed by the physician.",
          "Children (10-30 kg): 1 tablet 1-3 times daily or as directed by the physician.",
          "Adults and children over 30 kg: 2 tablets daily or as directed by the physician.",
          "Zinc supplements are most effective if they are taken at least 1 hour before or 2 hour after a meal, if Zinc supplements cause stomach upset, they may be taken with a meal.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occuring side effects are nausea, vomiting, gastric irritation, metallic taste, headache, neurologic deterioration etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Concurrent administration of Zinc salt with penicillamine might diminish the effect of Penicillamine. Chelation may occur with Tetracyclines.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Zinc is contraindicated in patients with hypersensitivity to Zinc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnant women and lactating mother should avoid zinc doses higher than Recommended Dietary Allowance (RDA).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData: `Zinc Sulphate is corrosive at overdose. Symptoms are corrosion and inflammation of the mucous membrane of the mouth and stomach, ulceration of the stomach followed by perforation may occur.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Zinc tablets might interact with some group of drugs like Quinolone, Tetracycline antibiotics, Penicillamine etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Protected from light, store in cool (Below 30°C. Temp.) and dry place. Keep out of reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `My zinc® 20 tablet: Each box contains 3 X 10’s tablets in blister strips.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 50,
    title: "Neovera 6 Tablet",
    therapeutic_class: "anti-parasitic",

    text1: " ",
    text2: " ",
    imgf: novera6fr,
    imge: novera6bk,
    img: [
      {
        id: 50,
        imgf: novera6fr,
        imge: novera6bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Neovera 6",
    innerComposition: "Ivermectin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Neovera® 6 tablet: Each tablet contains Ivermectin BP 6 mg.",
          "Neovera® 12 tablet: Each tablet contains Ivermectin BP 12mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `This medication is used to treat certain parasitic roundworm infections. Ivermectin belongs to a class of drugs known as anthelmintics. It works by paralyzing and killing parasites. Ivermectin are macrocyclic lactones derived from the bacterium Streptomyces avermitilis. Ivermectin kills by interfering with nervous system and muscle function, in particular by enhancing inhibitory neurotransmission. It binds to glutamate-gated chloride channels in the membranes of invertebrate nerve and muscle cells, causing increased permeability to chloride ions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Ivermectin oral tablet is used to treat infections of parasites. These include parasitic infections of intestinal tract, skin and eyes etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The recommended dosage of ivermectin is a single oral dose designed to provide approximately 200 mcg of ivermectin per kg of body weight. It should be taken at least 1 hour before meal in an empty stomach.
        Dosage guidelines based on body weight:
        15 to 24 kg: 3 mg orally one time
        25 to 35 kg: 6 mg orally one time
        36 to 50 kg: 9 mg orally one time
        51 to 65 kg: 12 mg orally one time
        66 to 80 kg: 15 mg orally one time
        85 kg or more: Approx 200 mg/kg
        Classic/typical scabies: 2 doses (1 dose on day 1 and another dose between day 8 and day 15). Ivermectin can be used alone or in combination with a topical scabicide.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occuring side effects are tiredness, loss of energy,stomach pain, loss of appetite, nausea, vomiting, diarrhea, dizziness, sleepiness or drowsiness,itchiness.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly, pediatric and allergic patient.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ivermectin is contraindicated in patients having hypersensitivity to this drug and those patients who taken warfarin. It is also contraindicated in a history of asthma, hepatic and HIV patients.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ivermectin is secreted in very low concentration in breast milk. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In case of overdose one need to employ the usual supportive measures e.g., remove unabsorbed material from the gastrointestinal tract, employ clinical monitoring and institute supportive treatment as dictated by the patient’s clinical status.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Ivermectin should not be used with aprepitant because of the potential for adverse effects. Care should be taken when administering Ivermectin with anticoagulants since co-administration may cause an enhanced anticoagulants effect. Ivermectin should not be taken with antiviral drugs.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (below 300 C temp.) and dry place, protected from light. Keep out of reach children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Neovera® 6 tablet: Each box contains 2 x 10 tablets in blister strips.",
          "Neovera® 6 tablet: Each box contains 2 x 10 tablets in blister strips.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 51,
    title: "Novera 12 Tablet",
    therapeutic_class: "anti-parasitic",

    text1: " ",
    text2: " ",
    imgf: novera12fr,
    imge: novera12bk,
    img: [
      {
        id: 51,
        imgf: novera12fr,
        imge: novera12bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Neovera 12",
    innerComposition: "Ivermectin BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Neovera® 6 tablet: Each tablet contains Ivermectin BP 6 mg.",
          "Neovera® 12 tablet: Each tablet contains Ivermectin BP 12mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `This medication is used to treat certain parasitic roundworm infections. Ivermectin belongs to a class of drugs known as anthelmintics. It works by paralyzing and killing parasites. Ivermectin are macrocyclic lactones derived from the bacterium Streptomyces avermitilis. Ivermectin kills by interfering with nervous system and muscle function, in particular by enhancing inhibitory neurotransmission. It binds to glutamate-gated chloride channels in the membranes of invertebrate nerve and muscle cells, causing increased permeability to chloride ions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Ivermectin oral tablet is used to treat infections of parasites. These include parasitic infections of intestinal tract, skin and eyes etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The recommended dosage of ivermectin is a single oral dose designed to provide approximately 200 mcg of ivermectin per kg of body weight. It should be taken at least 1 hour before meal in an empty stomach.
        Dosage guidelines based on body weight:
        15 to 24 kg: 3 mg orally one time
        25 to 35 kg: 6 mg orally one time
        36 to 50 kg: 9 mg orally one time
        51 to 65 kg: 12 mg orally one time
        66 to 80 kg: 15 mg orally one time
        85 kg or more: Approx 200 mg/kg
        Classic/typical scabies: 2 doses (1 dose on day 1 and another dose between day 8 and day 15). Ivermectin can be used alone or in combination with a topical scabicide.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Commonly occuring side effects are tiredness, loss of energy,stomach pain, loss of appetite, nausea, vomiting, diarrhea, dizziness, sleepiness or drowsiness,itchiness.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Precaution should be taken in elderly, pediatric and allergic patient.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Ivermectin is contraindicated in patients having hypersensitivity to this drug and those patients who taken warfarin. It is also contraindicated in a history of asthma, hepatic and HIV patients.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Safety in human pregnancy has not been established. Ivermectin is secreted in very low concentration in breast milk. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In case of overdose one need to employ the usual supportive measures e.g., remove unabsorbed material from the gastrointestinal tract, employ clinical monitoring and institute supportive treatment as dictated by the patient’s clinical status.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Ivermectin should not be used with aprepitant because of the potential for adverse effects. Care should be taken when administering Ivermectin with anticoagulants since co-administration may cause an enhanced anticoagulants effect. Ivermectin should not be taken with antiviral drugs.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (below 300 C temp.) and dry place, protected from light. Keep out of reach children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Neovera® 6 tablet: Each box contains 2 x 10 tablets in blister strips.",
          "Neovera® 6 tablet: Each box contains 2 x 10 tablets in blister strips.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 52,
    title: "Neuroprax Pot Tablet",
    therapeutic_class: "anti-neuropathic",

    text1: " ",
    text2: " ",
    imgf: neuropraxpotfr,
        imge: neuropraxpotbk,
    img: [
      {
        id: 52,
        imgf: neuropraxpotfr,
        imge: neuropraxpotbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Neuroprax",
    innerComposition: "Vit-B1+Vit-B6+Vit-B12      ",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Neuroprax: Each film coated tablet contains Thiamine Hydrochloride (Vit-B1) BP 100 mg, Pyridoxine Hydrochloride (Vit-B6) BP 200 mg &Cyanocobalamine (Vit-B12) BP 200 mcg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Neuroprax is a combination of Thiamine Hydrochloride (Vit-B1), Pyridoxine Hydrochloride (Vit-B6) & Cyanocobalamin (Vit-B12). These B-vitamins play an essential role as co-enzyme in the cellular biochemical metabolism in the nervous system. Thus the combination normalizes metabolic condition of nerve cells and improves neural condition. Neuroprax supports the regeneration of nerve fibers and myelin sheath by activation of the metabolism and the natural repair mechanism.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Neuroprax Tablet indicated for deficiency of the relavent vitamins exists. It is indicated for the treatment of following diseases - Polyneuropathy of any origin (such as-Diabetic, Alcoholic or Toxic neuropathies), Neuritis, Neuralgia, Cervical Syndrome, Shoulder-Arm syndrome, Lumbago, Sciatica, Myalgia, Intercostal neuralgia, Herpes Zoster and Trigeminal Neuralgia, supportive treatment in facial paresis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `1 to 3 tablets daily preferably after meals or as directed by the physician.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Should not be used in patients on Levodopa therapy and hypersensitive to any of its components.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Neuroprax is generally well-tolerated. In rare cases, few allergic reactions may occur.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Cyanocobalamin should not be given before a diagnosis has been fully established because of the possibility of masking of the symptoms of subacute degeneration of the spinal cord. Cyanocobalamin is not a suitable form of Vitamin B12 for the treatment of optic neuropathies associated with raised plasma concentration of cyanocobalamin.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Sufficient data yet not available in this respect. So, Neuroprax tablet is to be taken if advised by physician during pregnancy and lactation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `No drug interactions have yet been reported.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Each box contains 6x10 tablets in Alu-PVDC blister pack and 30 tablets HDPE container.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 53,
    title: "Norxit Tablet",
    therapeutic_class: "antidepressant",

    text1: " ",
    text2: " ",
    imgf: norxitfr,
    imge: norxitbk,
    img: [
      {
        id: 53,
        imgf: norxitfr,
        imge: norxitbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Norxit",
    innerComposition: "Flupentixol 0.5 mg & Melitracen 10 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Each film coated tablet contains- Flupentixol Dihydrochloride BP 0.584 mg Eqvt. to Flupentixol 0.5 mg & Melitracen Hydrochloride INN 11.25 mg Eqvt. to Melitracen 10 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },

      {
        innerHead: "INDICATIONS",
        innerData: `• Anxiety  • Depression  • Apathy • Others are Psychogenic depression, depressive neuroses, masked depression, psychosomatic affections accompanied by anxiety and apathy, menopausal depression. Dysphoria and depression in alcoholics and drug addicts.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adults: Usually 2 tablets daily (morning and noon). In severe cases the morning dose may be increased to 2 tablets. Elderly patients: 1 tablet in the morning. Maintenance dose: Usually 1 tablet in the morning. In cases of insomnia or severe restlessness additional treatment with a sedative in the acute phase is recommended. Second dose should not be taken after 4 pm.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `The immediate recovery phase after myocardial infarction. Defects in bundle-branch conduction. Untreated narrow angle glaucoma. Acute alcohol, barbiturate and opiate intoxication. Flupentixol and Melitracen should not be given to patients who have received a MAO inhibitor within two weeks. Not recommended for excitable patient since its activating effect may lead to exaggeration of these characteristics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `If previously the patient has been treated with tranquilizers with sedative effects these should be withdrawn gradually.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Flupentixol and Melitracen may enhance the response to alcohol, barbiturates and other CNS depressants. Simultaneous administration of MAO inhibitors may cause hypertensive crisis. Neuroleptics and thymoleptics reduce the antihypertensive effect of Guanethidine and similar acting compounds and thymoleptics enhance the effects of adrenaline and noradrenaline.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `In the recommended doses side effects are rare. These could be transient
        restlessness and insomnia.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN SPECIAL POPULATION",
        innerData: `Pregnancy and lactation: Flupentixol and Melitracen should preferably not be given during pregnancy and lactation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Norxit Tablet: Box containing 50 tablets in 5 x 10’s blister strips.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 54,
    title: "Norxit Tablet",
    therapeutic_class: "antidepressant",

    text1: " ",
    imgf: norxitfr,
    imge: norxitbk,
    text2: " ",
    img: [
      {
        id: 54,
        imgf: norxitfr,
        imge: norxitbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Norxit",
    innerComposition: "Flupentixol 0.5 mg & Melitracen 10 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Each film coated tablet contains- Flupentixol Dihydrochloride BP 0.584 mg Eqvt. to Flupentixol 0.5 mg & Melitracen Hydrochloride INN 11.25 mg Eqvt. to Melitracen 10 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },

      {
        innerHead: "INDICATIONS",
        innerData: `• Anxiety  • Depression  • Apathy • Others are Psychogenic depression, depressive neuroses, masked depression, psychosomatic affections accompanied by anxiety and apathy, menopausal depression. Dysphoria and depression in alcoholics and drug addicts.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Adults: Usually 2 tablets daily (morning and noon). In severe cases the morning dose may be increased to 2 tablets. Elderly patients: 1 tablet in the morning. Maintenance dose: Usually 1 tablet in the morning. In cases of insomnia or severe restlessness additional treatment with a sedative in the acute phase is recommended. Second dose should not be taken after 4 pm.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `The immediate recovery phase after myocardial infarction. Defects in bundle-branch conduction. Untreated narrow angle glaucoma. Acute alcohol, barbiturate and opiate intoxication. Flupentixol and Melitracen should not be given to patients who have received a MAO inhibitor within two weeks. Not recommended for excitable patient since its activating effect may lead to exaggeration of these characteristics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `If previously the patient has been treated with tranquilizers with sedative effects these should be withdrawn gradually.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Flupentixol and Melitracen may enhance the response to alcohol, barbiturates and other CNS depressants. Simultaneous administration of MAO inhibitors may cause hypertensive crisis. Neuroleptics and thymoleptics reduce the antihypertensive effect of Guanethidine and similar acting compounds and thymoleptics enhance the effects of adrenaline and noradrenaline.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `In the recommended doses side effects are rare. These could be transient
        restlessness and insomnia.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN SPECIAL POPULATION",
        innerData: `Pregnancy and lactation: Flupentixol and Melitracen should preferably not be given during pregnancy and lactation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Norxit Tablet: Box containing 50 tablets in 5 x 10’s blister strips.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 55,
    title: "Novotril 0.5 Tablet",
    therapeutic_class: "antidepressant",

    text1: " ",
    text2: " ",
    imgf: novotril05fr,
    imge: novotril05bk,
    img: [
      {
        id: 55,
        imgf: novotril05fr,
        imge: novotril05bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Novotril",
    innerComposition: "Clonazepam BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Novotril® 0.5 Tablet: Each tablet contains- Clonazepam BP 0.5 mg.",
          "Novotril® 2 Tablet: Each tablet contains- Clonazepam BP 2 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Novotril® (Clonazepam) acts by binding to the benzodiazepine site of the GABA receptors, which enhances the electric effect of GABA binding on neurons, resulting in an increased influx of chloride ions into the neurons. This further results in an inhibition of synaptic transmission across the CNS. Benzodiazepines do not have any effect on the levels of GABA in the brain. Clonazepam has no effect on GABA levels and has no effect on gamma-aminobutyric acid transaminase. Clonazepam does, however, affect glutamate decarboxylase activity. It differs from other anticonvulsant drugs it was compared to in a study.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Novotril® (Clonazepam) is used as an anticonvulsant in the treatment of the Lennox-Gastaut syndrome (petit mal variant), akinetic and myoclonic seizures. It can also be used for the treatment of panic disorders.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Panic Disorder: Adults: The recommended initial dosage of Clonazepam is 0.25 mg twice daily, increment dose is 0.5-1 mg at interval of 3 days. To reduce the inconvenience of somnolence administration of one dose at bedtime may be desirable.
        Children: There is no clinical trial experience with Clonazepam in Panic disorder patients under 18 years of age. 
        Seizure Disorder: Adults: Initial dose is 1 mg/daily in divided dose (elderly 0.5 mg), not to exceed 1.5 mg/day. Increment dose is 0.5 mg at intervals of 3 days. Maintenance dose is 4.8 mg/day. Maximum dose: 20 mg/day should be administered with caution.
        Children: Up to 1 year: 0.25 mg increased to 0.5-1 mg. 1-5 years: 0.25 mg increased to 1-3 mg at intervals of 3 days. Maintenance dose is 4-8 mg/day.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `The common side-effects are fatigue, drowsiness, muscular hypotonia, dizziness, light-headedness and ataxia. These effects are usually transient and generally disappear spontaneously although these can be partially prevented by increasing the dose slowly at the start of treatment.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS:",
        innerData: `Carbamazepine, Phenobarbitone or Phenytoin may accelerate the metabolism of Clonazepam. Intake of alcohol may affect the patient’s response to Clonazepam. Clonazepam may be expected to have the sedative interactions associated with benzodiazepines in general.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `The dosage of Clonazepam must be carefully adjusted to individual requirements in elderly patients with pre existing disease of the respiratory system (chronic obstructive pulmonary disease), renal or hepatic diseases and in patients undergoing treatment with other centrally acting medications or anticonvulsant agents. It should be withdrawn slowly and abrupt discontinuance of the drug should be avoided.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Clonazepam should only be administered to pregnant women if the potential benefit outweighs the risk to the fetus. Not recommended in lactation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Clonazepam is contraindicated in patients with known hypersensitivity to benzodiazepines, acute pulmonary insufficiency and respiratory depression.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (below 30⁰C) and dry place, protected from light. Keep out of the reach of the children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Novotril® 0.5 Tablet: Each box containing 5 x 10’s tablets in blister strips. ",
          "Novotril® 0.5 Tablet: Each box containing 5 x 10’s tablets in blister strips. ",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 56,
    title: "Opmax 20 Capsule",
    therapeutic_class: "anti-ulcerant",

    text1: " ",
    text2: " ",
    imgf: opmax20fr,
    imge: opmax20bk,
    img: [
      {
        id: 56,
        imgf: opmax20fr,
        imge: opmax20bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "OPmax",
    innerComposition: "Omeprazole BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "OPmax®20 Capsule: Each capsule contains- Omeprazole BP 20 mg .",
          "OPmax®40 Capsule: Each capsule contains- Omeprazole BP 40 mg .",
        ],
      },
      {
        innerHead: "INDICATION",
        innerData: `OPmax® capsule is indicated for GERD including-  `,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Reflux esophagitis",
          "Acid reflux diseases",
          "Duodenal and benign gastric ulcers",
          "H. pylori eradication regimens in peptic ulcer disease (PUD)",
          "Prophylaxis of acid aspiration ",
          "Zollinger-Ellison Syndrome (ZES)",
          "NSAIDs-associated gastric ulcers",
          "Gastroduodenal erosions",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `OPmax® (Omeprazole) should be taken before meal.`,
        istable: true,
        table: {
          headers: ["DISEASE", "DOSAGE AND ADMINISTRATION"],
          body: [
            [
              `Gastroesophageal reflux disease including reflux esophagitis`,
              `The usual dosage is 20 mg Omeprazole once daily for 4 weeks.`,
            ],
            [
              `Duodenal and benign gastric ulcers`,
              `The usual dose is 20 mg Omeprazole once daily for 4 weeks in patients with duodenal ulcer and 8 weeks in patients with gastric ulcer.`,
            ],
            [
              `Helicobacter pylori eradication regimens in peptic ulcer disease`,
              `Recommended dose 20 mg twice daily in association with antimicrobial agents Amoxicillin 1 g and Clarithromycin 500 mg both twice a day for 7 to 14 days`,
            ],
            [
              `Prophylaxis of acid aspiration`,
              `For patients considered to be at risk of aspiration of the gastric contents during general anaesthesia, the recommended dosage is Omeprazole 40 mg on the evening before surgery followed by Omeprazole 40 mg 2-6 hours prior to surgery.`,
            ],
            [
              `Zollinger-Ellison syndrome`,
              `The recommended dosage is 60 mg Omeprazole once daily. Maximum dose is 80 mg daily; the dose should be divided and given twice daily.`,
            ],
            [
              `NSAID associated gastric ulcers, duodenal ulcers or gastro duodenal erosions`,
              `The recommended dose is 20 mg once daily. Symptom resolution is rapid and in most patients healing occurs within 4 weeks.`,
            ],
            [
              `GERD or other acid-related disorders`,
              `>1 year-10 mg once daily, if needed, 20 mg once daily 
            >2 year-20 mg once daily, if needed, 40 mg once daily
            `,
            ],
          ],
        },
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SPECIAL POPULATION",
        innerData: `Impaired renal function: Dose adjustment is not necessary. 
        Impaired hepatic function: As plasma half-life of Omeprazole is increased, a daily dose of 10 – 20 mg may be sufficient. 
        Elderly: Dose adjustment is not necessary.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECT",
        innerData: `Omeprazole is well-tolerated. Nausea, diarrhoea, abdominal colic, paresthesia, dizziness and headache have been stated to be generally mild and transient and not requiring a reduction in dosage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `There are no known contraindications to the use of Omeprazole. When gastric ulcer is suspected, the possibility of malignancy should be excluded before treatment with Omeprazole is instituted as treatment may alleviate symptoms and delay diagnosis. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Symptomatic response to therapy with Omeprazole does not preclude the presence of gastric malignancy. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30 ⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "OPmax®20 Capsule: Each box contains 10x10’s capsules in Alu-Alu pack. ",
          "OPmax®20 Capsule: Each box contains 10x10’s capsules in Alu-Alu pack. ",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 57,
    title: "Picocef 70 Syrup",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: picocef70fr,
    imge: picocef70bk,
    img: [
      {
        id: 57,
        imgf: picocef70fr,
        imge: picocef70bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Picocef",
    innerComposition: "Cefuroxime",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Each film coated tablet contains Cefuroxime Axetil USP equivalent to Cefuroxime 250 mg.",
          "Picocef® 500 Tablet: Each film coated tablet contains Cefuroxime Axetil BP equivalent to Cefuroxime 500 mg.",
          "Picocef® PFS: After reconstitution Each 5 ml suspension contains Cefuroxime Axetil USP equivalent to Cefuroxime 125 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefuroxime is 2nd generation cephalosporin which active against a wide range of gram-positive & gram-negative bacteria. Cefuroxime works by binding with beta-lactam ring of bacteria & inhibit bacterial cell wall. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Upper and lower respiratory tract infections, such as acute and chronic bronchitis, pneumonia, sinusitis, otitis media & tonsillitis",
          "Skin & soft tissue infections such as peritonitis.",
          "Urinary tract infections.",
          "Gonorrhoea.",
          "Septicemia.",
          "Meningitis.",
          "Prophylaxis.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adults (>13 years)
        • Pharyngitis/Tonsillitis 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        • Acute bacterial chronic bronchitis 250 or 500 mg bid 10 days.
        • Secondary bacterial infections of acute bronchitis 250-500 mg bid 5-10 days.
        • Uncomplicated skin and skin structure infections 250-500 mg bid 10 days.
        • Uncomplicated urinary tract infections 125-250 mg bid 7-10 days.
        • Uncomplicated gonorrhoea 1000 mg Single dose.
        Children who can swallow tablets
        • Pharyngitis/Tonsillitis 125 mg bid 10 days.
        • Acute otitis media 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        Pediatric patients (3 months to 12 years)
        • Pharyngitis/Tonsillitis 10 mg/kg/day bid 10 days
        • Acute otitis media 15 mg/kg/day bid 10 days
        • Acute bacterial maxillary sinusitis 15 mg/kg/day bid 10 days
        • Impetigo 15 mg/kg/day bid 10 days
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTIONS FOR RECONSTITUTION",
        innerData: `For Suspension: To prepare 70 ml Suspension, at first shake the bottle well to loosen the powder. Then add 40 ml boiled and cooled water with the help of the supplied measuring cup to the powder and shake well. For better reconstitution add the water divided amount.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Patients with known allergy to Cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Generally Cefuroxime is well tolerated. However, a few side effects like nausea, vomiting, diarrhea, abdominal discomfort or pain may occur. Rarely (<0.2%) renal dysfunction, anaphylaxis, angioedema, pruritus, rash and serum sickness like urticaria may appear.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefuroxime should be given with care to patients receiving concurrent treatment with potent diuretics & who have history of colitis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnant women: USFDA pregnancy category B. While all antibiotics should be avoided in the first trimester. If possible, Cefuroxime has been safely used in later pregnancy to treat urinary and other infections`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Concomitant administration of probenecid with Cefuroxime increases the area under the serum concentration versus time curve by 50%. Drug that reduces gastric acidity may result in a lower bioavailability of Cefuroxime and tend to cancel the effect of postprandial absorption.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Overdosage of Cefuroxime tablet can cause cerebral irritation leading to convulsions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, keep away from sunlight. All medicines keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® PFS: After reconstitution, each bottle contains 70 ml suspension and a dropper with measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 58,
    title: "Pregacap 50 Capsule",
    therapeutic_class: "anti-neuropathic",

    text1: " ",
    imgf: pregacap50fr,
    imge: pregacap50bk,
    text2: " ",
    img: [
      {
        id: 58,
        imgf: pregacap50fr,
        imge: pregacap50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Pregacap",
    innerComposition: "Pregabalin INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pregacap® 50 mg Capsule: Each capsule contains Pregabalin INN 50 mg.",
          "Pregacap® 75 mg Capsule: Each capsule contains Pregabalin INN 75 mg.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Pregacap (Pregabalin) is the preparation of Pregabalin, which is an analogue of neurotransmitter gamma-amino-butyric acid (GABA). It does not bind directly to GABAA or GABAB or benzodiazepine receptors. It binds with high affinity to the alpha-delta site (an auxiliary subunit of voltage-gated calcium channels) in central nervous system.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Management of neuropathic pain associated with diabetic peripheral neuropathy",
          "Management of post herpetic neuralgia",
          "Adjunctive therapy for adult patients with partial seizures/Epilepsy",
          "Management of fibromyalgia",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adults over 18 years of age: Pregacap is given orally with or without food. Dosing amounts and frequency of dosing will be decided by the physician.
        Neuropathic pain, associated with diabetic peripheral neuropathy:
        Dosing should begin at 50 mg three times a day (150 mg/day). The dose may be increased to 300 mg/day within 1 week based on efficacy and tolerability. The maximum recommended dose of Pregabalin is 100 mg three times a day (300 mg/day) in patients with creatinine clearance of at least 60 ml/min.
        Post-herpetic Neuralgia 
        The recommended dose is 150 mg to 300 mg daily in 2-3 divided doses in patients with creatinine clearance of at least 60 ml/min.
        Adjunctive Therapy For Adult Patients With Partial Seizures/epilepsy
        The initial dose is 150 mg daily in 2-3 divided doses as adjunctive therapy in the treatment of partial onset seizures in adults.
        Fibromyalgia
        The recommended dose is 300 to 450 mg daily. Dosing should begin at 150 mg daily in two divided doses and may be increased to 300 mg daily in 2 divided doses within 1 week based on efficacy and tolerability.
        Children And Adolescents (<18 Years Of Age)
        The safety and efficacy of Pregabalin has not been established in patients below the age of 18 years, with either epilepsy or neuropathic pain.
        Use In Elderly (Over 65 Years Of Age)
        Elderly patients may require a dose reduction of Pregabalin due to decreased renal function.
        Patients With Renal Impairment
        Creatinine clearance (CrCl)
        >_ 60 ml/min,	Initially 150 mg daily and maximum 600 mgdaily in 2-3 divided doses.
        30- 60 ml/min, Initially 75 mg daily and maximum 300 mg daily in 2-3 divided doses.
        15-30 ml/min,	initially 25-50 mg daily and maximum 150mgdaily in1-2 divided doses.
        <15 ml/min,	Initially 25 mg once daily and maximum 75 mgonce daily.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Most common side-effects are dizziness, somnolence, dry mouth, edema, blurred vision, weight gain and abnormal thinking (primarily difficulty with concentration/attention).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy: Pregabalin is a pregnancy category C drug. It should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus.
        Lactation: It is not known if Pregabalin is excreted in the breast milk of humans but because of the potential for tumorigenicity shown for Pregabalin in animal studies, a decision should be made whether to discontinue nursing or to discontinue the drug, taking into account the importance of the drug to the mother.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Pregabalin is contraindicated in patients with known hypersensitivity to Pregabalin or any of its other components.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Hypersensitivity reactions (e.g. hives, dyspnea, and wheezing) can occur. Pregabalin should be discontinued immediately in these cases. Pregabalin may cause peripheral edema. Caution should be taken in case of exercise or when co-administering Pregabalin and Thiazolidinedione antidiabetic agents. Pregabalin may cause dizziness and somnolence and impair patients ability to drive or operate machinery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `There are no significant interactions between Pregabalin and other antiepileptic drugs like carbamazepine, valproic acid, lamotrigine, phenytoin, phenobarbital, and topiramate. Co-administration of Pregabalin with the oral contraceptives like norethisterone and ethinyl oestradiol does not influence the steady state pharmacokinetics of other agent. Pregabalin may potentiate the effects of ethanol and lorazepam.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `The highest reported accidental overdose of Pregabalin was 8000 mg. The most common adverse events are affective disorder, somnolence, confusional state, depression, agitation and restlessness. Elimination of unabsorbed drug may be attempted by emesis or gastric lavage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pregacap® 50 mg Capsule: Each box contains- 30’s Capsules in blister strips.",
          "Pregacap® 75 mg Capsule: Each box contains- 30’s Capsules in blister strips.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 59,
    title: "Pregacap 75 Capsule",
    therapeutic_class: "anti-neuropathic",

    text1: " ",
    text2: " ",
    imgf: pregacap75fr,
    imge: pregacap75bk,
    img: [
      {
        id: 59,
        imgf: pregacap75fr,
        imge: pregacap75bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Pregacap 75",
    innerComposition: "Pregabalin INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pregacap® 50 mg Capsule: Each capsule contains Pregabalin INN 50 mg.",
          "Pregacap® 75 mg Capsule: Each capsule contains Pregabalin INN 75 mg.",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Pregacap (Pregabalin) is the preparation of Pregabalin, which is an analogue of neurotransmitter gamma-amino-butyric acid (GABA). It does not bind directly to GABAA or GABAB or benzodiazepine receptors. It binds with high affinity to the alpha-delta site (an auxiliary subunit of voltage-gated calcium channels) in central nervous system.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Management of neuropathic pain associated with diabetic peripheral neuropathy",
          "Management of post herpetic neuralgia",
          "Adjunctive therapy for adult patients with partial seizures/Epilepsy",
          "Management of fibromyalgia",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adults over 18 years of age: Pregacap is given orally with or without food. Dosing amounts and frequency of dosing will be decided by the physician.
        Neuropathic pain, associated with diabetic peripheral neuropathy:
        Dosing should begin at 50 mg three times a day (150 mg/day). The dose may be increased to 300 mg/day within 1 week based on efficacy and tolerability. The maximum recommended dose of Pregabalin is 100 mg three times a day (300 mg/day) in patients with creatinine clearance of at least 60 ml/min.
        Post-herpetic Neuralgia 
        The recommended dose is 150 mg to 300 mg daily in 2-3 divided doses in patients with creatinine clearance of at least 60 ml/min.
        Adjunctive Therapy For Adult Patients With Partial Seizures/epilepsy
        The initial dose is 150 mg daily in 2-3 divided doses as adjunctive therapy in the treatment of partial onset seizures in adults.
        Fibromyalgia
        The recommended dose is 300 to 450 mg daily. Dosing should begin at 150 mg daily in two divided doses and may be increased to 300 mg daily in 2 divided doses within 1 week based on efficacy and tolerability.
        Children And Adolescents (<18 Years Of Age)
        The safety and efficacy of Pregabalin has not been established in patients below the age of 18 years, with either epilepsy or neuropathic pain.
        Use In Elderly (Over 65 Years Of Age)
        Elderly patients may require a dose reduction of Pregabalin due to decreased renal function.
        Patients With Renal Impairment
        Creatinine clearance (CrCl)
        >_ 60 ml/min,	Initially 150 mg daily and maximum 600 mgdaily in 2-3 divided doses.
        30- 60 ml/min, Initially 75 mg daily and maximum 300 mg daily in 2-3 divided doses.
        15-30 ml/min,	initially 25-50 mg daily and maximum 150mgdaily in1-2 divided doses.
        <15 ml/min,	Initially 25 mg once daily and maximum 75 mgonce daily.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Most common side-effects are dizziness, somnolence, dry mouth, edema, blurred vision, weight gain and abnormal thinking (primarily difficulty with concentration/attention).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy: Pregabalin is a pregnancy category C drug. It should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus.
        Lactation: It is not known if Pregabalin is excreted in the breast milk of humans but because of the potential for tumorigenicity shown for Pregabalin in animal studies, a decision should be made whether to discontinue nursing or to discontinue the drug, taking into account the importance of the drug to the mother.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Pregabalin is contraindicated in patients with known hypersensitivity to Pregabalin or any of its other components.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Hypersensitivity reactions (e.g. hives, dyspnea, and wheezing) can occur. Pregabalin should be discontinued immediately in these cases. Pregabalin may cause peripheral edema. Caution should be taken in case of exercise or when co-administering Pregabalin and Thiazolidinedione antidiabetic agents. Pregabalin may cause dizziness and somnolence and impair patients ability to drive or operate machinery.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `There are no significant interactions between Pregabalin and other antiepileptic drugs like carbamazepine, valproic acid, lamotrigine, phenytoin, phenobarbital, and topiramate. Co-administration of Pregabalin with the oral contraceptives like norethisterone and ethinyl oestradiol does not influence the steady state pharmacokinetics of other agent. Pregabalin may potentiate the effects of ethanol and lorazepam.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `The highest reported accidental overdose of Pregabalin was 8000 mg. The most common adverse events are affective disorder, somnolence, confusional state, depression, agitation and restlessness. Elimination of unabsorbed drug may be attempted by emesis or gastric lavage.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pregacap® 50 mg Capsule: Each box contains- 30’s Capsules in blister strips.",
          "Pregacap® 75 mg Capsule: Each box contains- 30’s Capsules in blister strips.",
        ],
      },
    ],

    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 60,
    title: "Relikof Kidz Syrup",
    therapeutic_class: "mucolytic",

    text1: " ",
    text2: " ",
    imgf: relikofkidzfr,
    imge: relikofkidzbk,
    img: [
      {
        id: 60,
        imgf: relikofkidzfr,
        imge: relikofkidzbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Relikof® Kidz Linctus",
    innerComposition: "Citric Acid Monohydrate BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Relikof® Kidz Linctus: Each 5 ml Linctus contains Citric Acid Monohydrate BP 31.25 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Relikof® kidz linctus contains Citric Acid Monohydrate BP which is moderately transparent, slightly yellowish, natural Anise flavored sugar free Linctus. It acts as demulent& forms a protective film on surface of respiratory mucus membrane. This Relikof® Kidz Linctus provides a soothing effect on throat relieving irritating dry cough.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Relikof® linctus is indicated for relief of all types of non productive (dry) coughs, specially-`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Environment induced dry cough",
          "Cold induced dry cough",
          "Irritating dry cough",
          "Allergic dry cough",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Child (1 month-12 Years): Relikof® Kidz Linctus 5-10 ml (1-2 teaspoon), 3-4 times daily.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `There are no known side effects from using this medicine. However, if you notice any side effects, stop use and consult a doctor or pharmacist.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Contraindicated in patients having hypersensitivity to any of the ingredients of Citric Acid Monohydrate .`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Consult a doctor if cough symptoms persist for more than 5 days.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `There are no enough data from the use of Citric Acid Monohydrate in pregnant women. There is insufficient information on the excretion of Citric Acid Monohydrate metabolites in Human milk.  If necessary, it can used with the consultation of physician.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `No clinically significant interactions have found.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Overdose with this preparation is unlikely to occur due to the low concentrations of the ingredients.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰C Temp.) & dry place, protect from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Relikof® Kidz Linctus: Each bottle contains 100 ml linctus with a measuring cup.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 61,
    title: "Sefcon 500 Capsule",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: sefcon500fr,
    imge: sefcon500bk,
    img: [
      {
        id: 61,
        imgf: sefcon500fr,
        imge: sefcon500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Sefcon 500",
    innerComposition: "Cefradine BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Sefcon® 500 Capsule: Each Capsule contains Cefradine BP 500 mg.",
          "Sefcon® DS Powder for Suspension: After reconstitution each 5 ml suspension contains Cefradine BP 250 mg",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Sefcon® (Cefradine) is a cephalosporin antibiotic with broad spectrum bactericidal activity against both gram-positive and gram-negative bacteria. Cefradine interferes with the synthesis of bacterial cell wall by inhibiting transpeptidase enzyme, as a result the bacterial cell wall is destroyed.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Sefcon® (Cefradine) is used in the treatment of infections caused by sensitive organisms.
        Upper respiratory tract infections: Pharyngitis, sinusitis, otitis media, tonsillitis. Lower respiratory tract infections: Acute and chronic bronchitis, Bronchopneumonia.
        Urinary tract infections: Cystitis, urethritis, pyelonephritis.
        Skin and soft tissue infections: Abscess, cellulitis, furunculosis, impetigo. Gastrointestinal tract infections: Bacillary dysentery, enteritis, peritonitis. Bone and joint infections.
        Surgical prophylaxis: It is also used in perioperative prophylactic administration. In cesarean post-operative infections, intra-operative and post-operative use may reduce the incidence of certain post-operative infections.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The dosage may be given without regard to meals.
        Adults: Oral: 250-500 mg 4 times a day, alternatively 0.5-1 g twice daily. Increased if necessary up to 1 g 4 times a day, Increased dose may be used in severe infections.
        Children: Oral: The usual total dose is 25 to 50 mg/kg/day daily in 2-4 divided doses.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE IN RENAL IMPAIRMENT",
        innerData: `In patient with impaired renal function, doses and frequency of administration of Cefradine must be modified according to the degree of impairment, severity of infection, susceptibility of the causative organism and serum concentration of the drug. For adults, a loading dose of 750 mg should be given subsequently followed by 500 mg with the mentioned time interval.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It should not be used in patients hypersensitive to any cephalosporin antibiotic.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefradine should be used with caution in those patients who have known hypersensitivity to penicillins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Side effects include nausea, vomiting, Diarrhoea and abdominal discomfort. Allergic reactions including skin rashes, Urticaria, eosinophilia, angioedema and anaphylaxis may occur and elevation of hepatic enzyme values have been noted. Neutropenia has been reported. Super-infection with resistant microorganisms, particularly candida, may follow the treatment. There is also a possibility of development of pseudo membranous colitis. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Although there have been no reports of adverse effect on the fetus, safety or use during pregnancy has not been definitely established. Cephalosporins are distributed into breast milk and the drug should be used with caution in nursing women.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Loop diuretics may increase nephro toxicity of cephalosporins. Probenecid has been seen to raise serum concentrations of Cefradine, by reducing renal clearance of the cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSE",
        innerData: `The symptoms of cefradine overdose are non-specific and are generally nausea, vomiting, diarrhoea and gastric upsets. Gastric lavage will be necessary if a large amount has been ingested. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Sefcon® 500 Capsule: Each box containing 3 x 7's Capsules in Alu-Alu Blister pack.",
          "Sefcon® DS Powder for Suspension: Each bottle containing dry powder to reconstitute 100 ml suspension with measuring cup for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 62,
    title: "Sefcon DS 100ml Syrup",
    therapeutic_class: "antibiotic",
    text1: " ",
    text2: " ",
    imgf: sefconds100fr,
        imge: sefconds100bk,
    img: [
      {
        id: 62,
        imgf: sefconds100fr,
        imge: sefconds100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Sefcon",
    innerComposition: "Cefradine BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Sefcon® 500 Capsule: Each Capsule contains Cefradine BP 500 mg.",
          "Sefcon® DS Powder for Suspension: After reconstitution each 5 ml suspension contains Cefradine BP 250 mg",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Sefcon® (Cefradine) is a cephalosporin antibiotic with broad spectrum bactericidal activity against both gram-positive and gram-negative bacteria. Cefradine interferes with the synthesis of bacterial cell wall by inhibiting transpeptidase enzyme, as a result the bacterial cell wall is destroyed.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Sefcon® (Cefradine) is used in the treatment of infections caused by sensitive organisms.
        Upper respiratory tract infections: Pharyngitis, sinusitis, otitis media, tonsillitis. Lower respiratory tract infections: Acute and chronic bronchitis, Bronchopneumonia.
        Urinary tract infections: Cystitis, urethritis, pyelonephritis.
        Skin and soft tissue infections: Abscess, cellulitis, furunculosis, impetigo. Gastrointestinal tract infections: Bacillary dysentery, enteritis, peritonitis. Bone and joint infections.
        Surgical prophylaxis: It is also used in perioperative prophylactic administration. In cesarean post-operative infections, intra-operative and post-operative use may reduce the incidence of certain post-operative infections.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The dosage may be given without regard to meals.
        Adults: Oral: 250-500 mg 4 times a day, alternatively 0.5-1 g twice daily. Increased if necessary up to 1 g 4 times a day, Increased dose may be used in severe infections.
        Children: Oral: The usual total dose is 25 to 50 mg/kg/day daily in 2-4 divided doses.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE IN RENAL IMPAIRMENT",
        innerData: `In patient with impaired renal function, doses and frequency of administration of Cefradine must be modified according to the degree of impairment, severity of infection, susceptibility of the causative organism and serum concentration of the drug. For adults, a loading dose of 750 mg should be given subsequently followed by 500 mg with the mentioned time interval.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It should not be used in patients hypersensitive to any cephalosporin antibiotic.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefradine should be used with caution in those patients who have known hypersensitivity to penicillins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Side effects include nausea, vomiting, Diarrhoea and abdominal discomfort. Allergic reactions including skin rashes, Urticaria, eosinophilia, angioedema and anaphylaxis may occur and elevation of hepatic enzyme values have been noted. Neutropenia has been reported. Super-infection with resistant microorganisms, particularly candida, may follow the treatment. There is also a possibility of development of pseudo membranous colitis. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Although there have been no reports of adverse effect on the fetus, safety or use during pregnancy has not been definitely established. Cephalosporins are distributed into breast milk and the drug should be used with caution in nursing women.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Loop diuretics may increase nephro toxicity of cephalosporins. Probenecid has been seen to raise serum concentrations of Cefradine, by reducing renal clearance of the cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVER DOSE",
        innerData: `The symptoms of cefradine overdose are non-specific and are generally nausea, vomiting, diarrhoea and gastric upsets. Gastric lavage will be necessary if a large amount has been ingested. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Sefcon® 500 Capsule: Each box containing 3 x 7's Capsules in Alu-Alu Blister pack.",
          "Sefcon® DS Powder for Suspension: Each bottle containing dry powder to reconstitute 100 ml suspension with measuring cup for measurement.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Syrup",
  },

  {
    id: 63,
    title: "Unirab 20 Capsule",
    therapeutic_class: "anti-ulcerant",

    text1: " ",
    text2: " ",
    imgf: unirab20fr,
        imge: unirab20bk,
    img: [
      {
        id: 63,
        imgf: unirab20fr,
        imge: unirab20bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Unirab",
    innerComposition: "Rabeprazole Sodium INN 20 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Unirab® Capsule: Each Capsule contains Rabeprazole Sodium INN 20 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Rabeprazole suppresses gastric acid secretion by inhibiting the gastric H+/K+ ATPase at the secretory surface of the gastric parietal cell. Because this enzyme is regarded as the acid (proton) pump within the parietal cell, Rabeprazole has been characterized as a gastric proton-pump inhibitor.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Healing of Benign Gastric Ulcer; Healing of Erosive or Ulcerative Gastroesophageal Reflux Disease (GERD); Maintenance of healing of Erosive or Ulcerative GERD; Treatment of symptomatic GERD; Healing of Duodenal Ulcers; Helicobacter pylori eradication to reduce the risk of Duodenal Ulcer recurrence; Treatment of pathological hypersecretory conditions, including Zollinger-Ellison Syndrome.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Unirab® capsule can be taken with or without food.
        Healing of Benign Gastric Ulcer: The recommended adult oral dose is one Unirab® capsule to be taken once daily in the morning for 8 weeks.
        Healing of Erosive or Ulcerative GERD: The recommended adult oral dose is one Unirab® Capsule to be taken once daily for four to eight weeks. For those patients who have not healed after 8 weeks of treatment, an additional 8 week course of Rabonac Tablet may be considered.
        Maintenance of healing of Erosive or Ulcerative GERD: The recommended adult oral dose is one Unirab® Capsule to be taken once daily.
        Treatment of symptomatic GERD: The recommended adult oral dose is one Unirab Capsule to be taken once daily for 4 weeks. If symptoms do not resolve completely after 4 weeks, an additional course of treatment may be considered.
        Healing of Duodenal Ulcers: The recommended adult oral dose is one Unirab® Capsule to be taken once daily after the morning meal for a period up to 4 weeks. Most patients with duodenal ulcer heal within 4 weeks. A few patients may require additional therapy to achieve healing.
        Helicobacter pylori eradication to reduce the risk of Duodenal Ulcer recurrence: Triple therapy regimen: Unirab® 20 mg, Amoxicillin 1000 mg, Clarithromycin 500 mg; each drug should be taken twice daily with the morning and evening meals for 7 days.
        Treatment of pathological hypersecretory conditions, including Zollinger-Ellison Syndrome: The recommended adult oral starting dose is 60 mg once a day. Doses should be adjusted to individual patient needs and should continue for as long as clinically indicated. Some patients may require 2 divided doses (maximum 120 mg daily). Some patients with Zollinger-Ellison syndrome have been treated continuously with Unirab® Capsule for up to one year.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Rabeprazole Capsule are generally well tolerated. The observed undesirable effects have been generally mild/moderate and transient in nature. The most common adverse events are headache, diarrhea and nausea. The less common adverse effects are abdominal pain, asthenia, flatulence, rash, dry mouth etc. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `Rabeprazole is contraindicated in patients with known hypersensitivity to Rabeprazole or to any component of the formulation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTION",
        innerData: `Administration of Rabeprazole to patients with mild to moderate liver impairment results in increased exposure and decreased elimination. Caution should be exercised in patients with severe hepatic impairment.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Rabeprazole like other PPIs is metabolized through Cytochrome P450 drug metabolizing enzyme system. But Rabeprazole does not have clinically significant interaction with other drugs metabolized by CYP P450 system, such as warfarin, theophylline, diazepam and phenytoin. Rabeprazole inhibits gastric acid secretion and may interfere with absorption of drugs where gastric pH is an important determinant of bioavailability e.g. ketoconazole, iron salts and digoxin. In studies no interaction with liquid antacid or foods was observed.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN SPECIAL GROUP",
        innerData: `Pregnancy: Pregnancy category B. There are no adequate and well-controlled studies in pregnant women. This drug should be used during pregnancy only if clearly needed.
        Nursing Mother: Since many drugs are excreted in milk, and becasue of the potential for adverse reactions to nursing infants from Rabeprazole, a decision should be made to discontinue nursing or discontinue the drug, taking into account the importance of the drug to the mother.
        Pediatric Use: The safety and effectiveness of Rabeprazole for the treatment of GERD patients <12 years of age have not been established. The safety and effectiveness of Rabeprazole for other uses have not been established in pediatric patients.
        Geriatric Use: No overall differences in safety or effectiveness were observed between these subjects and younger subjects, but greater sensitivity of some older individuals cannot be ruled out.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "Commercial Pack",
        innerData: `Unirab® Capsule: Each box contains 6x10 tablets in Alu-Alu blister strip.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Capsule",
  },

  {
    id: 64,
    title: "Optivas 10",
    therapeutic_class: "cardiovascular",

    text1: " ",
    text2: " ",
    imgf: optivas10fr,
    imge: optivas10bk,
    img: [
      {
        id: 64,
        imgf: optivas10fr,
        imge: optivas10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Optivas",
    innerComposition: "Atorvastatin INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Optivas® 10 : Each film coated tablet contains Atorvastatin Calcium Trihydrate INN equivalent to Atorvastatin 10 mg.",
          "Optivas® 20 : Each film coated tablet contains Atorvastatin Calcium Trihydrate INN equivalent to Atorvastatin 20 mg",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Optivas® (Atorvastatin) is a synthetic lipid-lowering agent. Atorvastatin is a selective, competitive inhibitor of HMG-CoA reductase, the rate-limiting enzyme that converts 3-hydroxy 3 methylglutarylcoenzyme A to mevalonate, a precursor of cholesterol. As mevalonate is produced, it is then converted into cholesterol. Moreover, It activates lipoproteinlipase which breaks down triglyceride by hydrolysis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Atorvastatin is indicated as an adjunct to diet for reduction of elevated total cholesterol, LDL-cholesterol, apolipoprotein B, and triglycerides in patients with-`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Primary hypercholesterolemia (heterozygous familial and non-familial) hypercholesterolemia and mixed dyslipidemia (Fredrickson types IIa and IIb).",
          " Elevated serum Triglyceride (TG) levels (Fredrickson type IV).",
          "Primary dysbetalipoproteinemia (Fredrickson type III) who do not respond adequately to diet.",
          "Homozygous familial hypercholesterolemia as an adjunct to other lipid-lowering treatments (e.g., LDL apheresis).",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Patients should be placed on a standard cholesterol-lowering diet before receiving Atorvastatin and should continue on this diet during treatment. The usual starting dose for all the indications is 10 mg once daily. The doses range is 10 to 80 mg once daily. Doses should be individualized according to baseline LDL-C levels, the goal of therapy, and patient response. Adjustment of dosage should be made at intervals of 4 weeks or more. Doses may be given at any time of day with or without food.
        Children: Treatment experience in a paediatric population with dose of Atorvastatin up to 80 mg/day is limited.
        Geriatric (>70 Years) Use: The safety and efficacy of Atorvastatin in this population is as similar as < 70 years of age patients with the dose up to 80 mg/day.
        
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Atorvastatin is contraindicated in patients with hypersensitivity to any component of this medication, active liver disease or unexplained persistent elevations of serum transaminases.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Atorvastatin is generally well tolerated. Adverse reactions have usually been mild and transient. Reversible myositis is rare but significant side effect of the statins. The statins also cause headache, altered liver function tests and gastro-intestinal effects including abdominal pain, flatulence, diarrhoea, nausea and vomiting.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Liver effects : Liver function tests should be performed before the initiation of treatment and periodically thereafter. Should an increase in ALT or AST of greater than 3 times the upper limit of normal persist, reduction of dose or withdrawal of Atorvastatin is recommended. Atorvastatin should be used with caution in patients who consume substantial quantities of alcohol and/or have a history of liver disease.
        Skeletal muscle effects: Uncomplicated myalgia has been reported in Atorvastatin- treated patients. Atorvastatin therapy should be discontinued if markedly elevated CPK levels occur or myopathy is diagnosed or suspected.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOAGE",
        innerData: `There is no specific treatment for overdose, in the event of an Overdose, the patients should be treated symptomatically and general supportive measures instituted as required. Due to excessive drug binding to plasma proteins, haemodialysis is not expected to significantly enhance atorvastatin clearance. Liver function test and Serum CPK levels should be monitored. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },

      {
        innerHead: "PREGNANCY AND LACTATION",
        innerData: `Atorvastatin is contraindicated in pregnancy. Women of childbearing potential should use adequate contraceptive measures. Atorvastatin should be administered to women of child bearing age only when such patients are highly unlikely to conceive and have been informed of the potential hazards to the fetus. Atorvastatin is contraindicated while breast feeding. It is not known whether this drug is excreted in human milk. Because of the potential for adverse reactions in nursing infants, women taking atorvastatin should not breast-feed.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `The risk of myopathy during treatment with other drugs in this class is increased with concurrent administration of cyclosporin, fibric acid derivatives, erythromycin, azole antifungals, or niacin (nicotinic acid). These risks may also occur when combining these drugs with Atorvastatin. Caution should also be exercised when Atorvastatin is administered with inhibitors of P450 3A4 (macrolide antibiotics and azole antifungals). Patients should be closely monitored if Atorvastatin is added to digoxin, erythromycin, oral contraceptives, colestipol, antacid and warfarin.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERICAL PACKING",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Optivas® 10: Each box contains 3×10's tablet in blister pack.",
          "Optivas® 10: Each box contains 3×10's tablet in blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 65,
    title: "Panagra 100",
    therapeutic_class: "pde",
    text1: " ",
    text2: " ",
    imgf: panagra100fr,
    imge: panagra100bk,
    img: [
      {
        id: 65,
        imgf: panagra100fr,
        imge: panagra100bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Panagra",
    innerComposition: "Sildenafil USP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Panagra®-50 Tablet: Each film coated tablet contains- Sildenafil Citrate USP eqvt. to Sildenafil 50 mg.",
          "Panagra®-50 Tablet: Each film coated tablet contains- Sildenafil Citrate USP eqvt. to Sildenafil 50 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Sildenafil is an inhibitor of phosphodiesterase type 5 (PDE5). The sexual stimulation causes the natural production of nitric oxide which releases required quantity of cGMP. PDE5 is present in the corpus cavernosum smooth muscle, vascular & visceral smooth muscle, kidney, lungs & pancreas. Sildenafil has no effect on penile blood flow in the absence of sexual stimulation. Sildenafil has no effect on penile blood flow in the absence of sexual stimulation. The effect of PDE5 inhibition on cGMP concentration in the corpus cavernosum and pulmonary arteries is also observed in the smooth muscle of the prostate, the bladder and their vascular supply. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Sildenafil is used for the treatment of men with erectile dysfunction and pulmonary arterial hypertension (PAH).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Erectile Dysfunction: The recommended dose for most patients is 50 mg taken, as needed, approximately 30 -40 minutes before intercourse. However, Sildenafil may be taken anywhere from 4 hours to 0.5 hour before sexual activity. Based on effectiveness and toleration, the dose may be increased to a maximum recommended dose of 100 mg or decreased to 25 mg. It should not be used more than once daily. The following factors are associated with increased plasma levels of Sildenafil: age >65, hepatic impairment, severe renal impairment, and concomitant use of potent cytochrome P450 3A4 inhibitors (ketoconazole, itraconazole, erythromycin, saquinavir). Since higher plasma levels may increase both the efficacy and incidence of adverse events, a starting dose of 25 mg should be considered in these patients. When Sildenafil is co-administered with a-blocker, patients should be stable on a-blocker therapy prior to initiating Sildenafil treatment and Sildenafil should be initiated at the lowest dose. 
        Pulmonary arterial hypertension: The recommended dose of Sildenafil Citrate is 20 mg three times a day and should be taken approximately 4-6 hours apart, with or without food.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Like all medicines, Sildenafil can cause side-effects although not everybody gets them. The side-effects reported in association with the use of Sildenafil are usually mild to moderate and of a short duration. Body as a whole: allergic reaction, face edema, photosensitivity reaction, shock, asthenia, pain, chills, abdominal pain, chest pain. Musculoskeletal: arthritis, myalgia, tendon rupture, tenosynovitis, bone pain, myasthenia, synovitis. Nervous: ataxia, hypertonia, neuralgia, neuropathy, paresthesia, tremor, vertigo, depression, insomnia, somnolence, abnormal dreams, hypesthesia. Respiratory: asthma, dyspnea, laryngitis, pharyngitis, sinusitis, bronchitis. Cardiovascular: angina pectoris, AV block migraine, syncope, tachycardia, palpitation, hypotension, postural hypotension, myocardial ischemia, cerebral thrombosis, cardiac arrest, heart failure, abnormal electrocardiogram and cardiomyopathy. Digestive: vomiting, glossitis, colitis, dysphagia, gastritis, gastroenteritis, esophagitis, stomatitis, dry mouth, liver function tests abnormal, rectal hemorrhage, gingivitis. Hemic and Lymphatic: anemia and leukopenia. Metabolic and Nutritional: thirst, edema, gout, unstable diabetes, hyperglycemia, peripheral edema, hyperuricemia, hypoglycemic reaction, hypernatremia. Skin and Appendages: urticaria, pruritus, sweating, skin ulcer, exfoliative dermatitis. Special Senses: sudden decrease or loss of hearing, mydriasis, conjunctivitis, photophobia, tinnitus, eye pain, ear pain, eye hemorrhage, cataract, dry eyes. Urogenital: cystitis, nocturia, urinary frequency, urinary incontinence, abnormal ejaculation, genital edema and anorgasmia. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Sildenafil has shown to potentiate the hypotensive effects of nitrates and its administration to patients who are using organic nitrates, either regularly and or intermittently, in any form is therefore contraindicated. Sildenafil is also contraindicated in patients with a hypersensivity to any component of the tablet`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `General: The evaluation of erectile dysfunction should include a determination of potential underlying causes and the identification of appropriate treatment following a complete medical assessment. Before prescribing Slidenafil, it is important to note the following: Caution is advised when Phosphodiesterase Type 5 (PDE5) inhibitors are co-administered with alpha-blockers. PDE5 inhibitors, including Sildenafil, and a-adrenergic blocking agents are both vasodilators with blood pressure lowering effects. When vasodilators are used in combination, an additive effect on blood pressure may be anticipated. In some patients, concomitant use of these two drug classes can lower blood pressure significantly leading to symptomatic hypotension (e.g. dizziness, fainting lightheadedness). Regard should be given: Patients should be stable on a-blocker therapy prior to initiating a PDE5 inhibitor. Patients who demonstrate hemodynamic instability on a-blocker therapy alone are at increased risk of symptomatic hypotension with concomitant use of PDE5 inhibitors. In those patients who are stable on a-blocker therapy, PDE5 inhibitors should be initiated at the lowest dose. In those patients already taking an optimized dose of a PDE5 inhibitor, a-blocker therapy should be initiated at the lowest dose. Stepwise increase in a-blocker dose may be associated with further lowering of blood pressure when taking a PDE5 inhibitor. Safety of combined use of PDE5 inhibitors and a-blockers may be affected by other variables, including intravascular volume depletion and other anti-hypertensive drugs. Sildenafil has systemic vasodilatory properties and may augment the blood pressure lowering effect of other anti-hypertensive medications. The safety of Sildenafil is unknown in patients with bleeding disorders and patients with active peptic ulceration. Sildenafil should be used with caution in patients with anatomical deformation of the penis (such as angulation, cavernosal fibrosis or Peyronie's disease), or in patients who have conditions which may predispose them to priapism (such as sickle cell anemia, multiple myeloma, or leukemia). The safety and efficacy of combinations of Sildenafil with other treatments for erectile dysfunction have not been studied. Therefore, the use of such combinations is not recommended. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "WARNINGS",
        innerData: `There is a cardiac risk of sexual activity in patients with preexisting cardiovascular disease. Therefore, treatments for erectile dysfunction with Sildenafil should not be generally used in men for whom sexual activity is inadvisable because of their underlying cardiovascular status. Sildenafil has systemic vasodilatory properties that resulted in transient decreases in supine blood pressure in healthy volunteers (mean maximum decrease of 8.4/5.5 mmHg). While this normally would be expected to be of little consequence in most patients, prior to prescribing Sildenafil, physicians should carefully consider whether their patients with underlying cardiovascular disease could be affected adversely by such vasodilatory effects, especially in combination with sexual activity. Patients with the following underlying conditions can be particularly sensitive to the actions of vasodilators including Sildenafil- those with left ventricular outflow obstruction (e.g. aortic stenosis, idiopathic hypertrophic subaortic stenosis) and those with severely impaired autonomic control of blood pressure. There is no controlled clinical data on the safety or efficacy of Sildenafil in the following groups; if prescribed, this should be done with caution. Patients who have suffered a myocardial infarction, stroke, or life-threatening arrhythmia within the last 6 months; Patients with resting hypotension (BP <90/50) or hypertension (BP >170/110): Patients with cardiac failure or coronary artery disease causing unstable angina; Patients with retinitis pigmentosa (a minority of these patients have genetic disorders of retinal phosphodiesterases); Patients with sickle cell or related anemias.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTTONS",
        innerData: `Sildenafil metabolism is principally mediated by the cytochrome P450 (CYP) isoforms 3A4 (major route) and 2C9 (minor route). Therefore, inhibitors of these isoenzymes 15 may reduce Sildenafil clearance and inducers of these isoenzymes may increase Sildenafil clearance. Cimetidine (800 mg), a nonspecific CYP inhibitor, caused a 56% increase in plasma Sildenafil concentrations when coadministered with Sildenafil (50 mg). When a single 100 mg dose of Sildenafil was administered with erythromycin, a specific CYP3A4 inhibitor, at steady state (500 mg bid for 5 days), there was a 182% increase in Sildenafil systemic exposure (AUC). Co-administration of the HIV protease inhibitor saquinavir, also a CYP3A4 inhibitor, at steady state (1200 mg tid) with Sildenafil (100 mg single dose) resulted in a 140% increase in Sildenafil Cmax and a 210% increase in Sildenafil AUC. Stronger CYP3A4 inhibitors such as ketoconazole or itraconazole would be expected to have still greater effects, and population data from patients in clinical trials did indicate a reduction in Sildenafil clearance when it was coadministered with CYP3A4 inhibitors (such as ketoconazole, erythromycin, or cimetidine). In another study co-administration with the HIV protease inhibitor ritonavir, a highly potent P450 inhibitor, at steady state (500 mg bid) with Sildenafil (100 mg single dose) resulted in a 300% (4-fold) increase in Sildenafil Cmax and a 1000% (11-fold) increase in Sildenafil plasma AUC. At 24 hours, the plasma levels of Sildenafil were approximately 200 ng/ml, compared to approximately 5 ng/ml when Sildenafil was dosed alone. Although the interaction between other protease inhibitors and Sildenafil has not been studied, their concomitant use is expected to increase Sildenafil levels.  Concomitant administration of strong CYP3A4 inducers, such as rifampin, is expected to cause greater decreases in plasma levels of Sildenafil. The AUC of the active metabolite, N-desmethyl Sildenafil, was increased 62% by loop and potassium-sparing diuretics and 102% by 16 nonspecific beta-blockers. These effects on the metabolite are not expected to be of clinical consequence. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData: `Sildenafil is not indicated for use in women. 
        Geriatric Use: Healthy elderly volunteers (65 years or over) had a reduced clearance of Sildenafil. Since higher plasma levels may increase both the efficacy and incidence of adverse events, a starting dose of 25 mg should be considered. 
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData: `In studies with healthy volunteers of single doses up to 800 mg, adverse events were similar to those seen at lower doses but incidence rates and severities were increased. In cases of overdose, standard supportive measures should be adopted as required. Renal dialysis is not expected to accelerate clearance as Sildenafil is highly bound to plasma proteins and it is not eliminated in the urine. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protected from light. Keep out of reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Panagra® 50 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
          "Panagra® 50 Tablet: Each box contains- 1 blister strip of 4 film-coated tablets.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 66,
    title: "Peacepil",
    therapeutic_class: "antidepressant",

    text1: " ",
    text2: " ",
    imgf: peacepil3fr,
    imge: peacepil3bk,
    img: [
      {
        id: 66,
        imgf: peacepil3fr,
        imge: peacepil3bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Peacepil",
    innerComposition: "Bromazepam BP 3 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Kafu® 100 ml Syrup: Each 5 ml syrup contains Ketotifen Fumarate BP equivalent to Ketotifen 1 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Kafu® is a preparation of Ketotifen which has anti-histaminic and anti-anaphylactic activity. It has been used similarly to sodium chromoglycate in the prophylactic treatment of asthma. Ketotifen is a non-bronchodilator anti-asthmatic drug with marked anti-histaminic effects. Ketotifen exerts a powerful and sustained H1-receptor blocking activities which can be clearly dissociated from its anti-anaphylactic properties.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATIONS",
        innerData: "",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Prophylactic treatment of bronchial asthma.",
          "Allergic rhinitis and Conjunctivitis.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData:
          "Adults: 1 mg twice daily with food. If necessary the dose may be increased up to 2 mg twice daily in severe case.Child above 3 years of age: 1 mg twice daily with food or as directed by the physician.Elderly: Same as adult dose or as advised by physician.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "Drowsiness, dry mouth, slight dizziness may occur at the beginning of treatment but usually disappear spontaneously after a few days. CNS stimulation and weight gain has also been reported. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData:
          "The treatment with existing anti-asthmatic treatment should be continued for at least 2 weeks after initiation of Ketotifen treatment to avoid the risk of exacerbation of asthma. If inter current infection occurs, treatment must be supplemented by specific anti-infectious therapy. On the first few days of treatment with Ketotifen, the patient’s reactions may be impaired. Care should be taken when driving a vehicle or operating machinery. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "OVERDOSE",
        innerData:
          "Symptoms of overdose include drowsiness to severe sedation, confusion, dyspnea, hypotension, tachycardia, hyperexcitability and convulsions. Other symptoms include nausea, vomiting, diarrhea and blurred vision.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData:
          "Kafu® may be potentiate the effects of CNS depressants, anti-histamines and alcohol.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "It should not be used in pregnancy and lactation, although there is no evidence of any teratogenic effects. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },

      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30 ⁰ C. Temp.), dry place and protected from light. Keep out of reach from children. ",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: "",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Kafu® 100 ml Syrup: Each 5 ml syrup contains Ketotifen Fumarate BP equivalent to Ketotifen 1 mg.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 67,
    title: "Picocef 250",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: picocef250fr,
    imge: picocef250bk,
    img: [
      {
        id: 67,
        imgf: picocef250fr,
        imge: picocef250bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Picocef",
    innerComposition: "Cefuroxime",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Each film coated tablet contains Cefuroxime Axetil USP equivalent to Cefuroxime 250 mg.",
          "Picocef® 500 Tablet: Each film coated tablet contains Cefuroxime Axetil BP equivalent to Cefuroxime 500 mg.",
          "Picocef® PFS: After reconstitution Each 5 ml suspension contains Cefuroxime Axetil USP equivalent to Cefuroxime 125 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefuroxime is 2nd generation cephalosporin which active against a wide range of gram-positive & gram-negative bacteria. Cefuroxime works by binding with beta-lactam ring of bacteria & inhibit bacterial cell wall. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Upper and lower respiratory tract infections, such as acute and chronic bronchitis, pneumonia, sinusitis, otitis media & tonsillitis",
          "Skin & soft tissue infections such as peritonitis.",
          "Urinary tract infections.",
          "Gonorrhoea.",
          "Septicemia.",
          "Meningitis.",
          "Prophylaxis.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adults (>13 years)
        • Pharyngitis/Tonsillitis 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        • Acute bacterial chronic bronchitis 250 or 500 mg bid 10 days.
        • Secondary bacterial infections of acute bronchitis 250-500 mg bid 5-10 days.
        • Uncomplicated skin and skin structure infections 250-500 mg bid 10 days.
        • Uncomplicated urinary tract infections 125-250 mg bid 7-10 days.
        • Uncomplicated gonorrhoea 1000 mg Single dose.
        Children who can swallow tablets
        • Pharyngitis/Tonsillitis 125 mg bid 10 days.
        • Acute otitis media 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        Pediatric patients (3 months to 12 years)
        • Pharyngitis/Tonsillitis 10 mg/kg/day bid 10 days
        • Acute otitis media 15 mg/kg/day bid 10 days
        • Acute bacterial maxillary sinusitis 15 mg/kg/day bid 10 days
        • Impetigo 15 mg/kg/day bid 10 days
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTIONS FOR RECONSTITUTION",
        innerData: `For Suspension: To prepare 70 ml Suspension, at first shake the bottle well to loosen the powder. Then add 40 ml boiled and cooled water with the help of the supplied measuring cup to the powder and shake well. For better reconstitution add the water divided amount.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Patients with known allergy to Cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Generally Cefuroxime is well tolerated. However, a few side effects like nausea, vomiting, diarrhea, abdominal discomfort or pain may occur. Rarely (<0.2%) renal dysfunction, anaphylaxis, angioedema, pruritus, rash and serum sickness like urticaria may appear.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefuroxime should be given with care to patients receiving concurrent treatment with potent diuretics & who have history of colitis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnant women: USFDA pregnancy category B. While all antibiotics should be avoided in the first trimester. If possible, Cefuroxime has been safely used in later pregnancy to treat urinary and other infections`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Concomitant administration of probenecid with Cefuroxime increases the area under the serum concentration versus time curve by 50%. Drug that reduces gastric acidity may result in a lower bioavailability of Cefuroxime and tend to cancel the effect of postprandial absorption.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Overdosage of Cefuroxime tablet can cause cerebral irritation leading to convulsions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, keep away from sunlight. All medicines keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® PFS: After reconstitution, each bottle contains 70 ml suspension and a dropper with measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 68,
    title: "Picocef 500",
    therapeutic_class: "antibiotic",

    text1: " ",
    imgf: picocef500fr,
    imge: picocef500bk,
    text2: " ",
    img: [
      {
        id: 68,
        imgf: picocef500fr,
        imge: picocef500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Picocef 500",
    innerComposition: "Cefuroxime",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Each film coated tablet contains Cefuroxime Axetil USP equivalent to Cefuroxime 250 mg.",
          "Picocef® 500 Tablet: Each film coated tablet contains Cefuroxime Axetil BP equivalent to Cefuroxime 500 mg.",
          "Picocef® PFS: After reconstitution Each 5 ml suspension contains Cefuroxime Axetil USP equivalent to Cefuroxime 125 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefuroxime is 2nd generation cephalosporin which active against a wide range of gram-positive & gram-negative bacteria. Cefuroxime works by binding with beta-lactam ring of bacteria & inhibit bacterial cell wall. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Upper and lower respiratory tract infections, such as acute and chronic bronchitis, pneumonia, sinusitis, otitis media & tonsillitis",
          "Skin & soft tissue infections such as peritonitis.",
          "Urinary tract infections.",
          "Gonorrhoea.",
          "Septicemia.",
          "Meningitis.",
          "Prophylaxis.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adults (>13 years)
        • Pharyngitis/Tonsillitis 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        • Acute bacterial chronic bronchitis 250 or 500 mg bid 10 days.
        • Secondary bacterial infections of acute bronchitis 250-500 mg bid 5-10 days.
        • Uncomplicated skin and skin structure infections 250-500 mg bid 10 days.
        • Uncomplicated urinary tract infections 125-250 mg bid 7-10 days.
        • Uncomplicated gonorrhoea 1000 mg Single dose.
        Children who can swallow tablets
        • Pharyngitis/Tonsillitis 125 mg bid 10 days.
        • Acute otitis media 250 mg bid 10 days.
        • Acute bacterial maxillary sinusitis 250 mg bid 10 days.
        Pediatric patients (3 months to 12 years)
        • Pharyngitis/Tonsillitis 10 mg/kg/day bid 10 days
        • Acute otitis media 15 mg/kg/day bid 10 days
        • Acute bacterial maxillary sinusitis 15 mg/kg/day bid 10 days
        • Impetigo 15 mg/kg/day bid 10 days
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTIONS FOR RECONSTITUTION",
        innerData: `For Suspension: To prepare 70 ml Suspension, at first shake the bottle well to loosen the powder. Then add 40 ml boiled and cooled water with the help of the supplied measuring cup to the powder and shake well. For better reconstitution add the water divided amount.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Patients with known allergy to Cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Generally Cefuroxime is well tolerated. However, a few side effects like nausea, vomiting, diarrhea, abdominal discomfort or pain may occur. Rarely (<0.2%) renal dysfunction, anaphylaxis, angioedema, pruritus, rash and serum sickness like urticaria may appear.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Cefuroxime should be given with care to patients receiving concurrent treatment with potent diuretics & who have history of colitis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnant women: USFDA pregnancy category B. While all antibiotics should be avoided in the first trimester. If possible, Cefuroxime has been safely used in later pregnancy to treat urinary and other infections`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Concomitant administration of probenecid with Cefuroxime increases the area under the serum concentration versus time curve by 50%. Drug that reduces gastric acidity may result in a lower bioavailability of Cefuroxime and tend to cancel the effect of postprandial absorption.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Overdosage of Cefuroxime tablet can cause cerebral irritation leading to convulsions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, keep away from sunlight. All medicines keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® 250 Tablet: Box containing 2 x 7’s tablets in Alu-Alu blister pack.",
          "Picocef® PFS: After reconstitution, each bottle contains 70 ml suspension and a dropper with measuring cup.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 69,
    title: "Plavas Plus",
    therapeutic_class: "cardiovascular",

    text1: " ",
    text2: " ",
    imgf: plavasplusfr,
        imge: plavasplusbk,
    img: [
      {
        id: 69,
        imgf: plavasplusfr,
        imge: plavasplusbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Plavas® Plus",
    innerComposition: "Clopidogrel + Aspirin",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData:
          "Plavas® Plus Tablet: Each film coated tablet contains Clopidogrel Bisulphate INN 97.854 mg eqvt. to 75 mg Clopidogrel & Aspirin BP 75 mg.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData:
          "Plavas Plus is a fixed dose combination containing Clopidogrel and Aspirin. Clopidogrel is an inhibitor of platelet aggregation. Clopidogrel selectively inhibits the binding of adenosine diphosphate (ADP) to its platelet receptor and the subsequent ADP mediated activation of the glycoprotein GPIIb/IIIa complex, thereby inhibiting platelet aggregation. Aspirin is an antiplatelet agent. It acts by causing irreversible inhibition of the cyclo-oxygenase enzyme.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
    ],
    innerdata1: [
      {
        innerHead: "MECHANISM OF ACTION",
        innerData:
          "Clopidogrel is a thienopyridine derivative that interferes with the platelet activation cascade. It blocks the adenosine diphosphate (ADP) receptor selectively and irreversibly & thus inhibiting the activation of the GPIIb/IIIA complex, the major receptor fibrinogen present in the platelet surface. Clopidogrel may antagonize the ADP induced inhibition of the atenylate cyclase possibly resulting in an elevated platelet cyclic adenosine monophosphate level after stimulation by an appropriate agonist. Aspirin is also an antiplatelet agent. It acts by causing irreversible inhibition of the cyclo-oxygenase enzyme, which leads to decreased formation of the thromboxaneA2. Since platelet does not synthesize new enzyme, the action of aspirin on platelet cyclo-oxygenase is permanent, lasting for the life of the platelet (7-10days)",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "INDICATION",
        innerData: "Plavas Plus is indicated for the patients-",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "With a history of recent myocardial infarction (MI) and stroke",
          "Established peripheral arterial diseases",
          "It is also indicated for patients with acute coronary syndrome e.g., unstable angina/non–Q-wave MI, including patients who are to be managed medically and those who are to be managed with per-cutaneous coronary intervention.",
        ],
      },
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData:
          "Recent MI, recent stroke or established peripheral arterial diseases: The recommended daily dose of this combined preparation is one tablet daily. Acute coronary syndrome: In Acute coronary syndrome (unstable angina/nonQ-wave MI), the dose should be initiated with 4 tablets as loading dose and then continued at one tablet daily.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData:
          "Hypersensitivity to any of the components or NSAIDs. Active pathological bleeding such as peptic ulcer or intracranial hemorrhage or bleeding disorders like hemophilia. Recent history of gastrointestinal bleeding.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },

      {
        innerHead: "SIDE-EFFECTS",
        innerData:
          "The combination is generally well-tolerated. Side-effects that have been reported include- abdominal pain, nausea, vomiting, neuralgia, paranesthesia, rash, pruritus etc.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },

      {
        innerHead: "DRUG INTERACTION",
        innerData: "This combination may enhance the effect of anticoagulants.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData:
          "The combination drug should be avoided during pregnancy. It is not recommended for use during breast feeding because of the possible risk of developing Reve's syndrome.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "USE IN PEDIATRIC PATIENTS",
        innerData:
          "Kafu® may be potentiate the effects of CNS depressants, anti-histamines and alcohol.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },

      {
        innerHead: "STORAGE",
        innerData:
          "Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.",
        istable: false,
        table: {},
        islist: false,
        listData: [],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: "",
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Plavas® Plus Tablet: Each box contains 30 tablets, in blister strips.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 70,
    title: "Polimet 500",
    therapeutic_class: "antibiotic",

    text1: " ",
    imgf: polimet500fr,
        imge: polimet500bk,
    text2: " ",
    img: [
      {
        id: 70,
        imgf: polimet500fr,
        imge: polimet500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Polimet",
    innerComposition: "Metformin Hydrochloride BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Polimet® 500 : Each tablet contains Metformin Hydrochloride BP 500 mg.",
          "Polimet® 850 : Each tablet contains Metformin Hydrochloride BP 850 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Metformin Hydrochloride is a biguanide type oral anti-hyperglycemic drug used in the management of type II diabetes. Mechanism of action of metformin is different from those of sulfonylureas and it does not produce hypoglycemia. Metformin decreases hepatic glucose production, decreases intestinal absorption of glucose and improves insulin sensitivity by an increase in peripheral glucose uptake and utilization.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Polimet tablet is used in the management of type II diabetes when diet has failed and especially if ",
          "Polimet as monotherapy, is indicated as an adjunct to diet and exercise to improve glycemic control in patients with type II diabetes.",
          "Non-alcoholic fatty liver syndrome. ",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Initial dose is 500 mg twice a day or 850 mg once daily along with breakfast.",
          "Later on dose could be increased up to 3 tablets daily on divided dose.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 71,
    title: "Polimet 850",
    therapeutic_class: "antibiotic",

    text1: " ",
    imgf: polimet850fr,
        imge: polimet850bk,
    text2: " ",
    img: [
      {
        id: 71,
        imgf: polimet850fr,
        imge: polimet850bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Polimet 850",
    innerComposition: "Metformin Hydrochloride BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Polimet® 500 : Each tablet contains Metformin Hydrochloride BP 500 mg.",
          "Polimet® 850 : Each tablet contains Metformin Hydrochloride BP 850 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Metformin Hydrochloride is a biguanide type oral anti-hyperglycemic drug used in the management of type II diabetes. Mechanism of action of metformin is different from those of sulfonylureas and it does not produce hypoglycemia. Metformin decreases hepatic glucose production, decreases intestinal absorption of glucose and improves insulin sensitivity by an increase in peripheral glucose uptake and utilization.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Polimet tablet is used in the management of type II diabetes when diet has failed and especially if ",
          "Polimet as monotherapy, is indicated as an adjunct to diet and exercise to improve glycemic control in patients with type II diabetes.",
          "Non-alcoholic fatty liver syndrome. ",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Initial dose is 500 mg twice a day or 850 mg once daily along with breakfast.",
          "Later on dose could be increased up to 3 tablets daily on divided dose.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 72,
    title: "Paramax 20",
    therapeutic_class: "anti-ulcerant",

    text1: " ",
    text2: " ",
    imgf: paramax20fr,
        imge: paramax20bk,
    img: [
      {
        id: 72,
        imgf: paramax20fr,
        imge: paramax20bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "",
    innerComposition: "",
    innerdata: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 73,
    title: "Paramax 40",
    therapeutic_class: "anti-ulcerant",

    text1: " ",
    text2: " ",
    imgf: paramax40fr,
    imge: paramax40bk,
    img: [
      {
        id: 73,
        imgf: paramax40fr,
        imge: paramax40bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "",
    innerComposition: "",
    innerdata: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 74,
    title: "Radibac 500",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: radibac500fr,
    imge: radibac500bk,
    img: [
      {
        id: 74,
        imgf: radibac500fr,
        imge: radibac500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Radibac",
    innerComposition: "Levofloxacin",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Rabibac® 500 Tablet: Each film coated tablet contains Levofloxacin Hemihydrate INN 500 mg as Levofloxacin.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `It is a synthetic, broad-spectrum, third generation fluoroquinolone derivative antibacterial agent for oral administration. Chemically Levofloxacin is a chiral fluorinated carboxyquinolone.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `It is indicated for the treatment of adults with mild, moderate and severe infections caused by susceptible strains of the designated micro-organisms in the condition listed below:`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acute maxillary sinusitis due to Streptococcus pneumoniae, Haemophilus influenzae or  Moraxella catarrhalis.",
          "Acute bacterial exacerbation of chronic bronchitis due to Staphylococcus aureus, Streptococcus pneumoniae, Haemophilus influenzae or Moraxella catarrhalis.",
          "Community-acquired pneumonia due to Staphylococcus aureus, Streptococcus pneumoniae, Haemophilus influenzae, Klebsiella pneumoniae, Moraxella cararrhalis, Chlamydiapneumoniae, Legionella pneumophila or Mycoplasmapneumoniae.",
          "Acute pyelonephritis caused by Escherichia coli.",
          "Uncomplicated & complicated skin and soft tissue infections including abscesses, cellulitis, furuncles, impetigo, pyoderma, wound infections, due to Staphylococcus aureus, Streptococcus pyogenes, Proteus mirabilis or Enterococcus faecalis.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Acute sinusitis 500 mg once daily for 10-14 days",
          "Exacerbation of chronic bronchitis 250-500 mg daily for 7 days",
          "Community-acquired pneumonia 500 mg once or twice daily for 7-14 days",
          "Complicated urinary tract infections and acute pyelonephritis, 250-500 mg daily for 7-10 days.",
          "Uncomplicated skin and soft-tissue infections, 500 mg once daily for 7-10 days.",
          "Complicated skin and soft-tissue infections, 750 mg once daily for 7-14 days.",
        ],
      },
      {
        innerHead: "CONTRAINDICATION AND PRECAUTION",
        innerData: `It is contraindicated in patients with a history of hypersensitivity to Levofloxacin, quinolone antimicrobial agents or any other components of this product. The following measures should be taken during administration of Levofloxacin:`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "While taking Levofloxacin, adequate amount of water should be taken to avoid concentrated form of urine.",
          "Dose adjustment should be exercised during Levofloxacin ingestion in presence of renal insufficiency.",
        ],
      },
      {
        innerHead: "SIDE EFFECT",
        innerData: `It is generally well tolerated. However, a few side effects can usually be seen, side effects include: nausea, vomiting, diarrhea, abdominal pain, flatulence and rare occurrence of phototoxicity (0.1%). side effects that may be seen very rarely include tremors, depression, anxiety, confusion etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Antacids, Iron and Adsorbents-reduce absorption of Levofloxacin.",
          "NSAID- may increase the risk of CNS stimulation.",
          "Warfarin- may increase the risk of bleeding",
        ],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `It is not recommended for use during pregnancy or nursing, as the effects on the unborn child or nursing infant are unknown.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Radibac®500 tablet: Box contains 2 x 10's tablets in blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 75,
    title: "Roclav 250",
    therapeutic_class: "antibiotic",

    text1: " ",
    imgf: roclav250fr,
    imge: roclav250bk,
    text2: " ",
    img: [
      {
        id: 75,
        imgf: roclav250fr,
        imge: roclav250bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Roclav",
    innerComposition: "Cefuroxime BP and Clavulanic Acid BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Roclav® 250: Each film coated tablet contains Cefuroxime 250 mg as Cefuroxime Axetil BP and Clavulanic Acid 62.5 mg as diluted Potassium Clavulanate BP. ",
          "Roclav® 500: Each film coated tablet contains Cefuroxime 500 mg as Cefuroxime Axetil BP and Clavulanic Acid 125 mg as diluted Potassium Clavulanate BP. ",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefuroxime is one of the bactericidal second generation cephalosporin antibiotics, which is active against a wide range of Gram-positive and Gram-negative susceptible organisms including many beta-lactamase producing strains. It is indicated for the treatment of infections caused by sensitive bacteria. Clavulanic acid has a similar structure to the beta-lactam antibiotics but binds irreversibly to the beta-lactamase enzymes. The presence of clavulanic acid in Roclav formulations protects Cefuroxime from degradation by beta-lactamase enzymes and effectively extends the antibacterial spectrum of Cefuroxime to include many bacteria normally resistant to Cefuroxime and other cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pharyngitis/tonsillitis caused by Streptococcus pyogenes.",
          "Acute bacterial otitis media caused by Streptococcus pneumoniae, Haemophilus influenzae (including beta lactamase-producing strains), Moraxella Catarrhalis (including beta-lactamase-producing strains) or Streptococcus pyogenes Acute bacterial maxillary sinusitis caused by Streptococcus pneumoniae or Haemophilus influenzae (non-beta-lactamase-producing strains only).",
          "Lower respiratory tract infections including pneumoniae, caused by Streptococcus pneumoniae, Haemophilus influenzae (including beta lactamase-producing strains), Klebsiella spp., Staphylococcus aureus (penicillinase- and non-penicillinase-producing strains), Streptococcus pyogenes, Escherichia coli.",
          "Acute bacterial exacerbations of chronic bronchitis and secondary bacterial infections of acute bronchitis caused by Streptococcus penumoniae, Haemophilus influenzae (beta-lactamase negative strains) or Haemophilusparainfluenzae (beta-lactamase negative strains).",
          "Skin and Skin-Structure Infections caused by Staphylococcus aureus (penicillinase- and non-penicillinase-producing strains), Streptococcus pyogenes, Escherichia coli, Klebsiella spp. and Enterobacter spp.",
          "Urinary tract infections caused by Escherichia coli or Klebsiella pneumoniae Bone and Joint Infections caused by Staphylococcus aureus (penicillinase and non-penicillinase producing strains).",
          "Gonorrhea: Uncomplicated and disseminated gonococcal infections due to Neisseria gonorrhoeae (penicillinase- and non-penicillinase-producing strains) in both males and females.",
          "Early Lyme disease (erythema migrans) caused by Borrelia burgdorferi Septicemia caused by Staphylococcus aureus (penicillinase and non-penicillinase producing strains), Streptococcus pneumoniae, Escherichia coli, Haemophilus influenzae (including ampicillin-resistant strains), and Klebsiella spp.",
          "Meningitis caused by Streptococcus pneumoniae, Haemophilus influenzae (including ampicillin resistant strains), Neisseria meningitidis and Staphylococcus aureus (penicillinase and non-penicillinase producing strains)",
          "Switch therapy (injectable to oral) after surgery when patient’s condition is improved.",
        ],
      },

      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adolescents & adults:
        Pharyngitis or Tonsillitis: 250 mg twice daily 5-10 days
        Acute bacterial maxillary sinusitis: 250 mg twice daily 10 days
        Acute bacterial exacerbation of chronic bronchitis: 250-500 mg twice daily 10 days
        Secondary bacterial infections of acute bronchitis: 250-500 mg twice daily 5-10 days
        Community acquired pneumonia: 250-500 mg twice daily 5-10 days
        Uncomplicated skin & skin-structure infections: 250-500 mg twice daily 10 days
        MDR Typhoid fever: 500 mg twice daily 10-14 days
        Uncomplicated urinary tract infection: 250 mg twice daily 7-10 days
        Uncomplicated gonorrhea: 1000 mg single dose
        Lyme disease: 500 mg twice daily 20 days
        Paediatric patients (3 months to 12 years)
        Pharyngitis or Tonsillitis: 20 mg/kg/day in two divided doses 5-10 days
        Acute otitis media: 30 mg/kg/day in two divided doses 10 days
        Acute bacterial maxillary sinusitis: 30 mg/kg/day in two divided doses 10 days
        Community acquired pneumonia: 30 mg/kg/day in two divided doses 5-10 days
        MDR Typhoid fever: 30 mg/kg/day in two divided doses 10-14 days
        Uncomplicated skin & skin-structure infections: 30 mg/kg/day in two divided doses 10 days
        Uncomplicated urinary tract infection: 20 mg/kg/day in two divided doses 7-10 days
        Roclav may be administered without regard to meals.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTION FOR RECONSTITUTION OF SUSPENSION",
        innerData: `Shake the bottle well to loosen the powder. Add 60 ml of boiled and cooled water to the dry powder of the bottle. For ease of preparation, add water to the bottle in two proportions. Shake the bottle well after each addition until all the powder is in suspension. 
        Note: The reconstituted suspension must be stored at 2-8°C temperature and should be used within 7 days after reconstitution. Shake the suspension well before each use. Keep the bottle tightly closed.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Generally Cefuroxime and Clavulanic acid are well tolerated. However, a few side effects like nausea, vomiting, diarrhea, abdominal discomfort or pain may occur. As with other broad-spectrum antibiotics, prolonged administration of Cefuroxime and Clavulanic acid combination may result in overgrowth of non susceptible microorganisms. Rarely (<0.2%) renal dysfunction, anaphylaxis, angioedema, pruritis, rash and serum sickness like urticaria may appear.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Roclav should be given with care to patients receiving concurrent treatment with potent diuretics & who have history of colitis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Patients with known allergy to cephalosporins & pseudomembranous colitis are contraindicated.
        During pregnancy: While all antibiotics should be avoided in the first trimester if possible. However, Roclav® can be safely used in later pregnancy to treat urinary and other infections.
        During lactation: Roclav® is excreted into the breast milk in small quantities. However, the possibility of sensitizing the infant should be kept in mind.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Concomitant administration of probenecid with Roclav increases the area under the serum concentration versus time curve by 50%. Drug that reduces gastric acidity may result in a lower bioavailability of Cefuroxime and tend to cancel the effect of postprandial absorption.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Signs and symptoms: Over dosage of Roclav® can cause cerebral irritation leading to convulsions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTION FOR PREPARATION OF SUSPENSION",
        innerData: `Shake the bottle well before mixing the water. To prepare 70 ml suspension, add 40 ml (with the help of 10 ml cup) boiled & cooled water in two portions. Shake well after each addition till powder is completely mixed with water.
        The reconstituted suspension must be kept in 20C-80C temperature in a refrigerator & consumed within 7 days after reconstitution.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Roclav® tablet should be kept in a cool (15–30°C) and dry place and protected from light.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Roclav® 250 : Each box contains 2 pouches and each pouch contains 7 tablets in alu-alu blister strip.",
          "Roclav® 250 : Each box contains 2 pouches and each pouch contains 7 tablets in alu-alu blister strip.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 76,
    title: "Roclav 500",
    therapeutic_class: "antibiotic",

    text1: " ",
    text2: " ",
    imgf: roclav500fr,
        imge: roclav500bk,
    img: [
      {
        id: 76,
        imgf: roclav500fr,
        imge: roclav500bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Roclav 500",
    innerComposition: "Cefuroxime BP and Clavulanic Acid BP",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Roclav® 250: Each film coated tablet contains Cefuroxime 250 mg as Cefuroxime Axetil BP and Clavulanic Acid 62.5 mg as diluted Potassium Clavulanate BP. ",
          "Roclav® 500: Each film coated tablet contains Cefuroxime 500 mg as Cefuroxime Axetil BP and Clavulanic Acid 125 mg as diluted Potassium Clavulanate BP. ",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Cefuroxime is one of the bactericidal second generation cephalosporin antibiotics, which is active against a wide range of Gram-positive and Gram-negative susceptible organisms including many beta-lactamase producing strains. It is indicated for the treatment of infections caused by sensitive bacteria. Clavulanic acid has a similar structure to the beta-lactam antibiotics but binds irreversibly to the beta-lactamase enzymes. The presence of clavulanic acid in Roclav formulations protects Cefuroxime from degradation by beta-lactamase enzymes and effectively extends the antibacterial spectrum of Cefuroxime to include many bacteria normally resistant to Cefuroxime and other cephalosporins.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pharyngitis/tonsillitis caused by Streptococcus pyogenes.",
          "Acute bacterial otitis media caused by Streptococcus pneumoniae, Haemophilus influenzae (including beta lactamase-producing strains), Moraxella Catarrhalis (including beta-lactamase-producing strains) or Streptococcus pyogenes Acute bacterial maxillary sinusitis caused by Streptococcus pneumoniae or Haemophilus influenzae (non-beta-lactamase-producing strains only).",
          "Lower respiratory tract infections including pneumoniae, caused by Streptococcus pneumoniae, Haemophilus influenzae (including beta lactamase-producing strains), Klebsiella spp., Staphylococcus aureus (penicillinase- and non-penicillinase-producing strains), Streptococcus pyogenes, Escherichia coli.",
          "Acute bacterial exacerbations of chronic bronchitis and secondary bacterial infections of acute bronchitis caused by Streptococcus penumoniae, Haemophilus influenzae (beta-lactamase negative strains) or Haemophilusparainfluenzae (beta-lactamase negative strains).",
          "Skin and Skin-Structure Infections caused by Staphylococcus aureus (penicillinase- and non-penicillinase-producing strains), Streptococcus pyogenes, Escherichia coli, Klebsiella spp. and Enterobacter spp.",
          "Urinary tract infections caused by Escherichia coli or Klebsiella pneumoniae Bone and Joint Infections caused by Staphylococcus aureus (penicillinase and non-penicillinase producing strains).",
          "Gonorrhea: Uncomplicated and disseminated gonococcal infections due to Neisseria gonorrhoeae (penicillinase- and non-penicillinase-producing strains) in both males and females.",
          "Early Lyme disease (erythema migrans) caused by Borrelia burgdorferi Septicemia caused by Staphylococcus aureus (penicillinase and non-penicillinase producing strains), Streptococcus pneumoniae, Escherichia coli, Haemophilus influenzae (including ampicillin-resistant strains), and Klebsiella spp.",
          "Meningitis caused by Streptococcus pneumoniae, Haemophilus influenzae (including ampicillin resistant strains), Neisseria meningitidis and Staphylococcus aureus (penicillinase and non-penicillinase producing strains)",
          "Switch therapy (injectable to oral) after surgery when patient’s condition is improved.",
        ],
      },

      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adolescents & adults:
        Pharyngitis or Tonsillitis: 250 mg twice daily 5-10 days
        Acute bacterial maxillary sinusitis: 250 mg twice daily 10 days
        Acute bacterial exacerbation of chronic bronchitis: 250-500 mg twice daily 10 days
        Secondary bacterial infections of acute bronchitis: 250-500 mg twice daily 5-10 days
        Community acquired pneumonia: 250-500 mg twice daily 5-10 days
        Uncomplicated skin & skin-structure infections: 250-500 mg twice daily 10 days
        MDR Typhoid fever: 500 mg twice daily 10-14 days
        Uncomplicated urinary tract infection: 250 mg twice daily 7-10 days
        Uncomplicated gonorrhea: 1000 mg single dose
        Lyme disease: 500 mg twice daily 20 days
        Paediatric patients (3 months to 12 years)
        Pharyngitis or Tonsillitis: 20 mg/kg/day in two divided doses 5-10 days
        Acute otitis media: 30 mg/kg/day in two divided doses 10 days
        Acute bacterial maxillary sinusitis: 30 mg/kg/day in two divided doses 10 days
        Community acquired pneumonia: 30 mg/kg/day in two divided doses 5-10 days
        MDR Typhoid fever: 30 mg/kg/day in two divided doses 10-14 days
        Uncomplicated skin & skin-structure infections: 30 mg/kg/day in two divided doses 10 days
        Uncomplicated urinary tract infection: 20 mg/kg/day in two divided doses 7-10 days
        Roclav may be administered without regard to meals.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTION FOR RECONSTITUTION OF SUSPENSION",
        innerData: `Shake the bottle well to loosen the powder. Add 60 ml of boiled and cooled water to the dry powder of the bottle. For ease of preparation, add water to the bottle in two proportions. Shake the bottle well after each addition until all the powder is in suspension. 
        Note: The reconstituted suspension must be stored at 2-8°C temperature and should be used within 7 days after reconstitution. Shake the suspension well before each use. Keep the bottle tightly closed.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Generally Cefuroxime and Clavulanic acid are well tolerated. However, a few side effects like nausea, vomiting, diarrhea, abdominal discomfort or pain may occur. As with other broad-spectrum antibiotics, prolonged administration of Cefuroxime and Clavulanic acid combination may result in overgrowth of non susceptible microorganisms. Rarely (<0.2%) renal dysfunction, anaphylaxis, angioedema, pruritis, rash and serum sickness like urticaria may appear.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Roclav should be given with care to patients receiving concurrent treatment with potent diuretics & who have history of colitis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Patients with known allergy to cephalosporins & pseudomembranous colitis are contraindicated.
        During pregnancy: While all antibiotics should be avoided in the first trimester if possible. However, Roclav® can be safely used in later pregnancy to treat urinary and other infections.
        During lactation: Roclav® is excreted into the breast milk in small quantities. However, the possibility of sensitizing the infant should be kept in mind.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Concomitant administration of probenecid with Roclav increases the area under the serum concentration versus time curve by 50%. Drug that reduces gastric acidity may result in a lower bioavailability of Cefuroxime and tend to cancel the effect of postprandial absorption.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `Signs and symptoms: Over dosage of Roclav® can cause cerebral irritation leading to convulsions.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DIRECTION FOR PREPARATION OF SUSPENSION",
        innerData: `Shake the bottle well before mixing the water. To prepare 70 ml suspension, add 40 ml (with the help of 10 ml cup) boiled & cooled water in two portions. Shake well after each addition till powder is completely mixed with water.
        The reconstituted suspension must be kept in 20C-80C temperature in a refrigerator & consumed within 7 days after reconstitution.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Roclav® tablet should be kept in a cool (15–30°C) and dry place and protected from light.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Roclav® 250 : Each box contains 2 pouches and each pouch contains 7 tablets in alu-alu blister strip.",
          "Roclav® 250 : Each box contains 2 pouches and each pouch contains 7 tablets in alu-alu blister strip.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 77,
    title: "Rosucard 10",
    therapeutic_class: "cardiovascular",

    text1: " ",
    text2: " ",
    imgf: rosucard10fr,
    imge: rosucard10bk,
    img: [
      {
        id: 77,
        imgf: rosucard10fr,
        imge: rosucard10bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Rosucard",
    innerComposition: "Rosuvastatin INN 10 mg",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Rosucard® 10 tablet: Each film coated tablet contains Rosuvastatin Calcium INN 10.40 mg equiv. to Rosuvastatin 10 mg`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Rosuvastatin calcium is a synthetic lipid-lowering agent for oral administration. It is an inhibitor of 3-hydroxy-3-methyl-glutaryl-coenzyme A (HMG-CoA). This enzyme catalyzes the conversion of HMG-CoA to mevalonate, an early and rate limiting step in the synthesis of cholesterol.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Hyperlipidemia and Mixed Dyslipidemia, Hypertriglyceridemia, Homozygous Familial Hypercholesterolemia, Rosuvastatin is also indicated to: Reduce the risk of stroke, Reduce the risk of myocardial infarction, Reduce the risk of arterial revascularization procedures.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The recommended starting dose of Rosuvastatin is 5-10 mg once daily. The dose may be increased if necessary at intervals of at least 4 weeks to 20 mg once daily. The dose may be increased after further 4 weeks to 40 mg once daily only in severe hypercholesterolemia with high cardiovascular risk and under specialist supervision. Dose in elderly patients: Initially 5 mg once daily. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `If the patient becomes pregnant while taking this drug, the patient should be apprised of the potential hazard to the fetus and the lack of known clinical benefit with continued use during pregnancy.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Rosuvastatin is generally well tolerated. The most frequent adverse event thought to be related to rosuvastatin were myalgia, constipation, asthenia,abdominal pain and nausea.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `It is contraindicated in patient with active liver disease. Women who are pregnant or may become pregnant: Rosuvastatin may cause fetal harm when administered to pregnant women. Nursing mothers: Because another drug in this class passes into breast milk it is advised not to nurse their infants while taking this drug.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Gemfibrozil, Lopinavir/Ritonavir, Cyclosporine significantly increased Rosuvastatin exposure. Therefore, in patients taking cyclosporine, therapy should be limited to Rosuvastatin 5 mg once daily. Rosuvastatin significantly increased INR in patients receiving coumarin anticoagulants. In patients taking coumarin anticoagulants and Rosuvastatin concomitantly, INR should be determined before starting Rosuvastatin and frequently enough during early therapy to ensure that no significant alteration of INR occurs. The risk of skeletal muscle effects may be enhanced when Rosuvastatin is used in combination with niacin; a reduction in Rosuvastatin dosage should be considered in this setting Special Precautions for Use Rosuvastatin should be used with caution in pregnancy, lactation and children. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Rosucard® 10 tablet: Each box containing 3x10’s tablets in blister strips.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },
  {
    id: 78,
    title: "Rotagan 200",
    therapeutic_class: "anti-viral",

    text1: " ",
    text2: " ",
    imgf: rotagan200fr,
    imge: rotagan200bk,
    img: [
      {
        id: 78,
        imgf: rotagan200fr,
        imge: rotagan200bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Rotagan",
    innerComposition: "Favipiravir INN 200 mg",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: `Rotagan® Tablet: Each film coated tablet contains Favipiravir INN 200 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `The mechanism of action of  Rotagan® is novel compared to existing influenza antivirals that primarily prevent entry and exit of the virus from cells. The active favipiravir-RTP selectively inhibits RNA polymerase and prevents replication of the viral genome. There are several hypotheses as to how favipiravir-RTP interacts with RdRp. Some studies have shown that when favipiravir-RTP is incorporated into a nascent RNA strand, it prevents RNA strand elongation and viral proliferation. Studies have also found that the presence of purine analogs can reduce favipiravir’s antiviral activity. Although originally developed to target influenza, Favipiravir has been investigated for the treatment of life-threatening pathogens such as Ebola virus, Lassa virus etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `Rotagan® was approved to treat cases of influenza that were unresponsive to conventional treatment. Given its efficacy at targeting several strains of influenza, it has been investigated in other countries to treat novel viruses including Ebola.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `The usual dosage of Rotagan® for adults is 1600 mg orally twice daily for 1 day followed by 600 mg orally twice daily for 4 days. The total administration period should be 5 days.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Shock, anaphylaxis, Pneumonia, hepatic dysfunction, jaundice, Toxic epidermal necrolysis (TEN), Acute kidney injury, White blood cell count decreased, neutrophil count decreased, platelet count decreased, Neurological and psychiatric symptoms (consciousness disturbed, abnormal behavior, convulsion etc.), Colitis hemorrhagic, Rash, Nausea, Vomiting,  Abdominal pain etc.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Women known or suspected to be pregnant. Also to patients with a history of hypersensitivity to any ingredients of the drug.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `Ratagan® is a drug the use of which is considered only when there is an outbreak of novel or re-emerging influenza virus infections in which other anti-influenza virus agents are not effective or insufficiently effective. When administering the drug, obtain the latest information including government’s direction of countermeasures against such influenza viruses, and prescribe only to appropriate patients.
        Rotagan® is not effective against bacterial infections.
        Rotagan® has not been administered to children .
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Warfarin: The metabolism of (S)-Warfarin can be decreased when combined with Favipiravir.
        Acetyldigoxin: May decrease the excretion rate of Acetyldigoxin which could result in a higher serum level.
        Acyclovir: The excretion of Acyclovir can be decreased when combined with Favipiravir.
        Allopurinol: The excretion of Allopurinol can be decreased when combined with Favipiravir.
        Almotriptan: The metabolism of Almotriptan can be decreased when combined with Favipiravir.
        Use in specific populations: 
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY & LACTATION",
        innerData: `Rotagan® should be avoided in administration to women known or suspected to be pregnant. When administering Rotagan® to lactating women, instruct to stop lactating.
        Elderly:
        Since the elderly often have reduced physiological functions, Rotagan® should be administered with care to them by monitoring their general conditions.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (below 30 ⁰C temp.) and dry place, protected from light. Keep out of reach children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Rotagan® Tablet: Each box contains 2 blister strips of 10 tablets.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 79,
    title: "Tispa",
    therapeutic_class: "anti-spasmodic",

    text1: " ",
    text2: " ",
    imgf: tispafr,
    imge: tispabk,
    img: [
      {
        id: 79,
        imgf: tispafr,
        imge: tispabk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Tispa",
    innerComposition: "Tiemonium Methylsulfate INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: `Tispa® Tablet : Each film coated tablet contains Tiemonium Methylsulfate INN 50 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `It is an antispasmodic. Tiemonium is quaternary ammonium anti muscarinic agent with peripheral effect similar to those of atropine.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "MECHANISM OF ACTION",
        innerData: `Tiemonium strengthens calcium bonding with phospholipids & proteins thus stabilizing the cell membrane of the GI tract. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "INDICATIONS",
        innerData: `This drug is indicated for pain in gastrointestinal and biliary diseases, and in urology and gynaecology. It reduces muscle spasms of the intestine, biliary system, bladder & uterus. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DOSAGE AND METHOD OF ADMINISTRAITON",
        innerData: `In adults the usual dose is 2 to 6 tablets per day. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `This drug should not be used in glaucoma (acute pain of eyeball with vision disturbances) and in difficulty to urinate (disorders of prostate or bladder). `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `In order to avoid possible drug interactions, you must systematically inform your physician about any other drugs you are taking. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `As with any active substance this drug may cause certain undesirable or unpleasant effects. In some people dry mouth with difficulty in swallowing and thirst dilatation of pupils with loss of accommodation and sensitivity to light, increased intraocular pressure, flushing, dry skin, bradycardia followed by tachycardia, palpitations and arrhythmias, difficulty in micturition and constipation may occur. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PREGNANCY AND LACTATION",
        innerData: `Avoid taking this drug without medical advice during pregnancy or breast feeding. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Occasional retention of urine in excessive or overdoses. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (below 30 ⁰C), dry place and protect from light. Keep out of the reach of children. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK: ",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Tispa® Tablet : Box containing 50 tablets in blister pack.",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 80,
    title: "Unilor",
    therapeutic_class: "anti-histamine",

    text1: " ",
    text2: " ",
    imgf: unilorfr,
    imge: unilorbk,
    img: [
      {
        id: 80,
        imgf: unilorfr,
        imge: unilorbk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Unilor",
    innerComposition: "Desloratadine INN",
    innerdata: [
      {
        innerHead: "COMPOSITION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Unilor tablet: Each film coated tablet contains Desloratadine INN 5 mg.",
          "Unilor syrup: Each 5 ml contains Desloratadine INN 2.5mg",
        ],
      },
      {
        innerHead: "DESCRIPTION",
        innerData: `Desloratadine is a long-acting tricyclic histamine antagonist with selective H1-receptor antagonist activity. It is a non-sedating antihistamine. Desloratadine has effects on the chronic inflammatory response to allergens.    `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Allergic rhinitis: Desloratadine is indicated for the relief of nasal and non-nasal symptoms of allergic rhinitis (seasonal and perennial). 
        Chronic idiopathic urticaria: Desloratadine is indicated for the symptomatic relief of pruritus, reduction in the number of hives and size of hives, in patients with chronic idiopathic urticaria.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Unilor Syrup: Child 2-5 years of Age: 1/2 teaspoonful once daily
        Child 6-11 years of Age: 1 teaspoonful once daily
        Adults &> years of Age: 2 teaspoonful once daily
        Unilor Tablet: Adults and children 12 years of age and over: 1 Tablet daily.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy: There are no adequate and well-controlled studies in pregnant women.  Because animal reproduction studies are not always predictive of human response, Desloratadine should be used in pregnancy only if clearly needed.
        Lactation: Desloratadine passes into breast milk. Therefore, a decision should be made whether to discontinue nursing or to discontinue Desloratadine, taking into account the importance of the drug to the mother.
        SIDE EFFECTS
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Desloratadine is generally well tolerated. However, dry mouth, fatigue, somnolence and myalgia are commonly reported side-effects. Less common side-effects may include dizziness, headache and nausea. Rarely rash, pruritus and urticaria may occur.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONS",
        innerData: `Desloratadine is contraindicated in patients who are hypersensitive to this medication or to any of its ingredients or to Loratadine.     `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `Alcohol enhances the sedative effect of Desloratadine. Erythromycin, Ketoconazole, Cimetidine & Amprenavir may increase plasma concentration of Loratadine.  `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SPECIAL PRECAUTIONS FOR USE",
        innerData: `Antihistamine should be used with caution in prostatic hypertrophy, urinary retention, glaucoma, and pyloroduodenal obstruction. It should be used with caution in hepatic disease and dose reduction may be necessary in the renal impairment. Caution may be required in epilepsy and porphyria. Children and the elderly are more susceptible to side effects.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSAGE",
        innerData: `No clinically relevant adverse effects have been reported in case of over dosage. However, in the event of overdosage, symptomatic and supportive treatment is recommended.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Unilor tablet: Each box containing 50’s tablets in blister strips.",
          "Unilor syrup: Each bottle containing 60 ml.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 81,
    title: "Vildaglip 50",
    therapeutic_class: "anti-diabetic",

    text1: " ",
    text2: " ",
    imgf: vildaglip50fr,
        imge: vildaglip50bk,
    img: [
      {
        id: 81,
        imgf: vildaglip50fr,
        imge: vildaglip50bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Vildaglip",
    innerComposition: "Vildagliptin INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: `Vildaglip® tablet: Each film coated tablet contains Vildagliptin INN 50 mg.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Vildaglip® is a Dipeptidyl peptidase-4 (DPP-4) inhibitor, which is believed to exert its actions in patients with type 2 diabetes by slowing the inactivation of incretin hormones. Incretin hormones, including glucagon-like peptide-1 (GLP-1) and glucose-dependent insulinotropic polypeptide (GIP), are released by the intestine throughout the day and levels are increased in response to a meal. These hormones are rapidly inactivated by the enzyme, DPP-4. The incretins are part of an endogenous system involved in the physiologic regulation of glucose homeostasis. When blood glucose concentrations are normal or elevated, GLP-1 and GIP increase insulin synthesis and release from pancreatic beta cells by intracellular signaling pathways involving cyclic AMP. GLP-1 also lowers glucagon secretion from pancreatic alpha cells, leading to reduced hepatic glucose production. By increasing and prolonging active incretin levels, Vildaglip increases insulin release and decreases glucagon levels in the circulation in a glucose-dependent manner.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS",
        innerData: `Vildaglip® is indicated as an adjunct to diet and exercise to improve glycemic control in patients with type-2 diabetes mellitus.`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "As monotherapy",
          "In dual combination with Metformin, a Sulphonylurea, a Thiazolidinedione or Insulin when diet, exercise and a single antidiabetic agent do not result in adequate glycemic control.",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `The recommended dose of Vildaglip® is`,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "50 mg or 100 mg daily for monotherapy.",
          "50 mg twice daily (morning and evening) when used in dual combination with Metformin or a Thiazolidinedione.",
          "50 mg once daily in the morning when used in dual combination with a Sulphonylurea.Vildaglip® may be taken with or without a meal. No dosage adjustment is required in the elderly, or in patients with mild renal impairment.",
        ],
      },
      {
        innerHead: "SIDE-EFFECTS",
        innerData: `Nausea, hypoglycemia, tremor, headache and dizziness. Rare cases of hepato-toxicity have been reported.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `In pharmacokinetic studies, no interactions were seen with pioglitazone, metformin, glibenclamide, digoxin, warfarin, amlodipine, ramipril, valsartan or simvastatin. As with other oral antidiabetic medicinal products the glucose-lowering effect of Vildagliptin may be reduced by certain active substances, including thiazides, corticosteroids, thyroid products and sympathomimetics.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY AND LACTATION",
        innerData: `PREGNANCY: There are no adequate data on the use of Vildagliptin in pregnant women; hence the potential risk for human is unknown.
        NURSING MOTHERS: It is not known whether Vildagliptin is excreted in human milk. Due to lack of human data, Vildagliptin should not be used during lactation.
        PEDIATRIC USE: Vildagliptin is not recommended in patients 18 years of age.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In the event of an overdose, appropriate supportive treatment should be initiated as dictated by the patient's clinical status.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE:",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: `Vildaglip® tablet: Each box containing 2x10’s tablets in Alu-Alu blister strips.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 82,
    title: "Vildaglip M 850",
    therapeutic_class: "anti-diabetic",

    text1: " ",
    text2: " ",
    imgf: vildaglipm850fr,
        imge: vildaglipm850bk,
    img: [
      {
        id: 82,
        imgf: vildaglipm850fr,
        imge: vildaglipm850bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "Vildaglip® M",
    innerComposition: "Vildagliptin INN & Metformin HCl BP",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Vildaglip M: Each tablet contains Vildagliptin INN 50 mg & Metformin HCl BP 500 mg.",
          "Vildaglip M: Each tablet contains Vildagliptin INN 50 mg & Metformin HCl BP 500 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Vildagliptin is an oral anti-hyperglycemic agent of the new dipeptidyl peptidase-4 (DPP-4) inhibitor class of drugs which inhibits the inactivation of GLP-1 and GIP by DPP-4, allowing GLP-1 and GIP to potentiate the secretion of insulin in the beta cells and suppress glucagon release by the alpha cells of the islets of Langerhans in the pancreas. Metformin is an antihyperglycemic agent which improves glucose tolerance in patients with type 2 diabetes, lowering both basal and postprandial plasma glucose. Its pharmacologic mechanisms of action are different from other classes of oral antihyperglycemic agents. Metformin decreases hepatic glucose production, decreases intestinal absorption of glucose and improves insulin sensitivity by increasing peripheral glucose uptake and utilization. Unlike sulfonylureas, metformin does not produce hypoglycemia in either patients with type 2 diabetes or normal subjects and does not cause hyperinsulinemia. With metformin therapy, insulin secretion remains unchanged while fasting insulin levels and daylong plasma insulin response may actually decrease.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATION",
        innerData: `It is used in the treatment of type 2 diabetes mellitus patients which cannot be controlled by diet and exercise or who are already treated with the combination of vildagliptin and metformin as separate tablets.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE AND ADMINISTRATION",
        innerData: `Generally be given twice daily with meals, with gradual dose escalation, to reduce the gastrointestinal (GI) side effects due to metformin. The starting dose should be based on the patient's current regimen. The recommended starting dose in patients not currently treated with metformin is 50 mg vildagliptin/500 mg metformin HCL twice daily, with gradual dose escalation recommended to reduce gastrointestinal side effects associated with metformin. The starting dose in patients already treated with metformin should provide vildagliptin dosed as 50 mg twice daily (100 mg total daily dose) and the dose of metformin already being taken. For patients taking metformin 850 mg twice daily. `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATIONs",
        innerData: `Vildagliptin/Metformin HCL combination is contraindicated with known hypersensitivity to the active substances or to any of the components of the formulation.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `A few numbers of patient experiences hypoglycemia, tremor, headache, dizziness, fatigue, asthenia, weight gain, peripheral oedema, diarrhea etc. Very rare cases reported liver disease (hepatitis), Nasopharyngitis, upper respiratory tract infection and arthralgia.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `It should be used with caution in patients with impaired renal function, heart problem and impaired hepatic function`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTIONS",
        innerData: `As with other oral antidiabetic medicinal products the hypoglycaemic effect of vildagliptin may be reduced by certain active substances, including thiazides, corticosteroids, thyroid products and sympathomimetics. Cationic active substances that are eliminated by renal tubular secretion (e.g. cimetidine) may interact with metformin by competing for common renal tubular transport systems and hence delay the elimination of metformin, which may increase the risk of lactic acidosis.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USED IN PREGNANCY AND LACTATION",
        innerData: `Pregnancy: There are no adequate data from the use of vildagliptin in pregnant women. Studies in animals have shown reproductive toxicity at high doses. The potential risk for humans is unknown. Due to lack of human data, It should not be used during pregnancy.
        Breast-feeding: It is unknown wheather vildagliptin is excreted in human milk. Animal studies have shown excretion of vildagliptin in milk. It should not be used during lactation.
        Use in children:
        Vildagliptin & Metformin combination therapy is not recommended under 18 years of age.
        Use in Elderly: Patients (>65 years): Metformin excreted through kidneys, for this reason renal function test is necessary before this combination therapy. It is not recommended in patient over 75 years of age.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C. Temp.), dry place and protect from light. Keep all medicines out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Vildaglip M: Each box contains 2X10’s tablets in a blister pack. ",
          "Vildaglip M: Each box contains 2X10’s tablets in a blister pack. ",
        ],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 83,
    title: "X-Dol 60",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",
    imgf: xdol60fr,
    imge: xdol60bk,
    img: [
      {
        id: 83,
        imgf: xdol60fr,
        imge: xdol60bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "X-dol 60",
    innerComposition: "Etoricoxib INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60: Each film-coated tablet contains Etoricoxib INN 60 mg.",
          "X dol® 90: Each film-coated tablet contains Etoricoxib INN 90 mg.",
          "X dol® 120: Each film-coated tablet contains Etoricoxib INN 120 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Etoricoxib is a nonsteroidal anti-inflammatory drugs(NSAID) that exhibits anti-inflammatory, analgesic, and antipyretic activities in animal models. It is a potent, orally active, highly selective cyclooxygenase-2 (COX-2) inhibitor within and above the clinical dose range. COX-2 has been shown to be primarily responsible for the synthesis of prostanoid mediators of pain, inflammation, and fever. Selective inhibition of COX-2 by Etoricoxib decreases these clinical signs and symptoms with decreased GI toxicity and without effects on platelet function.  `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS:",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pain and inflammation in osteoarthritis, rheumatoid arthritis and other chronic musculoskeletal disorders",
          "Treatment of acute gout",
          "Treatment of acute gout",
          "Pain following dental surgery",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adult and adolescent over 16 years: `,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Adult and adolescent over 16 years: ",
          "Osteoarthritis: 30 mg once daily, increased if necessary to 60 mg once daily.",
          "Acute gut : 120 mg once daily for maximum 8 days. Maximum 60 mg daily in mild hepatic impairment. Maximum 60 mg on alteration days or 30 mg once daily in moderate hepatic impairment.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Side- effects may include dry mouth, taste disturbance, mouth ulcers, flatulence, constipation, appetite and weight changes, chest pain, fatigue, paraesthesia, influenza-like syndrome & myalgia.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `In patients with advanced renal disease treatment with it is not recommended. Clinical experience in patients with estimated creatinine clearance of <30 ml/min in very limited. If therapy with it must be initiated in such patients, close monitoring of the patients renal function is advisable. Caution should be used when initiating treatment with it in patients with considerable dehydration. It is advisable to rehydrate patients prior to starting therapy with it. The possibility of fluid retention, edema or hypertension should be taken into consideration when it is used in patients with a pre-exiting edema, hypertension, or heart failure. Independent of treatment, patients with a prior history of GI perforation, ulcer and bleeding(PUB) and patients greater than 65 years of age are known to be at a higher risk for a PUB. A patient with symptoms and /or signs suggesting liver dysfunction, or in whom an abnormal liver function test has occurred, should be evaluated for persistently abnormal liver function tests. If persistently abnormal liver function tests (three times the upper limit of normal) are detected, it should be discontinued. It should be used with caution in patients who have previously experienced acute asthmatic attacks, urticaria or rhinitis, which were precipitated by salicylates or non- selective cyclooxygenase inhibitors. It may mask fever, which is a sign of infection. The physician should be aware of this when using it in patients being treated for infection.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `It is contraindicated in patients with hypersensitivity to any component of this product, patients, with inflammatory bowel disease, severe congestive heart failure.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy : As with others drugs known to inhibit prostaglandin synthesis, use of it should be avoided in late pregnancy because it may cause premature closure of the ductus arteriosus. It should be used during the first two trimesters of pregnancy only if the potential benefit justifies the potential risk to the foetus.
        Lactation: It is known whether this drug is excreted in human milk.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Oral anticoagulants, diuretics and ACE inhibitors, Acetylsalicylic acid, Cyclosporin and Tacrolimus, Lithium, Methotrexate, oral contraceptives, Prednisone/Prednisolone, Digoxin, drugs metabolized by sulfotransferases (Ethinyl Estradiol), drugs metabolized by CYP isoenzymes, Ketoconazole, Rifampicin and Antacids have interaction with Etoricoxib.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In clinical studies, administration of single doses of etoricoxib up to 500 mg and multiple doses up to 150 mg/day for 21 days did not result in significant toxicity. There have been reports of acute overdosage with etoricoxib although adverse experiences were not reported in the majority of cases. The most frequently observed adverse experiences were consistent with the safety profile for etoricoxib (e.g. gastrointestinal events, cardiorenal events).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],
    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 84,
    title: "X-Dol 90",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",imgf: xdol90fr,
    imge: xdol90bk,
    img: [
      {
        id: 84,
        imgf: xdol90fr,
        imge: xdol90bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "X-dol 90",
    innerComposition: "Etoricoxib INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60: Each film-coated tablet contains Etoricoxib INN 60 mg.",
          "X dol® 90: Each film-coated tablet contains Etoricoxib INN 90 mg.",
          "X dol® 120: Each film-coated tablet contains Etoricoxib INN 120 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Etoricoxib is a nonsteroidal anti-inflammatory drugs(NSAID) that exhibits anti-inflammatory, analgesic, and antipyretic activities in animal models. It is a potent, orally active, highly selective cyclooxygenase-2 (COX-2) inhibitor within and above the clinical dose range. COX-2 has been shown to be primarily responsible for the synthesis of prostanoid mediators of pain, inflammation, and fever. Selective inhibition of COX-2 by Etoricoxib decreases these clinical signs and symptoms with decreased GI toxicity and without effects on platelet function.  `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS:",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pain and inflammation in osteoarthritis, rheumatoid arthritis and other chronic musculoskeletal disorders",
          "Treatment of acute gout",
          "Treatment of acute gout",
          "Pain following dental surgery",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adult and adolescent over 16 years: `,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Adult and adolescent over 16 years: ",
          "Osteoarthritis: 30 mg once daily, increased if necessary to 60 mg once daily.",
          "Acute gut : 120 mg once daily for maximum 8 days. Maximum 60 mg daily in mild hepatic impairment. Maximum 60 mg on alteration days or 30 mg once daily in moderate hepatic impairment.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Side- effects may include dry mouth, taste disturbance, mouth ulcers, flatulence, constipation, appetite and weight changes, chest pain, fatigue, paraesthesia, influenza-like syndrome & myalgia.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `In patients with advanced renal disease treatment with it is not recommended. Clinical experience in patients with estimated creatinine clearance of <30 ml/min in very limited. If therapy with it must be initiated in such patients, close monitoring of the patients renal function is advisable. Caution should be used when initiating treatment with it in patients with considerable dehydration. It is advisable to rehydrate patients prior to starting therapy with it. The possibility of fluid retention, edema or hypertension should be taken into consideration when it is used in patients with a pre-exiting edema, hypertension, or heart failure. Independent of treatment, patients with a prior history of GI perforation, ulcer and bleeding(PUB) and patients greater than 65 years of age are known to be at a higher risk for a PUB. A patient with symptoms and /or signs suggesting liver dysfunction, or in whom an abnormal liver function test has occurred, should be evaluated for persistently abnormal liver function tests. If persistently abnormal liver function tests (three times the upper limit of normal) are detected, it should be discontinued. It should be used with caution in patients who have previously experienced acute asthmatic attacks, urticaria or rhinitis, which were precipitated by salicylates or non- selective cyclooxygenase inhibitors. It may mask fever, which is a sign of infection. The physician should be aware of this when using it in patients being treated for infection.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `It is contraindicated in patients with hypersensitivity to any component of this product, patients, with inflammatory bowel disease, severe congestive heart failure.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy : As with others drugs known to inhibit prostaglandin synthesis, use of it should be avoided in late pregnancy because it may cause premature closure of the ductus arteriosus. It should be used during the first two trimesters of pregnancy only if the potential benefit justifies the potential risk to the foetus.
        Lactation: It is known whether this drug is excreted in human milk.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Oral anticoagulants, diuretics and ACE inhibitors, Acetylsalicylic acid, Cyclosporin and Tacrolimus, Lithium, Methotrexate, oral contraceptives, Prednisone/Prednisolone, Digoxin, drugs metabolized by sulfotransferases (Ethinyl Estradiol), drugs metabolized by CYP isoenzymes, Ketoconazole, Rifampicin and Antacids have interaction with Etoricoxib.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In clinical studies, administration of single doses of etoricoxib up to 500 mg and multiple doses up to 150 mg/day for 21 days did not result in significant toxicity. There have been reports of acute overdosage with etoricoxib although adverse experiences were not reported in the majority of cases. The most frequently observed adverse experiences were consistent with the safety profile for etoricoxib (e.g. gastrointestinal events, cardiorenal events).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],

    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },

  {
    id: 85,
    title: "X-Dol 120",
    therapeutic_class: "nsaids",

    text1: " ",
    text2: " ",
    imgf: xdol120fr,
        imge: xdol120bk,
    img: [
      {
        id: 85,
        imgf: xdol120fr,
        imge: xdol120bk,
      },
    ],
    backpagename: "By Therapeutic Class",
    backpagelink: "/by-therapeutic-class",

    innerMainHeading: "X-dol 120",
    innerComposition: "Etoricoxib INN",
    innerdata: [
      {
        innerHead: "PRESENTATION",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60: Each film-coated tablet contains Etoricoxib INN 60 mg.",
          "X dol® 90: Each film-coated tablet contains Etoricoxib INN 90 mg.",
          "X dol® 120: Each film-coated tablet contains Etoricoxib INN 120 mg.",
        ],
      },
      {
        innerHead: "PHARMACOLOGY",
        innerData: `Etoricoxib is a nonsteroidal anti-inflammatory drugs(NSAID) that exhibits anti-inflammatory, analgesic, and antipyretic activities in animal models. It is a potent, orally active, highly selective cyclooxygenase-2 (COX-2) inhibitor within and above the clinical dose range. COX-2 has been shown to be primarily responsible for the synthesis of prostanoid mediators of pain, inflammation, and fever. Selective inhibition of COX-2 by Etoricoxib decreases these clinical signs and symptoms with decreased GI toxicity and without effects on platelet function.  `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "INDICATIONS:",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Pain and inflammation in osteoarthritis, rheumatoid arthritis and other chronic musculoskeletal disorders",
          "Treatment of acute gout",
          "Treatment of acute gout",
          "Pain following dental surgery",
        ],
      },
    ],
    innerdata1: [
      {
        innerHead: "DOSAGE & ADMINISTRATION",
        innerData: `Adult and adolescent over 16 years: `,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "Adult and adolescent over 16 years: ",
          "Osteoarthritis: 30 mg once daily, increased if necessary to 60 mg once daily.",
          "Acute gut : 120 mg once daily for maximum 8 days. Maximum 60 mg daily in mild hepatic impairment. Maximum 60 mg on alteration days or 30 mg once daily in moderate hepatic impairment.",
        ],
      },
      {
        innerHead: "SIDE EFFECTS",
        innerData: `Side- effects may include dry mouth, taste disturbance, mouth ulcers, flatulence, constipation, appetite and weight changes, chest pain, fatigue, paraesthesia, influenza-like syndrome & myalgia.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "PRECAUTIONS",
        innerData: `In patients with advanced renal disease treatment with it is not recommended. Clinical experience in patients with estimated creatinine clearance of <30 ml/min in very limited. If therapy with it must be initiated in such patients, close monitoring of the patients renal function is advisable. Caution should be used when initiating treatment with it in patients with considerable dehydration. It is advisable to rehydrate patients prior to starting therapy with it. The possibility of fluid retention, edema or hypertension should be taken into consideration when it is used in patients with a pre-exiting edema, hypertension, or heart failure. Independent of treatment, patients with a prior history of GI perforation, ulcer and bleeding(PUB) and patients greater than 65 years of age are known to be at a higher risk for a PUB. A patient with symptoms and /or signs suggesting liver dysfunction, or in whom an abnormal liver function test has occurred, should be evaluated for persistently abnormal liver function tests. If persistently abnormal liver function tests (three times the upper limit of normal) are detected, it should be discontinued. It should be used with caution in patients who have previously experienced acute asthmatic attacks, urticaria or rhinitis, which were precipitated by salicylates or non- selective cyclooxygenase inhibitors. It may mask fever, which is a sign of infection. The physician should be aware of this when using it in patients being treated for infection.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "CONTRAINDICATION",
        innerData: `It is contraindicated in patients with hypersensitivity to any component of this product, patients, with inflammatory bowel disease, severe congestive heart failure.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "USE IN PREGNANCY & LACTATION",
        innerData: `Pregnancy : As with others drugs known to inhibit prostaglandin synthesis, use of it should be avoided in late pregnancy because it may cause premature closure of the ductus arteriosus. It should be used during the first two trimesters of pregnancy only if the potential benefit justifies the potential risk to the foetus.
        Lactation: It is known whether this drug is excreted in human milk.
        `,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "DRUG INTERACTION",
        innerData: `Oral anticoagulants, diuretics and ACE inhibitors, Acetylsalicylic acid, Cyclosporin and Tacrolimus, Lithium, Methotrexate, oral contraceptives, Prednisone/Prednisolone, Digoxin, drugs metabolized by sulfotransferases (Ethinyl Estradiol), drugs metabolized by CYP isoenzymes, Ketoconazole, Rifampicin and Antacids have interaction with Etoricoxib.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "OVERDOSE",
        innerData: `In clinical studies, administration of single doses of etoricoxib up to 500 mg and multiple doses up to 150 mg/day for 21 days did not result in significant toxicity. There have been reports of acute overdosage with etoricoxib although adverse experiences were not reported in the majority of cases. The most frequently observed adverse experiences were consistent with the safety profile for etoricoxib (e.g. gastrointestinal events, cardiorenal events).`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "STORAGE",
        innerData: `Store in a cool (Below 30⁰ C Temp.) and dry place, away from light. Keep out of the reach of children.`,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "COMMERCIAL PACK",
        innerData: ``,
        istable: false,
        table: {},
        islist: true,
        listData: [
          "X dol® 60 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
          "X dol® 90 Tablet: Each box contains 3X10’s Film Coated Tablet in blister pack.",
        ],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
      {
        innerHead: "",
        innerData: ``,
        istable: false,
        table: {},
        islist: false,
        listData: ["", ""],
      },
    ],

    btn: "Read More",
    btnlink: "/prod-details",
    type: "Tablet",
  },
];
